var Za = Object.defineProperty;
var Qa = (t, e, n) => e in t ? Za(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var dt = (t, e, n) => Qa(t, typeof e != "symbol" ? e + "" : e, n);
import Ri, { useState as ue, useRef as lr, useCallback as Mr, useEffect as xi, Component as tc, createElement as xo, createContext as ec } from "react";
class nc {
  constructor({ platform: e }) {
    dt(this, "clientType", "pf");
    dt(this, "country", "brasil");
    dt(this, "domain");
    dt(this, "environment", "vender");
    dt(this, "platform");
    dt(this, "server", "web");
    dt(this, "tmsVersion", "S33");
    this.domain = typeof window < "u" ? window.location.host : "", this.platform = e;
  }
}
class rc {
  constructor({ pageType: e, pageName: n, pageNameTier1: r, pageNameTier2: o }) {
    dt(this, "flowType", "fluxo-vender");
    dt(this, "pageName");
    dt(this, "pageNameTier1");
    dt(this, "pageNameTier2");
    dt(this, "pageType");
    dt(this, "url");
    dt(this, "trackingCode");
    const i = typeof window < "u" ? new URLSearchParams(window.location.search) : void 0;
    this.pageName = n, this.pageNameTier1 = r, this.pageNameTier2 = o, this.pageType = e, this.url = window == null ? void 0 : window.location.href, this.trackingCode = {}, this.trackingCode.idcmp = (i == null ? void 0 : i.get("idcmp")) || void 0, this.trackingCode.idcmpint = (i == null ? void 0 : i.get("idcmpint")) || void 0, this.trackingCode.icid = (i == null ? void 0 : i.get("icid")) || void 0, this.trackingCode.lkid = (i == null ? void 0 : i.get("lkid")) || void 0;
  }
}
class oc {
  constructor({ loginStatus: e, userID: n }) {
    dt(this, "loginStatus");
    dt(this, "userID");
    this.loginStatus = e, this.userID = n;
  }
}
class ic {
  constructor({ name: e, discount: n }) {
    dt(this, "name");
    dt(this, "discount");
    var i;
    const r = new URLSearchParams(window.location.search).get(
      "utm_campaign"
    ), o = (i = new URLSearchParams(window.location.search).get("utm_medium")) == null ? void 0 : i.replace(/\D+/g, "");
    this.name = r || e, this.discount = {}, this.discount.percentage = o || (n == null ? void 0 : n.percentage);
  }
}
class sc {
  constructor({ type: e }) {
    dt(this, "type");
    this.type = e;
  }
}
class ac {
  constructor(e, n) {
    Object.assign(this, {
      ...this,
      site: new nc({
        ...n == null ? void 0 : n.site,
        ...e == null ? void 0 : e.site
      }),
      page: new rc({
        ...n == null ? void 0 : n.page,
        ...e == null ? void 0 : e.page
      }),
      user: new oc({
        ...n == null ? void 0 : n.user,
        ...e == null ? void 0 : e.user,
        loginStatus: "1"
      }),
      coupon: new ic({
        ...n == null ? void 0 : n.coupon,
        ...e == null ? void 0 : e.coupon
      }),
      vehicle: new sc({
        ...n == null ? void 0 : n.vehicle,
        ...e == null ? void 0 : e.vehicle
      })
    });
  }
}
function Oi(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var dr = { exports: {} };
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
var Oo;
function cc() {
  return Oo || (Oo = 1, function(t, e) {
    (function(n) {
      var r;
      if (t.exports = n(), r = !0, !r) {
        var o = window.Cookies, i = window.Cookies = n();
        i.noConflict = function() {
          return window.Cookies = o, i;
        };
      }
    })(function() {
      function n() {
        for (var i = 0, s = {}; i < arguments.length; i++) {
          var a = arguments[i];
          for (var c in a)
            s[c] = a[c];
        }
        return s;
      }
      function r(i) {
        return i.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
      }
      function o(i) {
        function s() {
        }
        function a(u, f, l) {
          if (!(typeof document > "u")) {
            l = n({
              path: "/"
            }, s.defaults, l), typeof l.expires == "number" && (l.expires = new Date(/* @__PURE__ */ new Date() * 1 + l.expires * 864e5)), l.expires = l.expires ? l.expires.toUTCString() : "";
            try {
              var g = JSON.stringify(f);
              /^[\{\[]/.test(g) && (f = g);
            } catch {
            }
            f = i.write ? i.write(f, u) : encodeURIComponent(String(f)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), u = encodeURIComponent(String(u)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var O = "";
            for (var E in l)
              l[E] && (O += "; " + E, l[E] !== !0 && (O += "=" + l[E].split(";")[0]));
            return document.cookie = u + "=" + f + O;
          }
        }
        function c(u, f) {
          if (!(typeof document > "u")) {
            for (var l = {}, g = document.cookie ? document.cookie.split("; ") : [], O = 0; O < g.length; O++) {
              var E = g[O].split("="), A = E.slice(1).join("=");
              !f && A.charAt(0) === '"' && (A = A.slice(1, -1));
              try {
                var v = r(E[0]);
                if (A = (i.read || i)(A, v) || r(A), f)
                  try {
                    A = JSON.parse(A);
                  } catch {
                  }
                if (l[v] = A, u === v)
                  break;
              } catch {
              }
            }
            return u ? l[u] : l;
          }
        }
        return s.set = a, s.get = function(u) {
          return c(
            u,
            !1
            /* read as raw */
          );
        }, s.getJSON = function(u) {
          return c(
            u,
            !0
            /* read as json */
          );
        }, s.remove = function(u, f) {
          a(u, "", n(f, {
            expires: -1
          }));
        }, s.defaults = {}, s.withConverter = o, s;
      }
      return o(function() {
      });
    });
  }(dr)), dr.exports;
}
var uc = cc();
const Dr = /* @__PURE__ */ Oi(uc);
class lc {
  get(e) {
    return Dr.get(e);
  }
  set(e, n, r) {
    return Dr.set(e, n, { expires: r == null ? void 0 : r.expires });
  }
}
class dc {
  async post(e, n) {
    const r = await fetch(e, {
      method: "post",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(n)
    });
    if (!r.ok) {
      const o = await r.text();
      throw new Error(
        `HTTP error! Status: ${r.status}. Body: ${o}`
      );
    }
    return await r.json();
  }
}
class fc {
  constructor(e) {
    dt(this, "dataLayer");
    dt(this, "dispatchEvent", (e, n) => {
      window.objDataLayer = window.objDataLayer ? { ...window.objDataLayer, ...n } : n, document.dispatchEvent(new CustomEvent(e, { detail: n }));
    });
    this.dataLayer = e;
  }
  dispatchPageView(e) {
    this.dispatchEvent(
      "customPageView",
      new this.dataLayer(e, window.objDataLayer)
    );
  }
  dispatchCustomEvent(e, n) {
    this.dispatchEvent(e, new this.dataLayer(n, window.objDataLayer));
  }
}
const pc = ({ tracking: t }) => () => ({ dispatchPageView: (r) => {
  t.dispatchPageView(r);
}, dispatchCustomEvent: (r, o) => {
  t.dispatchCustomEvent(r, o);
} });
function ki(t) {
  return t.get("mbox") || "";
}
function ko(t) {
  const e = ki(t), n = crypto.randomUUID(), r = e.split("|").find((o) => o.startsWith("session"));
  return r ? r.split("#")[1] : n;
}
function hc(t) {
  const n = ki(t).split("|").find((r) => r.startsWith("PC"));
  return n ? n.split("#")[1] : "";
}
function gc(t, e = 10, n = 300) {
  return new Promise((r, o) => {
    const i = (s) => {
      window.Visitor ? r(window.Visitor.getInstance(t)) : s > 0 ? setTimeout(() => i(s - 1), n) : o(new Error("Visitor not available after retries"));
    };
    i(e);
  });
}
async function mc(t) {
  const e = await gc(t);
  return new Promise((n, r) => {
    e.getVisitorValues((o) => {
      const { MCMID: i } = o || {}, s = e._supplementalDataIDCurrent || e.getSupplementalDataID();
      i && s ? n({ mcmid: i, sdid: s }) : r(new Error("Visitor IDs not available not MCMID or SDID"));
    });
  });
}
function _c() {
  return /Mobi|iPhone|iPod|Android/i.test(navigator.userAgent);
}
function bc() {
  var n;
  const t = navigator;
  if ((n = t.userAgentData) != null && n.platform)
    return t.userAgentData.platform;
  const e = navigator.userAgent;
  return /Windows/.test(e) ? "Windows" : /Android/.test(e) ? "Android" : /iPhone|iPad|iPod/.test(e) ? "iOS" : /Mac OS/.test(e) ? "MacOS" : /Linux/.test(e) ? "Linux" : "unknown";
}
function yc() {
  return window.screen.orientation ? window.screen.orientation.type.split("-")[0] : "unknown";
}
function Li() {
  return {
    channel: "web",
    address: {
      url: window.location.href,
      referringUrl: document.referrer
    },
    browser: {
      host: window.location.host
    },
    userAgent: navigator.userAgent,
    clientHints: {
      mobile: _c(),
      platform: bc()
    },
    screen: {
      width: window.screen.width,
      height: window.screen.height,
      orientation: yc(),
      colorDepth: window.screen.colorDepth,
      pixelRatio: window.devicePixelRatio
    },
    window: {
      width: window.innerWidth,
      height: window.innerHeight
    }
  };
}
function vc(t, e) {
  return {
    context: Li(),
    id: t,
    ...e && {
      experienceCloud: {
        analytics: {
          trackingServer: "webmotors.sc.omtrdc.net",
          logging: "server_side",
          supplementalDataId: e
        }
      }
    }
  };
}
const Ec = ({
  fetch: t,
  mbox: e,
  cookie: n,
  autoInit: r = !0,
  adobeOrg: o,
  autoNotify: i = !1,
  key: s
}) => {
  const [a, c] = ue(r), [u, f] = ue(), [l, g] = ue(null), [O, E] = ue(null), A = lr(!1), v = lr(!1), x = lr(null), k = Mr(
    async (R) => {
      var b, C, h;
      const U = R || u;
      if (!(!U || v.current))
        try {
          const _ = (C = (b = U.prefetch) == null ? void 0 : b.mboxes) == null ? void 0 : C[0], p = (h = _ == null ? void 0 : _.options) == null ? void 0 : h[0], S = p == null ? void 0 : p.eventToken, I = _ == null ? void 0 : _.name, $ = ko(n), F = U.id;
          I && S && (await t.post(
            `https://webmotors.tt.omtrdc.net/rest/v1/delivery?client=webmotors&sessionId=${$}`,
            {
              ...vc(F, x.current || ""),
              notifications: [
                {
                  id: `${I}-notifications`,
                  timestamp: Date.now(),
                  type: "display",
                  mbox: { name: I },
                  tokens: [S]
                }
              ]
            }
          ), v.current = !0);
        } catch (_) {
          g(_);
        }
    },
    [n, t, u]
  ), T = Mr(async () => {
    var R, U, b, C, h;
    c(!0), g(null);
    try {
      const { mcmid: _, sdid: p } = await mc(o), S = hc(n), I = ko(n);
      x.current = p;
      const $ = await t.post(
        `https://webmotors.tt.omtrdc.net/rest/v1/delivery?client=webmotors&sessionId=${I}`,
        {
          context: Li(),
          id: {
            ...S && { tntId: S },
            ..._ && { marketingCloudVisitorId: _ }
          },
          experienceCloud: {
            analytics: {
              trackingServer: "webmotors.sc.omtrdc.net",
              logging: "server_side",
              supplementalDataId: p
            }
          },
          prefetch: {
            mboxes: [
              {
                name: e,
                index: 0
              }
            ]
          }
        }
      );
      if (f($), $ && s) {
        const F = (h = (C = (b = (U = (R = $.prefetch) == null ? void 0 : R.mboxes) == null ? void 0 : U[0]) == null ? void 0 : b.options) == null ? void 0 : C[0]) == null ? void 0 : h.content;
        F && s in F && E(F[s]);
      }
      i && $ && !v.current && await k($);
    } catch (_) {
      g(_);
    } finally {
      c(!1);
    }
  }, [o, i, n, t, s, e, k]);
  return xi(() => {
    r && !A.current && (T(), A.current = !0);
  }, [r, T]), {
    isFetching: a,
    result: u,
    init: T,
    notify: k,
    error: l,
    variation: O,
    notified: v.current
  };
};
function Qm({
  mbox: t,
  key: e,
  run: n = !0,
  debug: r = !1
}) {
  const [o, i] = ue(null), [s, a] = ue(null), [c, u] = ue(n), [f, l] = ue(null), g = Mr(() => new Promise((O, E) => {
    let v = 0;
    const x = setInterval(() => {
      var k;
      v++, r && console.log("Adobe Target loading attempt:", v), (k = window.adobe) != null && k.target ? (clearInterval(x), O()) : v >= 10 && (clearInterval(x), E(new Error("Adobe Target (at.js) não foi carregado.")));
    }, 300);
  }), [r]);
  return xi(() => {
    n && (async () => {
      var E, A;
      try {
        await g(), (A = (E = window.adobe) == null ? void 0 : E.target) == null || A.getOffer({
          mbox: t,
          success: (v) => {
            var R, U, b, C, h;
            (U = (R = window.adobe) == null ? void 0 : R.target) == null || U.applyOffer({ mbox: t, offer: v }), (C = (b = window.adobe) == null ? void 0 : b.target) == null || C.trackEvent({ mbox: t, type: "display" });
            const x = v == null ? void 0 : v.find((_) => _.action === "setJson"), k = ((h = x == null ? void 0 : x.content) == null ? void 0 : h[0]) ?? null, T = (k == null ? void 0 : k[e]) ?? null;
            r && console.log("Adobe Target content:", {
              offer: v,
              jsonAction: x,
              contentObject: k,
              variationValue: T
            }), i(k), a(T), u(!1);
          },
          error: (v) => {
            r && console.error("Adobe Target getOffer error:", v), l(v instanceof Error ? v : new Error(String(v))), u(!1);
          }
        });
      } catch (v) {
        r && console.error("Adobe Target loading error:", v), l(v instanceof Error ? v : new Error(String(v))), u(!1);
      }
    })();
  }, [t, e, n, g, r]), { content: o, variation: s, isLoading: c, error: f };
}
const t_ = () => {
  const t = pc({
    tracking: new fc(ac)
  }), {
    dispatchPageView: e,
    dispatchCustomEvent: n
  } = t();
  return { dispatchSellPageView: e, dispatchSellCustomEvent: n };
}, e_ = ({
  mbox: t,
  autoInit: e = !0,
  autoNotify: n = !1,
  adobeOrg: r,
  key: o
}) => Ec({
  fetch: new dc(),
  cookie: new lc(),
  mbox: t,
  autoInit: e,
  adobeOrg: r,
  autoNotify: n,
  key: o
}), Et = {
  log: "log",
  debug: "debug",
  info: "info",
  warn: "warn",
  error: "error"
}, Xt = console, me = {};
Object.keys(Et).forEach((t) => {
  me[t] = Xt[t];
});
const rn = "Datadog Browser SDK:", X = {
  debug: me.debug.bind(Xt, rn),
  log: me.log.bind(Xt, rn),
  info: me.info.bind(Xt, rn),
  warn: me.warn.bind(Xt, rn),
  error: me.error.bind(Xt, rn)
}, Wn = "https://docs.datadoghq.com", wc = `${Wn}/real_user_monitoring/browser/troubleshooting`, Yr = "More details:";
function Ni(t, e) {
  return (...n) => {
    try {
      return t(...n);
    } catch (r) {
      X.error(e, r);
    }
  };
}
function de(t) {
  return t !== 0 && Math.random() * 100 <= t;
}
function un(t, e) {
  return +t.toFixed(e);
}
function Sc(t) {
  return bn(t) && t >= 0 && t <= 100;
}
function bn(t) {
  return typeof t == "number";
}
const Pt = 1e3, $t = 60 * Pt, Pi = 60 * $t, Tc = 24 * Pi, Ui = 365 * Tc;
function yn(t) {
  return { relative: t, timeStamp: Ac(t) };
}
function Cc(t) {
  return { relative: qn(t), timeStamp: t };
}
function Ac(t) {
  const e = Yt() - performance.now();
  return e > vn() ? Math.round(We(e, t)) : Rc(t);
}
function Ic() {
  return Math.round(Yt() - We(vn(), performance.now()));
}
function K(t) {
  return bn(t) ? un(t * 1e6, 0) : t;
}
function Yt() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function It() {
  return Yt();
}
function zt() {
  return performance.now();
}
function xt() {
  return { relative: zt(), timeStamp: It() };
}
function Mi() {
  return { relative: 0, timeStamp: vn() };
}
function Ct(t, e) {
  return e - t;
}
function We(t, e) {
  return t + e;
}
function qn(t) {
  return t - vn();
}
function Rc(t) {
  return Math.round(We(vn(), t));
}
function xc(t) {
  return t < Ui;
}
let fr;
function vn() {
  return fr === void 0 && (fr = performance.timing.navigationStart), fr;
}
const je = 1024, Di = 1024 * je, Oc = /[^\u0000-\u007F]/;
function Bi(t) {
  return Oc.test(t) ? window.TextEncoder !== void 0 ? new TextEncoder().encode(t).length : new Blob([t]).size : t.length;
}
function kc(t) {
  const e = t.reduce((o, i) => o + i.length, 0), n = new Uint8Array(e);
  let r = 0;
  for (const o of t)
    n.set(o, r), r += o.length;
  return n;
}
function fn(t) {
  return { ...t };
}
function Vn(t, e) {
  return Object.keys(t).some((n) => t[n] === e);
}
function we(t) {
  return Object.keys(t).length === 0;
}
function Lc(t, e) {
  const n = {};
  for (const r of Object.keys(t))
    n[r] = e(t[r]);
  return n;
}
function qt() {
  if (typeof globalThis == "object")
    return globalThis;
  Object.defineProperty(Object.prototype, "_dd_temp_", {
    get() {
      return this;
    },
    configurable: !0
  });
  let t = _dd_temp_;
  return delete Object.prototype._dd_temp_, typeof t != "object" && (typeof self == "object" ? t = self : typeof window == "object" ? t = window : t = {}), t;
}
function fe(t, e) {
  const n = qt();
  let r;
  return n.Zone && typeof n.Zone.__symbol__ == "function" && (r = t[n.Zone.__symbol__(e)]), r || (r = t[e]), r;
}
let $n, Fi = !1;
function Nc(t) {
  $n = t;
}
function Pc(t) {
  Fi = t;
}
function Uc(t, e, n) {
  const r = n.value;
  n.value = function(...o) {
    return ($n ? G(r) : r).apply(this, o);
  };
}
function G(t) {
  return function() {
    return Ee(t, this, arguments);
  };
}
function Ee(t, e, n) {
  try {
    return t.apply(e, n);
  } catch (r) {
    pn(r);
  }
}
function pn(t) {
  if (Br(t), $n)
    try {
      $n(t);
    } catch (e) {
      Br(e);
    }
}
function Br(...t) {
  Fi && X.error("[MONITOR]", ...t);
}
function At(t, e) {
  return fe(qt(), "setTimeout")(G(t), e);
}
function Kt(t) {
  fe(qt(), "clearTimeout")(t);
}
function qe(t, e) {
  return fe(qt(), "setInterval")(G(t), e);
}
function Xn(t) {
  fe(qt(), "clearInterval")(t);
}
function Lo(t) {
  const e = window.queueMicrotask;
  typeof e == "function" ? e(G(t)) : Promise.resolve().then(G(t));
}
class nt {
  constructor(e) {
    this.onFirstSubscribe = e, this.observers = [];
  }
  subscribe(e) {
    return this.addObserver(e), {
      unsubscribe: () => this.removeObserver(e)
    };
  }
  notify(e) {
    this.observers.forEach((n) => n(e));
  }
  addObserver(e) {
    this.observers.push(e), this.observers.length === 1 && this.onFirstSubscribe && (this.onLastUnsubscribe = this.onFirstSubscribe(this) || void 0);
  }
  removeObserver(e) {
    this.observers = this.observers.filter((n) => e !== n), !this.observers.length && this.onLastUnsubscribe && this.onLastUnsubscribe();
  }
}
function Vi(...t) {
  return new nt((e) => {
    const n = t.map((r) => r.subscribe((o) => e.notify(o)));
    return () => n.forEach((r) => r.unsubscribe());
  });
}
class Mc extends nt {
  constructor(e) {
    super(), this.maxBufferSize = e, this.buffer = [];
  }
  notify(e) {
    this.buffer.push(e), this.buffer.length > this.maxBufferSize && this.buffer.shift(), super.notify(e);
  }
  subscribe(e) {
    let n = !1;
    const r = {
      unsubscribe: () => {
        n = !0, this.removeObserver(e);
      }
    };
    return Lo(() => {
      for (const o of this.buffer) {
        if (n)
          return;
        e(o);
      }
      n || this.addObserver(e);
    }), r;
  }
  /**
   * Drop buffered data and don't buffer future data. This is to avoid leaking memory when it's not
   * needed anymore. This can be seen as a performance optimization, and things will work probably
   * even if this method isn't called, but still useful to clarify our intent and lowering our
   * memory impact.
   */
  unbuffer() {
    Lo(() => {
      this.maxBufferSize = this.buffer.length = 0;
    });
  }
}
function Jn(t, e, n) {
  const r = n && n.leading !== void 0 ? n.leading : !0, o = n && n.trailing !== void 0 ? n.trailing : !0;
  let i = !1, s, a;
  return {
    throttled: (...c) => {
      if (i) {
        s = c;
        return;
      }
      r ? t(...c) : s = c, i = !0, a = At(() => {
        o && s && t(...s), i = !1, s = void 0;
      }, e);
    },
    cancel: () => {
      Kt(a), i = !1, s = void 0;
    }
  };
}
function it() {
}
function Ot(t) {
  return t ? (
    // eslint-disable-next-line  no-bitwise
    (parseInt(t, 10) ^ Math.random() * 16 >> parseInt(t, 10) / 4).toString(16)
  ) : `10000000-1000-4000-8000-${1e11}`.replace(/[018]/g, Ot);
}
const jn = /([\w-]+)\s*=\s*([^;]+)/g;
function hn(t, e) {
  for (jn.lastIndex = 0; ; ) {
    const n = jn.exec(t);
    if (n) {
      if (n[1] === e)
        return n[2];
    } else
      break;
  }
}
function Dc(t) {
  const e = /* @__PURE__ */ new Map();
  for (jn.lastIndex = 0; ; ) {
    const n = jn.exec(t);
    if (n)
      e.set(n[1], n[2]);
    else
      break;
  }
  return e;
}
function $i(t, e, n = "") {
  const r = t.charCodeAt(e - 1), i = r >= 55296 && r <= 56319 ? e + 1 : e;
  return t.length <= i ? t : `${t.slice(0, i)}${n}`;
}
function Bc() {
  return ji() === 0;
}
function n_() {
  return ji() === 1;
}
let Tn;
function ji() {
  return Tn ?? (Tn = Fc());
}
function Fc(t = window) {
  var e;
  const n = t.navigator.userAgent;
  return t.chrome || /HeadlessChrome/.test(n) ? 0 : (
    // navigator.vendor is deprecated, but it is the most resilient way we found to detect
    // "Apple maintained browsers" (AKA Safari). If one day it gets removed, we still have the
    // useragent test as a semi-working fallback.
    ((e = t.navigator.vendor) === null || e === void 0 ? void 0 : e.indexOf("Apple")) === 0 || /safari/i.test(n) && !/chrome|android/i.test(n) ? 1 : 2
  );
}
function Zn(t, e, n = 0, r) {
  const o = /* @__PURE__ */ new Date();
  o.setTime(o.getTime() + n);
  const i = `expires=${o.toUTCString()}`, s = r && r.crossSite ? "none" : "strict", a = r && r.domain ? `;domain=${r.domain}` : "", c = r && r.secure ? ";secure" : "", u = r && r.partitioned ? ";partitioned" : "";
  document.cookie = `${t}=${e};${i};path=/;samesite=${s}${a}${c}${u}`;
}
function Wr(t) {
  return hn(document.cookie, t);
}
let pr;
function le(t) {
  return pr || (pr = Dc(document.cookie)), pr.get(t);
}
function zi(t, e) {
  Zn(t, "", 0, e);
}
function Vc(t) {
  if (document.cookie === void 0 || document.cookie === null)
    return !1;
  try {
    const e = `dd_cookie_test_${Ot()}`, n = "test";
    Zn(e, n, $t, t);
    const r = Wr(e) === n;
    return zi(e, t), r;
  } catch (e) {
    return X.error(e), !1;
  }
}
let hr;
function $c() {
  if (hr === void 0) {
    const t = `dd_site_test_${Ot()}`, e = "test", n = window.location.hostname.split(".");
    let r = n.pop();
    for (; n.length && !Wr(t); )
      r = `${n.pop()}.${r}`, Zn(t, e, Pt, { domain: r });
    zi(t, { domain: r }), hr = r;
  }
  return hr;
}
const En = "_dd_s";
function jc(t, e) {
  for (let n = t.length - 1; n >= 0; n -= 1) {
    const r = t[n];
    if (e(r, n, t))
      return r;
  }
}
function zn(t) {
  return Object.values(t);
}
function qr(t) {
  return Object.entries(t);
}
const Se = 4 * Pi, Gi = 15 * $t, zc = Ui, Hi = "0", gn = {
  COOKIE: "cookie",
  LOCAL_STORAGE: "local-storage"
}, Ki = /^([a-zA-Z]+)=([a-z0-9-]+)$/, Xr = "&";
function Gc(t) {
  return !!t && (t.indexOf(Xr) !== -1 || Ki.test(t));
}
const Hc = "1";
function _e(t, e) {
  const n = {
    isExpired: Hc
  };
  return e.trackAnonymousUser && (t != null && t.anonymousId ? n.anonymousId = t == null ? void 0 : t.anonymousId : n.anonymousId = Ot()), n;
}
function Pn(t) {
  return we(t);
}
function Yi(t) {
  return !Pn(t);
}
function Gn(t) {
  return t.isExpired !== void 0 || !Kc(t);
}
function Kc(t) {
  return (t.created === void 0 || Yt() - Number(t.created) < Se) && (t.expire === void 0 || Yt() < Number(t.expire));
}
function Wi(t) {
  t.expire = String(Yt() + Gi);
}
function qi(t) {
  return qr(t).map(([e, n]) => e === "anonymousId" ? `aid=${n}` : `${e}=${n}`).join(Xr);
}
function Xi(t) {
  const e = {};
  return Gc(t) && t.split(Xr).forEach((n) => {
    const r = Ki.exec(n);
    if (r !== null) {
      const [, o, i] = r;
      o === "aid" ? e.anonymousId = i : e[o] = i;
    }
  }), e;
}
const Yc = "_dd", Wc = "_dd_r", qc = "_dd_l", Xc = "rum", Jc = "logs";
function Zc(t) {
  if (!le(En)) {
    const n = le(Yc), r = le(Wc), o = le(qc), i = {};
    n && (i.id = n), o && /^[01]$/.test(o) && (i[Jc] = o), r && /^[012]$/.test(r) && (i[Xc] = r), Yi(i) && (Wi(i), t.persistSession(i));
  }
}
function No(t) {
  const e = tu(t);
  return Vc(e) ? { type: gn.COOKIE, cookieOptions: e } : void 0;
}
function Qc(t, e) {
  const n = {
    /**
     * Lock strategy allows mitigating issues due to concurrent access to cookie.
     * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
     */
    isLockEnabled: Bc(),
    persistSession: (r) => Po(e, t, r, Gi),
    retrieveSession: Ji,
    expireSession: (r) => Po(e, t, _e(r, t), Se)
  };
  return Zc(n), n;
}
function Po(t, e, n, r) {
  Zn(En, qi(n), e.trackAnonymousUser ? zc : r, t);
}
function Ji() {
  const t = Wr(En);
  return Xi(t);
}
function tu(t) {
  const e = {};
  return e.secure = !!t.useSecureSessionCookie || !!t.usePartitionedCrossSiteSessionCookie, e.crossSite = !!t.usePartitionedCrossSiteSessionCookie, e.partitioned = !!t.usePartitionedCrossSiteSessionCookie, t.trackSessionAcrossSubdomains && (e.domain = $c()), e;
}
const eu = "_dd_test_";
function Uo() {
  try {
    const t = Ot(), e = `${eu}${t}`;
    localStorage.setItem(e, t);
    const n = localStorage.getItem(e);
    return localStorage.removeItem(e), t === n ? { type: gn.LOCAL_STORAGE } : void 0;
  } catch {
    return;
  }
}
function nu(t) {
  return {
    isLockEnabled: !1,
    persistSession: Zi,
    retrieveSession: ru,
    expireSession: (e) => ou(e, t)
  };
}
function Zi(t) {
  localStorage.setItem(En, qi(t));
}
function ru() {
  const t = localStorage.getItem(En);
  return Xi(t);
}
function ou(t, e) {
  Zi(_e(t, e));
}
function Xe(t, e, n) {
  if (typeof t != "object" || t === null)
    return JSON.stringify(t);
  const r = Me(Object.prototype), o = Me(Array.prototype), i = Me(Object.getPrototypeOf(t)), s = Me(t);
  try {
    return JSON.stringify(t, e, n);
  } catch {
    return "<error: unable to serialize object>";
  } finally {
    r(), o(), i(), s();
  }
}
function Me(t) {
  const e = t, n = e.toJSON;
  return n ? (delete e.toJSON, () => {
    e.toJSON = n;
  }) : it;
}
const iu = 220 * je, su = "$", au = 3;
function ht(t, e = iu) {
  const n = Me(Object.prototype), r = Me(Array.prototype), o = [], i = /* @__PURE__ */ new WeakMap(), s = gr(t, su, void 0, o, i), a = JSON.stringify(s);
  let c = a ? a.length : 0;
  if (c > e) {
    mr(e, "discarded", t);
    return;
  }
  for (; o.length > 0 && c < e; ) {
    const u = o.shift();
    let f = 0;
    if (Array.isArray(u.source))
      for (let l = 0; l < u.source.length; l++) {
        const g = gr(u.source[l], u.path, l, o, i);
        if (g !== void 0 ? c += JSON.stringify(g).length : c += 4, c += f, f = 1, c > e) {
          mr(e, "truncated", t);
          break;
        }
        u.target[l] = g;
      }
    else
      for (const l in u.source)
        if (Object.prototype.hasOwnProperty.call(u.source, l)) {
          const g = gr(u.source[l], u.path, l, o, i);
          if (g !== void 0 && (c += JSON.stringify(g).length + f + l.length + au, f = 1), c > e) {
            mr(e, "truncated", t);
            break;
          }
          u.target[l] = g;
        }
  }
  return n(), r(), s;
}
function gr(t, e, n, r, o) {
  const i = lu(t);
  if (!i || typeof i != "object")
    return cu(i);
  const s = Fr(i);
  if (s !== "[Object]" && s !== "[Array]" && s !== "[Error]")
    return s;
  const a = t;
  if (o.has(a))
    return `[Reference seen at ${o.get(a)}]`;
  const c = n !== void 0 ? `${e}.${n}` : e, u = Array.isArray(i) ? [] : {};
  return o.set(a, c), r.push({ source: i, target: u, path: c }), u;
}
function cu(t) {
  return typeof t == "bigint" ? `[BigInt] ${t.toString()}` : typeof t == "function" ? `[Function] ${t.name || "unknown"}` : typeof t == "symbol" ? `[Symbol] ${t.description || t.toString()}` : t;
}
function Fr(t) {
  try {
    if (t instanceof Event)
      return uu(t);
    if (t instanceof RegExp)
      return `[RegExp] ${t.toString()}`;
    const n = Object.prototype.toString.call(t).match(/\[object (.*)\]/);
    if (n && n[1])
      return `[${n[1]}]`;
  } catch {
  }
  return "[Unserializable]";
}
function uu(t) {
  return {
    type: t.type,
    isTrusted: t.isTrusted,
    currentTarget: t.currentTarget ? Fr(t.currentTarget) : null,
    target: t.target ? Fr(t.target) : null
  };
}
function lu(t) {
  const e = t;
  if (e && typeof e.toJSON == "function")
    try {
      return e.toJSON();
    } catch {
    }
  return t;
}
function mr(t, e, n) {
  X.warn(`The data provided has been ${e} as it is over the limit of ${t} characters:`, n);
}
const ze = "?";
function Je(t) {
  var e, n;
  const r = [];
  let o = _r(t, "stack");
  const i = String(t);
  if (o && o.startsWith(i) && (o = o.slice(i.length)), o && o.split(`
`).forEach((s) => {
    const a = pu(s) || gu(s) || _u(s) || vu(s);
    a && (!a.func && a.line && (a.func = ze), r.push(a));
  }), r.length > 0 && Tu() && t instanceof Error) {
    const s = [];
    let a = t;
    for (; (a = Object.getPrototypeOf(a)) && ts(a); ) {
      const c = ((e = a.constructor) === null || e === void 0 ? void 0 : e.name) || ze;
      s.push(c);
    }
    for (let c = s.length - 1; c >= 0 && ((n = r[0]) === null || n === void 0 ? void 0 : n.func) === s[c]; c--)
      r.shift();
  }
  return {
    message: _r(t, "message"),
    name: _r(t, "name"),
    stack: r
  };
}
const Qi = "((?:file|https?|blob|chrome-extension|electron|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)", Ge = "(?::(\\d+))", du = new RegExp(`^\\s*at (.*?) ?\\(${Qi}${Ge}?${Ge}?\\)?\\s*$`, "i"), fu = new RegExp(`\\((\\S*)${Ge}${Ge}\\)`);
function pu(t) {
  const e = du.exec(t);
  if (!e)
    return;
  const n = e[2] && e[2].indexOf("native") === 0, r = e[2] && e[2].indexOf("eval") === 0, o = fu.exec(e[2]);
  return r && o && (e[2] = o[1], e[3] = o[2], e[4] = o[3]), {
    args: n ? [e[2]] : [],
    column: e[4] ? +e[4] : void 0,
    func: e[1] || ze,
    line: e[3] ? +e[3] : void 0,
    url: n ? void 0 : e[2]
  };
}
const hu = new RegExp(`^\\s*at ?${Qi}${Ge}?${Ge}??\\s*$`, "i");
function gu(t) {
  const e = hu.exec(t);
  if (e)
    return {
      args: [],
      column: e[3] ? +e[3] : void 0,
      func: ze,
      line: e[2] ? +e[2] : void 0,
      url: e[1]
    };
}
const mu = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function _u(t) {
  const e = mu.exec(t);
  if (e)
    return {
      args: [],
      column: e[4] ? +e[4] : void 0,
      func: e[1] || ze,
      line: +e[3],
      url: e[2]
    };
}
const bu = /^\s*(.*?)(?:\((.*?)\))?(?:(?:(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle|\[wasm code\])(?::(\d+))?(?::(\d+))?)|@)\s*$/i, yu = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function vu(t) {
  const e = bu.exec(t);
  if (!e)
    return;
  const n = e[3] && e[3].indexOf(" > eval") > -1, r = yu.exec(e[3]);
  return n && r && (e[3] = r[1], e[4] = r[2], e[5] = void 0), {
    args: e[2] ? e[2].split(",") : [],
    column: e[5] ? +e[5] : void 0,
    func: e[1] || ze,
    line: e[4] ? +e[4] : void 0,
    url: e[3]
  };
}
function _r(t, e) {
  if (typeof t != "object" || !t || !(e in t))
    return;
  const n = t[e];
  return typeof n == "string" ? n : void 0;
}
function Eu(t, e, n, r) {
  if (e === void 0)
    return;
  const { name: o, message: i } = Su(t);
  return {
    name: o,
    message: i,
    stack: [{ url: e, column: r, line: n }]
  };
}
const wu = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function Su(t) {
  let e, n;
  return {}.toString.call(t) === "[object String]" && ([, e, n] = wu.exec(t)), { name: e, message: n };
}
function ts(t) {
  return String(t.constructor).startsWith("class ");
}
let Cn;
function Tu() {
  if (Cn !== void 0)
    return Cn;
  class t extends Error {
    constructor() {
      super(), this.name = "Error";
    }
  }
  const [e, n] = [t, Error].map((r) => new r());
  return Cn = // If customError is not a class, it means that this was built with ES5 as target, converting the class to a normal object.
  // Thus, error constructors will be reported on all browsers, which is the expected behavior.
  ts(Object.getPrototypeOf(e)) && // If the browser is correctly reporting the stacktrace, the normal error stacktrace should be the same as the custom error stacktrace
  n.stack !== e.stack, Cn;
}
function He(t) {
  const n = new Error(t);
  n.name = "HandlingStack";
  let r;
  return Ee(() => {
    const o = Je(n);
    o.stack = o.stack.slice(2), r = Ze(o);
  }), r;
}
function Ze(t) {
  let e = es(t);
  return t.stack.forEach((n) => {
    const r = n.func === "?" ? "<anonymous>" : n.func, o = n.args && n.args.length > 0 ? `(${n.args.join(", ")})` : "", i = n.line ? `:${n.line}` : "", s = n.line && n.column ? `:${n.column}` : "";
    e += `
  at ${r}${o} @ ${n.url}${i}${s}`;
  }), e;
}
function es(t) {
  return `${t.name || "Error"}: ${t.message}`;
}
const ns = "No stack, consider using an instance of Error";
function Qn({ stackTrace: t, originalError: e, handlingStack: n, componentStack: r, startClocks: o, nonErrorPrefix: i, useFallbackStack: s = !0, source: a, handling: c }) {
  const u = Te(e);
  return !t && u && (t = Je(e)), {
    startClocks: o,
    source: a,
    handling: c,
    handlingStack: n,
    componentStack: r,
    originalError: e,
    type: t ? t.name : void 0,
    message: Cu(t, u, i, e),
    stack: t ? Ze(t) : s ? ns : void 0,
    causes: u ? xu(e, a) : void 0,
    fingerprint: Au(e),
    context: Iu(e)
  };
}
function Cu(t, e, n, r) {
  return t != null && t.message && (t != null && t.name) ? t.message : e ? "Empty message" : `${n} ${Xe(ht(r))}`;
}
function Au(t) {
  return Te(t) && "dd_fingerprint" in t ? String(t.dd_fingerprint) : void 0;
}
function Iu(t) {
  if (t !== null && typeof t == "object" && "dd_context" in t)
    return t.dd_context;
}
function Ru(t) {
  var e;
  return (e = /@ (.+)/.exec(t)) === null || e === void 0 ? void 0 : e[1];
}
function Te(t) {
  return t instanceof Error || Object.prototype.toString.call(t) === "[object Error]";
}
function xu(t, e) {
  let n = t;
  const r = [];
  for (; Te(n == null ? void 0 : n.cause) && r.length < 10; ) {
    const o = Je(n.cause);
    r.push({
      message: n.cause.message,
      source: e,
      type: o == null ? void 0 : o.name,
      stack: o && Ze(o)
    }), n = n.cause;
  }
  return r.length ? r : void 0;
}
var mn;
(function(t) {
  t.TRACK_INTAKE_REQUESTS = "track_intake_requests", t.WRITABLE_RESOURCE_GRAPHQL = "writable_resource_graphql";
})(mn || (mn = {}));
const Jr = /* @__PURE__ */ new Set();
function rs(t) {
  Array.isArray(t) && Ou(t.filter((e) => Vn(mn, e)));
}
function Ou(t) {
  t.forEach((e) => {
    Jr.add(e);
  });
}
function os(t) {
  return Jr.has(t);
}
function ku() {
  return Jr;
}
const is = "datad0g.com", Lu = "dd0g-gov.com", ye = "datadoghq.com", Nu = "datadoghq.eu", Pu = "ddog-gov.com", Uu = "pci.browser-intake-datadoghq.com", Mu = ["ddsource", "ddtags"];
function Zr(t, e) {
  const n = window.__ddBrowserSdkExtensionCallback;
  n && n({ type: t, payload: e });
}
function Ce(t) {
  return t === null ? "null" : Array.isArray(t) ? "array" : typeof t;
}
function Hn(t, e, n = Du()) {
  if (e === void 0)
    return t;
  if (typeof e != "object" || e === null)
    return e;
  if (e instanceof Date)
    return new Date(e.getTime());
  if (e instanceof RegExp) {
    const o = e.flags || // old browsers compatibility
    [
      e.global ? "g" : "",
      e.ignoreCase ? "i" : "",
      e.multiline ? "m" : "",
      e.sticky ? "y" : "",
      e.unicode ? "u" : ""
    ].join("");
    return new RegExp(e.source, o);
  }
  if (n.hasAlreadyBeenSeen(e))
    return;
  if (Array.isArray(e)) {
    const o = Array.isArray(t) ? t : [];
    for (let i = 0; i < e.length; ++i)
      o[i] = Hn(o[i], e[i], n);
    return o;
  }
  const r = Ce(t) === "object" ? t : {};
  for (const o in e)
    Object.prototype.hasOwnProperty.call(e, o) && (r[o] = Hn(r[o], e[o], n));
  return r;
}
function tr(t) {
  return Hn(void 0, t);
}
function Vt(...t) {
  let e;
  for (const n of t)
    n != null && (e = Hn(e, n));
  return e;
}
function Du() {
  if (typeof WeakSet < "u") {
    const e = /* @__PURE__ */ new WeakSet();
    return {
      hasAlreadyBeenSeen(n) {
        const r = e.has(n);
        return r || e.add(n), r;
      }
    };
  }
  const t = [];
  return {
    hasAlreadyBeenSeen(e) {
      const n = t.indexOf(e) >= 0;
      return n || t.push(e), n;
    }
  };
}
function ss() {
  var t;
  const e = window.navigator;
  return {
    status: e.onLine ? "connected" : "not_connected",
    interfaces: e.connection && e.connection.type ? [e.connection.type] : void 0,
    effective_type: (t = e.connection) === null || t === void 0 ? void 0 : t.effectiveType
  };
}
function Bu(t) {
  const e = /* @__PURE__ */ new Set();
  return t.forEach((n) => e.add(n)), Array.from(e);
}
function as(t, e) {
  const n = t.indexOf(e);
  n >= 0 && t.splice(n, 1);
}
const Fu = 500;
function Qr() {
  const t = [];
  return {
    add: (o) => {
      t.push(o) > Fu && t.splice(0, 1);
    },
    remove: (o) => {
      as(t, o);
    },
    drain: (o) => {
      t.forEach((i) => i(o)), t.length = 0;
    }
  };
}
function cs(t) {
  return t >= 500;
}
function us(t) {
  try {
    return t.clone();
  } catch {
    return;
  }
}
const jt = {
  AGENT: "agent",
  CONSOLE: "console",
  CUSTOM: "custom",
  LOGGER: "logger",
  NETWORK: "network",
  SOURCE: "source",
  REPORT: "report"
}, Vu = 80 * je, $u = 32, ls = 3 * Di, ju = $t, ds = Pt;
function fs(t, e, n, r, o) {
  e.transportStatus === 0 && e.queuedPayloads.size() === 0 && e.bandwidthMonitor.canHandle(t) ? hs(t, e, n, {
    onSuccess: () => gs(0, e, n, r, o),
    onFailure: () => {
      e.queuedPayloads.enqueue(t), ps(e, n, r, o);
    }
  }) : e.queuedPayloads.enqueue(t);
}
function ps(t, e, n, r) {
  t.transportStatus === 2 && At(() => {
    const o = t.queuedPayloads.first();
    hs(o, t, e, {
      onSuccess: () => {
        t.queuedPayloads.dequeue(), t.currentBackoffTime = ds, gs(1, t, e, n, r);
      },
      onFailure: () => {
        t.currentBackoffTime = Math.min(ju, t.currentBackoffTime * 2), ps(t, e, n, r);
      }
    });
  }, t.currentBackoffTime);
}
function hs(t, e, n, { onSuccess: r, onFailure: o }) {
  e.bandwidthMonitor.add(t), n(t, (i) => {
    e.bandwidthMonitor.remove(t), zu(i) ? (e.transportStatus = e.bandwidthMonitor.ongoingRequestCount > 0 ? 1 : 2, t.retry = {
      count: t.retry ? t.retry.count + 1 : 1,
      lastFailureStatus: i.status
    }, o()) : (e.transportStatus = 0, r());
  });
}
function gs(t, e, n, r, o) {
  t === 0 && e.queuedPayloads.isFull() && !e.queueFullReported && (o({
    message: `Reached max ${r} events size queued for upload: ${ls / Di}MiB`,
    source: jt.AGENT,
    startClocks: xt()
  }), e.queueFullReported = !0);
  const i = e.queuedPayloads;
  for (e.queuedPayloads = ms(); i.size() > 0; )
    fs(i.dequeue(), e, n, r, o);
}
function zu(t) {
  return t.type !== "opaque" && (t.status === 0 && !navigator.onLine || t.status === 408 || t.status === 429 || cs(t.status));
}
function Gu() {
  return {
    transportStatus: 0,
    currentBackoffTime: ds,
    bandwidthMonitor: Hu(),
    queuedPayloads: ms(),
    queueFullReported: !1
  };
}
function ms() {
  const t = [];
  return {
    bytesCount: 0,
    enqueue(e) {
      this.isFull() || (t.push(e), this.bytesCount += e.bytesCount);
    },
    first() {
      return t[0];
    },
    dequeue() {
      const e = t.shift();
      return e && (this.bytesCount -= e.bytesCount), e;
    },
    size() {
      return t.length;
    },
    isFull() {
      return this.bytesCount >= ls;
    }
  };
}
function Hu() {
  return {
    ongoingRequestCount: 0,
    ongoingByteCount: 0,
    canHandle(t) {
      return this.ongoingRequestCount === 0 || this.ongoingByteCount + t.bytesCount <= Vu && this.ongoingRequestCount < $u;
    },
    add(t) {
      this.ongoingRequestCount += 1, this.ongoingByteCount += t.bytesCount;
    },
    remove(t) {
      this.ongoingRequestCount -= 1, this.ongoingByteCount -= t.bytesCount;
    }
  };
}
function Ku(t, e, n) {
  const r = Gu(), o = (i, s) => qu(t, e, i, s);
  return {
    send: (i) => {
      fs(i, r, o, t.trackType, n);
    },
    /**
     * Since fetch keepalive behaves like regular fetch on Firefox,
     * keep using sendBeaconStrategy on exit
     */
    sendOnExit: (i) => {
      Yu(t, e, i);
    }
  };
}
function Yu(t, e, n) {
  if (!!navigator.sendBeacon && n.bytesCount < e)
    try {
      const o = t.build("beacon", n);
      if (navigator.sendBeacon(o, n.data))
        return;
    } catch (o) {
      Wu(o);
    }
  Vr(t, n);
}
let Mo = !1;
function Wu(t) {
  Mo || (Mo = !0, pn(t));
}
function qu(t, e, n, r) {
  if (Xu() && n.bytesCount < e) {
    const i = t.build("fetch-keepalive", n);
    fetch(i, { method: "POST", body: n.data, keepalive: !0, mode: "cors" }).then(G((s) => r == null ? void 0 : r({ status: s.status, type: s.type }))).catch(G(() => Vr(t, n, r)));
  } else
    Vr(t, n, r);
}
function Vr(t, e, n) {
  const r = t.build("fetch", e);
  fetch(r, { method: "POST", body: e.data, mode: "cors" }).then(G((o) => n == null ? void 0 : n({ status: o.status, type: o.type }))).catch(G(() => n == null ? void 0 : n({ status: 0 })));
}
function Xu() {
  try {
    return window.Request && "keepalive" in new Request("http://a");
  } catch {
    return !1;
  }
}
function Qe() {
  const t = Ju();
  if (t)
    return {
      getCapabilities() {
        var e;
        return JSON.parse(((e = t.getCapabilities) === null || e === void 0 ? void 0 : e.call(t)) || "[]");
      },
      getPrivacyLevel() {
        var e;
        return (e = t.getPrivacyLevel) === null || e === void 0 ? void 0 : e.call(t);
      },
      getAllowedWebViewHosts() {
        return JSON.parse(t.getAllowedWebViewHosts());
      },
      send(e, n, r) {
        const o = r ? { id: r } : void 0;
        t.send(JSON.stringify({ eventType: e, event: n, view: o }));
      }
    };
}
function _s(t) {
  const e = Qe();
  return !!e && e.getCapabilities().includes(t);
}
function ie(t) {
  var e;
  t === void 0 && (t = (e = qt().location) === null || e === void 0 ? void 0 : e.hostname);
  const n = Qe();
  return !!n && n.getAllowedWebViewHosts().some((r) => t === r || t.endsWith(`.${r}`));
}
function Ju() {
  return qt().DatadogEventBridge;
}
function mt(t, e, n, r, o) {
  return pe(t, e, [n], r, o);
}
function pe(t, e, n, r, { once: o, capture: i, passive: s } = {}) {
  const a = G((g) => {
    !g.isTrusted && !g.__ddIsTrusted && !t.allowUntrustedEvents || (o && l(), r(g));
  }), c = s ? { capture: i, passive: s } : i, u = window.EventTarget && e instanceof EventTarget ? window.EventTarget.prototype : e, f = fe(u, "addEventListener");
  n.forEach((g) => f.call(e, g, a, c));
  function l() {
    const g = fe(u, "removeEventListener");
    n.forEach((O) => g.call(e, O, a, c));
  }
  return {
    stop: l
  };
}
const Ve = {
  HIDDEN: "visibility_hidden",
  UNLOADING: "before_unload",
  PAGEHIDE: "page_hide",
  FROZEN: "page_frozen"
};
function bs(t) {
  return new nt((e) => {
    const { stop: n } = pe(t, window, [
      "visibilitychange",
      "freeze"
      /* DOM_EVENT.FREEZE */
    ], (o) => {
      o.type === "visibilitychange" && document.visibilityState === "hidden" ? e.notify({ reason: Ve.HIDDEN }) : o.type === "freeze" && e.notify({ reason: Ve.FROZEN });
    }, { capture: !0 }), r = mt(t, window, "beforeunload", () => {
      e.notify({ reason: Ve.UNLOADING });
    }).stop;
    return () => {
      n(), r();
    };
  });
}
function Zu(t) {
  return zn(Ve).includes(t);
}
function Qu({ encoder: t, request: e, flushController: n, messageBytesLimit: r }) {
  let o = {};
  const i = n.flushObservable.subscribe((l) => f(l));
  function s(l, g, O) {
    n.notifyBeforeAddMessage(g), O !== void 0 ? (o[O] = l, n.notifyAfterAddMessage()) : t.write(t.isEmpty ? l : `
${l}`, (E) => {
      n.notifyAfterAddMessage(E - g);
    });
  }
  function a(l) {
    return l !== void 0 && o[l] !== void 0;
  }
  function c(l) {
    const g = o[l];
    delete o[l];
    const O = t.estimateEncodedBytesCount(g);
    n.notifyAfterRemoveMessage(O);
  }
  function u(l, g) {
    const O = Xe(l), E = t.estimateEncodedBytesCount(O);
    if (E >= r) {
      X.warn(`Discarded a message whose size was bigger than the maximum allowed size ${r}KB. ${Yr} ${wc}/#technical-limitations`);
      return;
    }
    a(g) && c(g), s(O, E, g);
  }
  function f(l) {
    const g = zn(o).join(`
`);
    o = {};
    const O = Zu(l.reason), E = O ? e.sendOnExit : e.send;
    if (O && // Note: checking that the encoder is async is not strictly needed, but it's an optimization:
    // if the encoder is async we need to send two requests in some cases (one for encoded data
    // and the other for non-encoded data). But if it's not async, we don't have to worry about
    // it and always send a single request.
    t.isAsync) {
      const A = t.finishSync();
      A.outputBytesCount && E(Do(A));
      const v = [A.pendingData, g].filter(Boolean).join(`
`);
      v && E({
        data: v,
        bytesCount: Bi(v)
      });
    } else
      g && t.write(t.isEmpty ? g : `
${g}`), t.finish((A) => {
        E(Do(A));
      });
  }
  return {
    flushController: n,
    add: u,
    upsert: u,
    stop: i.unsubscribe
  };
}
function Do(t) {
  let e;
  return typeof t.output == "string" ? e = t.output : e = new Blob([t.output], {
    // This will set the 'Content-Type: text/plain' header. Reasoning:
    // * The intake rejects the request if there is no content type.
    // * The browser will issue CORS preflight requests if we set it to 'application/json', which
    // could induce higher intake load (and maybe has other impacts).
    // * Also it's not quite JSON, since we are concatenating multiple JSON objects separated by
    // new lines.
    type: "text/plain"
  }), {
    data: e,
    bytesCount: t.outputBytesCount,
    encoding: t.encoding
  };
}
function tl({ messagesLimit: t, bytesLimit: e, durationLimit: n, pageMayExitObservable: r, sessionExpireObservable: o }) {
  const i = r.subscribe((E) => f(E.reason)), s = o.subscribe(() => f("session_expire")), a = new nt(() => () => {
    i.unsubscribe(), s.unsubscribe();
  });
  let c = 0, u = 0;
  function f(E) {
    if (u === 0)
      return;
    const A = u, v = c;
    u = 0, c = 0, O(), a.notify({
      reason: E,
      messagesCount: A,
      bytesCount: v
    });
  }
  let l;
  function g() {
    l === void 0 && (l = At(() => {
      f("duration_limit");
    }, n));
  }
  function O() {
    Kt(l), l = void 0;
  }
  return {
    flushObservable: a,
    get messagesCount() {
      return u;
    },
    /**
     * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
     *
     * This function needs to be called synchronously, right before adding the message, so no flush
     * event can happen after `notifyBeforeAddMessage` and before adding the message.
     *
     * @param estimatedMessageBytesCount: an estimation of the message bytes count once it is
     * actually added.
     */
    notifyBeforeAddMessage(E) {
      c + E >= e && f("bytes_limit"), u += 1, c += E, g();
    },
    /**
     * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
     *
     * This function can be called asynchronously after the message was added, but in this case it
     * should not be called if a flush event occurred in between.
     *
     * @param messageBytesCountDiff: the difference between the estimated message bytes count and
     * its actual bytes count once added to the pool.
     */
    notifyAfterAddMessage(E = 0) {
      c += E, u >= t ? f("messages_limit") : c >= e && f("bytes_limit");
    },
    /**
     * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
     *
     * This function needs to be called synchronously, right after removing the message, so no flush
     * event can happen after removing the message and before `notifyAfterRemoveMessage`.
     *
     * @param messageBytesCount: the message bytes count that was added to the pool. Should
     * correspond to the sum of bytes counts passed to `notifyBeforeAddMessage` and
     * `notifyAfterAddMessage`.
     */
    notifyAfterRemoveMessage(E) {
      c -= E, u -= 1, u === 0 && O();
    }
  };
}
function to(t, e, n, r, o, i, s = Qu) {
  const a = u(t, e), c = n && u(t, n);
  function u(f, { endpoint: l, encoder: g }) {
    return s({
      encoder: g,
      request: Ku(l, f.batchBytesLimit, r),
      flushController: tl({
        messagesLimit: f.batchMessagesLimit,
        bytesLimit: f.batchBytesLimit,
        durationLimit: f.flushTimeout,
        pageMayExitObservable: o,
        sessionExpireObservable: i
      }),
      messageBytesLimit: f.messageBytesLimit
    });
  }
  return {
    flushObservable: a.flushController.flushObservable,
    add(f, l = !0) {
      a.add(f), c && l && c.add(n.transformMessage ? n.transformMessage(f) : f);
    },
    upsert: (f, l) => {
      a.upsert(f, l), c && c.upsert(n.transformMessage ? n.transformMessage(f) : f, l);
    },
    stop: () => {
      a.stop(), c && c.stop();
    }
  };
}
const ve = {
  LOG: "log",
  CONFIGURATION: "configuration",
  USAGE: "usage"
}, el = [
  "https://www.datadoghq-browser-agent.com",
  "https://www.datad0g-browser-agent.com",
  "https://d3uc069fcn7uxw.cloudfront.net",
  "https://d20xtzwzcl0ceb.cloudfront.net",
  "http://localhost",
  "<anonymous>"
], nl = [Pu];
let ys = Qr(), tn = (t) => {
  ys.add(() => tn(t));
};
function vs(t, e, n, r, o, i) {
  const s = new nt(), { stop: a } = ol(e, r, o, i, s), { enabled: c } = rl(t, e, n, s);
  return {
    stop: a,
    enabled: c
  };
}
function rl(t, e, n, r) {
  const o = /* @__PURE__ */ new Set(), i = !nl.includes(e.site) && de(e.telemetrySampleRate), s = {
    [ve.LOG]: i,
    [ve.CONFIGURATION]: i && de(e.telemetryConfigurationSampleRate),
    [ve.USAGE]: i && de(e.telemetryUsageSampleRate)
  }, a = il();
  return tn = (u) => {
    const f = Xe(u);
    if (s[u.type] && o.size < e.maxTelemetryEventsPerPage && !o.has(f)) {
      const l = c(n, t, u, a);
      r.notify(l), Zr("telemetry", l), o.add(f);
    }
  }, ys.drain(), Nc(eo), {
    enabled: i
  };
  function c(u, f, l, g) {
    const O = xt(), E = u.triggerHook(1, {
      startTime: O.relative
    }), A = {
      type: "telemetry",
      date: O.timeStamp,
      service: f,
      version: "6.14.0",
      source: "browser",
      _dd: {
        format_version: 2
      },
      telemetry: Vt(l, {
        runtime_env: g,
        connectivity: ss(),
        sdk_setup: "npm"
      }),
      experimental_features: Array.from(ku())
    };
    return Vt(A, E);
  }
}
function ol(t, e, n, r, o) {
  const i = [];
  if (ie()) {
    const s = Qe(), a = o.subscribe((c) => s.send("internal_telemetry", c));
    i.push(() => a.unsubscribe());
  } else {
    const s = to(
      t,
      {
        endpoint: t.rumEndpointBuilder,
        encoder: r(
          4
          /* DeflateEncoderStreamId.TELEMETRY */
        )
      },
      t.replica && {
        endpoint: t.replica.rumEndpointBuilder,
        encoder: r(
          5
          /* DeflateEncoderStreamId.TELEMETRY_REPLICA */
        )
      },
      e,
      n,
      // We don't use an actual session expire observable here, to make telemetry collection
      // independent of the session. This allows to start and send telemetry events ealier.
      new nt()
    );
    i.push(() => s.stop());
    const a = o.subscribe((c) => s.add(c, sl(t)));
    i.push(() => a.unsubscribe());
  }
  return {
    stop: () => i.forEach((s) => s())
  };
}
function il() {
  return {
    is_local_file: window.location.protocol === "file:",
    is_worker: "WorkerGlobalScope" in self
  };
}
function sl(t) {
  return t.site === is;
}
function se(t, e) {
  Br(Et.debug, t, e), tn({
    type: ve.LOG,
    message: t,
    status: "debug",
    ...e
  });
}
function eo(t, e) {
  tn({
    type: ve.LOG,
    status: "error",
    ...al(t),
    ...e
  });
}
function Es(t) {
  tn({
    type: ve.CONFIGURATION,
    configuration: t
  });
}
function Nt(t) {
  tn({
    type: ve.USAGE,
    usage: t
  });
}
function al(t) {
  if (Te(t)) {
    const e = Je(t);
    return {
      error: {
        kind: e.name,
        stack: Ze(cl(e))
      },
      message: e.message
    };
  }
  return {
    error: {
      stack: ns
    },
    message: `Uncaught ${Xe(t)}`
  };
}
function cl(t) {
  return t.stack = t.stack.filter((e) => !e.url || el.some((n) => e.url.startsWith(n))), t;
}
const ul = 10, ll = 100, dl = Pt, ws = "--", Ss = [];
let Un;
function be(t, e, n = 0) {
  var r;
  const { isLockEnabled: o, persistSession: i, expireSession: s } = e, a = (g) => i({ ...g, lock: u }), c = () => {
    const { lock: g, ...O } = e.retrieveSession();
    return {
      session: O,
      lock: g && !pl(g) ? g : void 0
    };
  };
  if (Un || (Un = t), t !== Un) {
    Ss.push(t);
    return;
  }
  if (o && n >= ll) {
    se("Aborted session operation after max lock retries", {
      currentStore: c()
    }), Bo(e);
    return;
  }
  let u, f = c();
  if (o) {
    if (f.lock) {
      An(t, e, n);
      return;
    }
    if (u = fl(), a(f.session), f = c(), f.lock !== u) {
      An(t, e, n);
      return;
    }
  }
  let l = t.process(f.session);
  if (o && (f = c(), f.lock !== u)) {
    An(t, e, n);
    return;
  }
  if (l && (Gn(l) ? s(l) : (Wi(l), o ? a(l) : i(l))), o && !(l && Gn(l))) {
    if (f = c(), f.lock !== u) {
      An(t, e, n);
      return;
    }
    i(f.session), l = f.session;
  }
  (r = t.after) === null || r === void 0 || r.call(t, l || f.session), Bo(e);
}
function An(t, e, n) {
  At(() => {
    be(t, e, n + 1);
  }, ul);
}
function Bo(t) {
  Un = void 0;
  const e = Ss.shift();
  e && be(e, t);
}
function fl() {
  return Ot() + ws + It();
}
function pl(t) {
  const [, e] = t.split(ws);
  return !e || Ct(Number(e), It()) > dl;
}
const Fo = Pt;
function hl(t) {
  switch (t.sessionPersistence) {
    case gn.COOKIE:
      return No(t);
    case gn.LOCAL_STORAGE:
      return Uo();
    case void 0: {
      let e = No(t);
      return !e && t.allowFallbackToLocalStorage && (e = Uo()), e;
    }
    default:
      X.error(`Invalid session persistence '${String(t.sessionPersistence)}'`);
  }
}
function gl(t, e) {
  return t.type === gn.COOKIE ? Qc(e, t.cookieOptions) : nu(e);
}
function ml(t, e, n, r, o = gl(t, e)) {
  const i = new nt(), s = new nt(), a = new nt(), c = qe(O, Fo);
  let u;
  A();
  const { throttled: f, cancel: l } = Jn(() => {
    be({
      process: (b) => {
        if (Pn(b))
          return;
        const C = E(b);
        return v(C), C;
      },
      after: (b) => {
        Yi(b) && !x() && R(b), u = b;
      }
    }, o);
  }, Fo);
  function g() {
    be({
      process: (b) => x() ? E(b) : void 0
    }, o);
  }
  function O() {
    const b = o.retrieveSession();
    Gn(b) ? be({
      process: (C) => _e(C, e),
      after: E
    }, o) : E(b);
  }
  function E(b) {
    return Gn(b) && (b = _e(b, e)), x() && (k(b) ? T() : (a.notify({ previousState: u, newState: b }), u = b)), b;
  }
  function A() {
    be({
      process: (b) => {
        if (Pn(b))
          return _e(b, e);
      },
      after: (b) => {
        u = b;
      }
    }, o);
  }
  function v(b) {
    if (Pn(b))
      return !1;
    const C = r(b[n]);
    b[n] = C, delete b.isExpired, C !== Hi && !b.id && (b.id = Ot(), b.created = String(Yt()));
  }
  function x() {
    return (u == null ? void 0 : u[n]) !== void 0;
  }
  function k(b) {
    return u.id !== b.id || u[n] !== b[n];
  }
  function T() {
    u = _e(u, e), s.notify();
  }
  function R(b) {
    u = b, i.notify();
  }
  function U(b) {
    be({
      process: (C) => ({ ...C, ...b }),
      after: E
    }, o);
  }
  return {
    expandOrRenewSession: f,
    expandSession: g,
    getSession: () => u,
    renewObservable: i,
    expireObservable: s,
    sessionStateUpdateObservable: a,
    restartSession: A,
    expire: () => {
      l(), o.expireSession(u), E(_e(u, e));
    },
    stop: () => {
      Xn(c);
    },
    updateSessionState: U
  };
}
const $r = {
  GRANTED: "granted",
  NOT_GRANTED: "not-granted"
};
function Ts(t) {
  const e = new nt();
  return {
    tryToInit(n) {
      t || (t = n);
    },
    update(n) {
      t = n, e.notify();
    },
    isGranted() {
      return t === $r.GRANTED;
    },
    observable: e
  };
}
function no(t) {
  const e = Ce(t);
  return e === "string" || e === "function" || t instanceof RegExp;
}
function ro(t, e, n = !1) {
  return t.some((r) => {
    try {
      if (typeof r == "function")
        return r(e);
      if (r instanceof RegExp)
        return r.test(e);
      if (typeof r == "string")
        return n ? e.startsWith(r) : r === e;
    } catch (o) {
      X.error(o);
    }
    return !1;
  });
}
const _l = ["chrome-extension://", "moz-extension://"];
function Vo(t) {
  return _l.some((e) => t.includes(e));
}
function bl(t, e = new Error().stack) {
  return !Vo(t) && Vo(e || "");
}
const yl = "Running the Browser SDK in a Web extension content script is discouraged and will be forbidden in a future major release unless the `allowedTrackingOrigins` option is provided.", vl = "SDK initialized on a non-allowed domain.";
function El(t, e = typeof location < "u" ? location.origin : "", n) {
  const r = t.allowedTrackingOrigins;
  if (!r)
    return bl(e, n) && X.warn(yl), !0;
  const o = ro(r, e);
  return o || X.error(vl), o;
}
function oo(t) {
  return io(t, location.href).href;
}
function wl(t) {
  try {
    return !!io(t);
  } catch {
    return !1;
  }
}
function Sl(t) {
  const e = io(t).pathname;
  return e[0] === "/" ? e : `/${e}`;
}
function io(t, e) {
  const n = Tl();
  if (n)
    try {
      return e !== void 0 ? new n(t, e) : new n(t);
    } catch (i) {
      throw new Error(`Failed to construct URL: ${String(i)} ${Xe({ url: t, base: e })}`);
    }
  if (e === void 0 && !/:/.test(t))
    throw new Error(`Invalid URL: '${t}'`);
  let r = document;
  const o = r.createElement("a");
  if (e !== void 0) {
    r = document.implementation.createHTMLDocument("");
    const i = r.createElement("base");
    i.href = e, r.head.appendChild(i), r.body.appendChild(o);
  }
  return o.href = t, o;
}
const $o = URL;
let In;
function Tl() {
  if (In === void 0)
    try {
      In = new $o("http://test/path").href === "http://test/path";
    } catch {
      In = !1;
    }
  return In ? $o : void 0;
}
function De(t, e, n) {
  const r = Cl(t, e);
  return {
    build(o, i) {
      const s = Al(t, e, n, o, i);
      return r(s);
    },
    tags: n,
    urlPrefix: r(""),
    trackType: e
  };
}
function Cl(t, e) {
  const n = `/api/v2/${e}`, r = t.proxy;
  if (typeof r == "string") {
    const i = oo(r);
    return (s) => `${i}?ddforward=${encodeURIComponent(`${n}?${s}`)}`;
  }
  if (typeof r == "function")
    return (i) => r({ path: n, parameters: i });
  const o = Cs(e, t);
  return (i) => `https://${o}${n}?${i}`;
}
function Cs(t, e) {
  const { site: n = ye, internalAnalyticsSubdomain: r } = e;
  if (t === "logs" && e.usePciIntake && n === ye)
    return Uu;
  if (r && n === ye)
    return `${r}.${ye}`;
  if (n === Lu)
    return `http-intake.logs.${n}`;
  const o = n.split("."), i = o.pop();
  return `browser-intake-${o.join("-")}.${i}`;
}
function Al({ clientToken: t, internalAnalyticsSubdomain: e }, n, r, o, { retry: i, encoding: s }) {
  const a = ["sdk_version:6.14.0", `api:${o}`].concat(r);
  i && a.push(`retry_count:${i.count}`, `retry_after:${i.lastFailureStatus}`);
  const c = [
    "ddsource=browser",
    `ddtags=${encodeURIComponent(a.join(","))}`,
    `dd-api-key=${t}`,
    `dd-evp-origin-version=${encodeURIComponent("6.14.0")}`,
    "dd-evp-origin=browser",
    `dd-request-id=${Ot()}`
  ];
  return s && c.push(`dd-evp-encoding=${s}`), n === "rum" && c.push(`batch_time=${It()}`), e && c.reverse(), c.join("&");
}
const Il = 200;
function Rl(t) {
  const { env: e, service: n, version: r, datacenter: o } = t, i = [];
  return e && i.push(Rn("env", e)), n && i.push(Rn("service", n)), r && i.push(Rn("version", r)), o && i.push(Rn("datacenter", o)), i;
}
function Rn(t, e) {
  const n = Il - t.length - 1;
  (e.length > n || xl(e)) && X.warn(`${t} value doesn't meet tag requirements and will be sanitized. ${Yr} ${Wn}/getting_started/tagging/#defining-tags`);
  const r = e.replace(/,/g, "_");
  return `${t}:${r}`;
}
function xl(t) {
  return Ol() ? new RegExp("[^\\p{Ll}\\p{Lo}0-9_:./-]", "u").test(t) : !1;
}
function Ol() {
  try {
    return new RegExp("[\\p{Ll}]", "u"), !0;
  } catch {
    return !1;
  }
}
function kl(t) {
  const e = t.site || ye, n = Rl(t), r = Ll(t, n);
  return {
    replica: Nl(t, n),
    site: e,
    ...r
  };
}
function Ll(t, e) {
  return {
    logsEndpointBuilder: De(t, "logs", e),
    rumEndpointBuilder: De(t, "rum", e),
    profilingEndpointBuilder: De(t, "profile", e),
    sessionReplayEndpointBuilder: De(t, "replay", e)
  };
}
function Nl(t, e) {
  if (!t.replica)
    return;
  const n = {
    ...t,
    site: ye,
    clientToken: t.replica.clientToken
  }, r = {
    logsEndpointBuilder: De(n, "logs", e),
    rumEndpointBuilder: De(n, "rum", e)
  };
  return { applicationId: t.replica.applicationId, ...r };
}
function As(t) {
  return Mu.every((e) => t.includes(e));
}
const ln = {
  ALLOW: "allow",
  MASK: "mask",
  MASK_USER_INPUT: "mask-user-input"
}, jr = {
  ALL: "all",
  SAMPLED: "sampled"
};
function br(t, e) {
  return t != null && typeof t != "string" ? (X.error(`${e} must be defined as a string`), !1) : !0;
}
function Pl(t) {
  return t && typeof t == "string" && !/(datadog|ddog|datad0g|dd0g)/.test(t) ? (X.error(`Site should be a valid Datadog site. ${Yr} ${Wn}/getting_started/site/.`), !1) : !0;
}
function Be(t, e) {
  return t !== void 0 && !Sc(t) ? (X.error(`${e} Sample Rate should be a number between 0 and 100`), !1) : !0;
}
function Is(t) {
  var e, n, r, o, i, s;
  if (!t || !t.clientToken) {
    X.error("Client Token is not configured, we will not send any data.");
    return;
  }
  if (t.allowedTrackingOrigins !== void 0 && !Array.isArray(t.allowedTrackingOrigins)) {
    X.error("Allowed Tracking Origins must be an array");
    return;
  }
  if (!(!Pl(t.site) || !Be(t.sessionSampleRate, "Session") || !Be(t.telemetrySampleRate, "Telemetry") || !Be(t.telemetryConfigurationSampleRate, "Telemetry Configuration") || !Be(t.telemetryUsageSampleRate, "Telemetry Usage") || !br(t.version, "Version") || !br(t.env, "Env") || !br(t.service, "Service") || !El(t))) {
    if (t.trackingConsent !== void 0 && !Vn($r, t.trackingConsent)) {
      X.error('Tracking Consent should be either "granted" or "not-granted"');
      return;
    }
    return {
      beforeSend: t.beforeSend && Ni(t.beforeSend, "beforeSend threw an error:"),
      sessionStoreStrategyType: hl(t),
      sessionSampleRate: (e = t.sessionSampleRate) !== null && e !== void 0 ? e : 100,
      telemetrySampleRate: (n = t.telemetrySampleRate) !== null && n !== void 0 ? n : 20,
      telemetryConfigurationSampleRate: (r = t.telemetryConfigurationSampleRate) !== null && r !== void 0 ? r : 5,
      telemetryUsageSampleRate: (o = t.telemetryUsageSampleRate) !== null && o !== void 0 ? o : 5,
      service: t.service || void 0,
      silentMultipleInit: !!t.silentMultipleInit,
      allowUntrustedEvents: !!t.allowUntrustedEvents,
      trackingConsent: (i = t.trackingConsent) !== null && i !== void 0 ? i : $r.GRANTED,
      trackAnonymousUser: (s = t.trackAnonymousUser) !== null && s !== void 0 ? s : !0,
      storeContextsAcrossPages: !!t.storeContextsAcrossPages,
      /**
       * beacon payload max queue size implementation is 64kb
       * ensure that we leave room for logs, rum and potential other users
       */
      batchBytesLimit: 16 * je,
      eventRateLimiterThreshold: 3e3,
      maxTelemetryEventsPerPage: 15,
      /**
       * flush automatically, aim to be lower than ALB connection timeout
       * to maximize connection reuse.
       */
      flushTimeout: 30 * Pt,
      /**
       * Logs intake limit
       */
      batchMessagesLimit: 50,
      messageBytesLimit: 256 * je,
      ...kl(t)
    };
  }
}
function Rs(t) {
  return {
    session_sample_rate: t.sessionSampleRate,
    telemetry_sample_rate: t.telemetrySampleRate,
    telemetry_configuration_sample_rate: t.telemetryConfigurationSampleRate,
    telemetry_usage_sample_rate: t.telemetryUsageSampleRate,
    use_before_send: !!t.beforeSend,
    use_partitioned_cross_site_session_cookie: t.usePartitionedCrossSiteSessionCookie,
    use_secure_session_cookie: t.useSecureSessionCookie,
    use_proxy: !!t.proxy,
    silent_multiple_init: t.silentMultipleInit,
    track_session_across_subdomains: t.trackSessionAcrossSubdomains,
    track_anonymous_user: t.trackAnonymousUser,
    session_persistence: t.sessionPersistence,
    allow_fallback_to_local_storage: !!t.allowFallbackToLocalStorage,
    store_contexts_across_pages: !!t.storeContextsAcrossPages,
    allow_untrusted_events: !!t.allowUntrustedEvents,
    tracking_consent: t.trackingConsent,
    use_allowed_tracking_origins: Array.isArray(t.allowedTrackingOrigins)
  };
}
function Jt(t, e, n, { computeHandlingStack: r } = {}) {
  let o = t[e];
  if (typeof o != "function")
    if (e in t && e.startsWith("on"))
      o = it;
    else
      return { stop: it };
  let i = !1;
  const s = function() {
    if (i)
      return o.apply(this, arguments);
    const a = Array.from(arguments);
    let c;
    Ee(n, null, [
      {
        target: this,
        parameters: a,
        onPostCall: (f) => {
          c = f;
        },
        handlingStack: r ? He("instrumented method") : void 0
      }
    ]);
    const u = o.apply(this, a);
    return c && Ee(c, null, [u]), u;
  };
  return t[e] = s, {
    stop: () => {
      i = !0, t[e] === s && (t[e] = o);
    }
  };
}
function r_(t, e, n) {
  const r = Object.getOwnPropertyDescriptor(t, e);
  if (!r || !r.set || !r.configurable)
    return { stop: it };
  const o = it;
  let i = (a, c) => {
    At(() => {
      i !== o && n(a, c);
    }, 0);
  };
  const s = function(a) {
    r.set.call(this, a), i(this, a);
  };
  return Object.defineProperty(t, e, {
    set: s
  }), {
    stop: () => {
      var a;
      ((a = Object.getOwnPropertyDescriptor(t, e)) === null || a === void 0 ? void 0 : a.set) === s && Object.defineProperty(t, e, r), i = o;
    }
  };
}
function Ul() {
  return new nt((t) => {
    const e = (o, i) => {
      const s = Qn({
        stackTrace: i,
        originalError: o,
        startClocks: xt(),
        nonErrorPrefix: "Uncaught",
        source: jt.SOURCE,
        handling: "unhandled"
      });
      t.notify(s);
    }, { stop: n } = Ml(e), { stop: r } = Dl(e);
    return () => {
      n(), r();
    };
  });
}
function Ml(t) {
  return Jt(qt(), "onerror", ({ parameters: [e, n, r, o, i] }) => {
    let s;
    Te(i) || (s = Eu(e, n, r, o)), t(i ?? e, s);
  });
}
function Dl(t) {
  return Jt(qt(), "onunhandledrejection", ({ parameters: [e] }) => {
    t(e.reason || "Empty reason");
  });
}
function xs(t) {
  const e = {
    version: "6.14.0",
    // This API method is intentionally not monitored, since the only thing executed is the
    // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
    // we don't want to interfere with the user uncaught exceptions.
    onReady(n) {
      n();
    },
    ...t
  };
  return Object.defineProperty(e, "_setDebug", {
    get() {
      return Pc;
    },
    enumerable: !1
  }), e;
}
function Os(t, e, n) {
  const r = t[e];
  r && !r.q && r.version && X.warn("SDK is loaded more than once. This is unsupported and might have unexpected behavior."), t[e] = n, r && r.q && r.q.forEach((o) => Ni(o, "onReady callback threw an error:")());
}
function er(t, e) {
  e.silentMultipleInit || X.error(`${t} is already initialized.`);
}
const Ke = {
  intervention: "intervention",
  deprecation: "deprecation",
  cspViolation: "csp_violation"
};
function ks(t, e) {
  const n = [];
  e.includes(Ke.cspViolation) && n.push(Fl(t));
  const r = e.filter((o) => o !== Ke.cspViolation);
  return r.length && n.push(Bl(r)), Vi(...n);
}
function Bl(t) {
  return new nt((e) => {
    if (!window.ReportingObserver)
      return;
    const n = G((o, i) => o.forEach((s) => e.notify(Vl(s)))), r = new window.ReportingObserver(n, {
      types: t,
      buffered: !0
    });
    return r.observe(), () => {
      r.disconnect();
    };
  });
}
function Fl(t) {
  return new nt((e) => {
    const { stop: n } = mt(t, document, "securitypolicyviolation", (r) => {
      e.notify($l(r));
    });
    return n;
  });
}
function Vl(t) {
  const { type: e, body: n } = t;
  return Ls({
    type: n.id,
    message: `${e}: ${n.message}`,
    originalError: t,
    stack: Ns(n.id, n.message, n.sourceFile, n.lineNumber, n.columnNumber)
  });
}
function $l(t) {
  const e = `'${t.blockedURI}' blocked by '${t.effectiveDirective}' directive`;
  return Ls({
    type: t.effectiveDirective,
    message: `${Ke.cspViolation}: ${e}`,
    originalError: t,
    csp: {
      disposition: t.disposition
    },
    stack: Ns(t.effectiveDirective, t.originalPolicy ? `${e} of the policy "${$i(t.originalPolicy, 100, "...")}"` : "no policy", t.sourceFile, t.lineNumber, t.columnNumber)
  });
}
function Ls(t) {
  return {
    startClocks: xt(),
    source: jt.REPORT,
    handling: "unhandled",
    ...t
  };
}
function Ns(t, e, n, r, o) {
  return n ? Ze({
    name: t,
    message: e,
    stack: [
      {
        func: "?",
        url: n,
        line: r ?? void 0,
        column: o ?? void 0
      }
    ]
  }) : void 0;
}
const xn = 1 / 0, jl = $t;
let on = null;
const Mn = /* @__PURE__ */ new Set();
function zl() {
  Mn.forEach((t) => t());
}
function en({ expireDelay: t, maxEntries: e }) {
  let n = [];
  on || (on = qe(() => zl(), jl));
  const r = () => {
    const f = zt() - t;
    for (; n.length > 0 && n[n.length - 1].endTime < f; )
      n.pop();
  };
  Mn.add(r);
  function o(f, l) {
    const g = {
      value: f,
      startTime: l,
      endTime: xn,
      remove: () => {
        as(n, g);
      },
      close: (O) => {
        g.endTime = O;
      }
    };
    return e && n.length >= e && n.pop(), n.unshift(g), g;
  }
  function i(f = xn, l = { returnInactive: !1 }) {
    for (const g of n)
      if (g.startTime <= f) {
        if (l.returnInactive || f <= g.endTime)
          return g.value;
        break;
      }
  }
  function s(f) {
    const l = n[0];
    l && l.endTime === xn && l.close(f);
  }
  function a(f = xn, l = 0) {
    const g = We(f, l);
    return n.filter((O) => O.startTime <= g && f <= O.endTime).map((O) => O.value);
  }
  function c() {
    n = [];
  }
  function u() {
    Mn.delete(r), Mn.size === 0 && on && (Xn(on), on = null);
  }
  return { add: o, find: i, closeActive: s, findAll: a, reset: c, stop: u };
}
const Gl = "datadog-synthetics-public-id", Hl = "datadog-synthetics-result-id", Kl = "datadog-synthetics-injects-rum";
function nr() {
  return !!(window._DATADOG_SYNTHETICS_INJECTS_RUM || le(Kl));
}
function so() {
  const t = window._DATADOG_SYNTHETICS_PUBLIC_ID || le(Gl);
  return typeof t == "string" ? t : void 0;
}
function ao() {
  const t = window._DATADOG_SYNTHETICS_RESULT_ID || le(Hl);
  return typeof t == "string" ? t : void 0;
}
function Ps() {
  return !!(so() && ao());
}
const Yl = $t, Wl = Se;
function Us(t, e, n, r) {
  const o = new nt(), i = new nt(), s = ml(t.sessionStoreStrategyType, t, e, n), a = en({
    expireDelay: Wl
  });
  s.renewObservable.subscribe(() => {
    a.add(c(), zt()), o.notify();
  }), s.expireObservable.subscribe(() => {
    i.notify(), a.closeActive(zt());
  }), s.expandOrRenewSession(), a.add(c(), Mi().relative), r.observable.subscribe(() => {
    r.isGranted() ? s.expandOrRenewSession() : s.expire();
  }), ql(t, () => {
    r.isGranted() && s.expandOrRenewSession();
  }), Xl(t, () => s.expandSession()), Jl(t, () => s.restartSession());
  function c() {
    const u = s.getSession();
    return u ? {
      id: u.id,
      trackingType: u[e],
      isReplayForced: !!u.forcedReplay,
      anonymousId: u.anonymousId
    } : (Zl().catch(() => {
    }), {
      id: "invalid",
      trackingType: Hi,
      isReplayForced: !1,
      anonymousId: void 0
    });
  }
  return {
    findSession: (u, f) => a.find(u, f),
    renewObservable: o,
    expireObservable: i,
    sessionStateUpdateObservable: s.sessionStateUpdateObservable,
    expire: s.expire,
    updateSessionState: s.updateSessionState
  };
}
function ql(t, e) {
  const { stop: n } = pe(t, window, [
    "click",
    "touchstart",
    "keydown",
    "scroll"
    /* DOM_EVENT.SCROLL */
  ], e, { capture: !0, passive: !0 });
}
function Xl(t, e) {
  const n = () => {
    document.visibilityState === "visible" && e();
  }, { stop: r } = mt(t, document, "visibilitychange", n);
  qe(n, Yl);
}
function Jl(t, e) {
  const { stop: n } = mt(t, window, "resume", e, { capture: !0 });
}
async function Zl() {
  const t = Ji();
  let e = [];
  "cookieStore" in window ? e = await window.cookieStore.getAll("_dd_s") : e = document.cookie.split(/\s*;\s*/).filter((n) => n.startsWith("_dd_s")), se("Unexpected session state", {
    session: t,
    isSyntheticsTest: Ps(),
    createdTimestamp: t == null ? void 0 : t.created,
    expireTimestamp: t == null ? void 0 : t.expire,
    cookie: {
      count: e.length,
      ...e
    }
  });
}
function Kn() {
  let t = "", e = 0;
  return {
    isAsync: !1,
    get isEmpty() {
      return !t;
    },
    write(n, r) {
      const o = Bi(n);
      e += o, t += n, r && r(o);
    },
    finish(n) {
      n(this.finishSync());
    },
    finishSync() {
      const n = {
        output: t,
        outputBytesCount: e,
        rawBytesCount: e,
        pendingData: ""
      };
      return t = "", e = 0, n;
    },
    estimateEncodedBytesCount(n) {
      return n.length;
    }
  };
}
class Ms {
  constructor() {
    this.callbacks = {};
  }
  notify(e, n) {
    const r = this.callbacks[e];
    r && r.forEach((o) => o(n));
  }
  subscribe(e, n) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(n), {
      unsubscribe: () => {
        this.callbacks[e] = this.callbacks[e].filter((r) => n !== r);
      }
    };
  }
}
function Dn(t, e, n) {
  let r = 0, o = !1;
  return {
    isLimitReached() {
      if (r === 0 && At(() => {
        r = 0;
      }, $t), r += 1, r <= e || o)
        return o = !1, !1;
      if (r === e + 1) {
        o = !0;
        try {
          n({
            message: `Reached max number of ${t}s by minute: ${e}`,
            source: jt.AGENT,
            startClocks: xt()
          });
        } finally {
          o = !1;
        }
      }
      return !0;
    }
  };
}
function co(t, e, n) {
  return document.readyState === e || document.readyState === "complete" ? (n(), { stop: it }) : mt(t, window, e === "complete" ? "load" : "DOMContentLoaded", n, { once: !0 });
}
function Ql(t, e) {
  return new Promise((n) => {
    co(t, e, n);
  });
}
let yr;
const uo = /* @__PURE__ */ new WeakMap();
function Ds(t) {
  return yr || (yr = td(t)), yr;
}
function td(t) {
  return new nt((e) => {
    const { stop: n } = Jt(XMLHttpRequest.prototype, "open", ed), { stop: r } = Jt(XMLHttpRequest.prototype, "send", (i) => {
      nd(i, t, e);
    }, { computeHandlingStack: !0 }), { stop: o } = Jt(XMLHttpRequest.prototype, "abort", rd);
    return () => {
      n(), r(), o();
    };
  });
}
function ed({ target: t, parameters: [e, n] }) {
  uo.set(t, {
    state: "open",
    method: String(e).toUpperCase(),
    url: oo(String(n))
  });
}
function nd({ target: t, handlingStack: e }, n, r) {
  const o = uo.get(t);
  if (!o)
    return;
  const i = o;
  i.state = "start", i.startClocks = xt(), i.isAborted = !1, i.xhr = t, i.handlingStack = e;
  let s = !1;
  const { stop: a } = Jt(t, "onreadystatechange", () => {
    t.readyState === XMLHttpRequest.DONE && c();
  }), c = () => {
    if (u(), a(), s)
      return;
    s = !0;
    const f = o;
    f.state = "complete", f.duration = Ct(i.startClocks.timeStamp, It()), f.status = t.status, r.notify(fn(f));
  }, { stop: u } = mt(n, t, "loadend", c);
  r.notify(i);
}
function rd({ target: t }) {
  const e = uo.get(t);
  e && (e.isAborted = !0);
}
let vr;
function rr() {
  return vr || (vr = od()), vr;
}
function od() {
  return new nt((t) => {
    if (!window.fetch)
      return;
    const { stop: e } = Jt(window, "fetch", (n) => id(n, t), {
      computeHandlingStack: !0
    });
    return e;
  });
}
function id({ parameters: t, onPostCall: e, handlingStack: n }, r) {
  const [o, i] = t;
  let s = i && i.method;
  s === void 0 && o instanceof Request && (s = o.method);
  const a = s !== void 0 ? String(s).toUpperCase() : "GET", c = o instanceof Request ? o.url : oo(String(o)), u = xt(), f = {
    state: "start",
    init: i,
    input: o,
    method: a,
    startClocks: u,
    url: c,
    handlingStack: n
  };
  r.notify(f), t[0] = f.input, t[1] = f.init, e((l) => sd(r, l, f));
}
function sd(t, e, n) {
  const r = n;
  function o(i) {
    r.state = "resolve", Object.assign(r, i), t.notify(r);
  }
  e.then(G((i) => {
    o({
      response: i,
      responseType: i.type,
      status: i.status,
      isAborted: !1
    });
  }), G((i) => {
    var s, a;
    o({
      status: 0,
      isAborted: ((a = (s = r.init) === null || s === void 0 ? void 0 : s.signal) === null || a === void 0 ? void 0 : a.aborted) || i instanceof DOMException && i.code === DOMException.ABORT_ERR,
      error: i
    });
  }));
}
function ad(t, e) {
  if (window.requestIdleCallback && window.cancelIdleCallback) {
    const n = window.requestIdleCallback(G(t), e);
    return () => window.cancelIdleCallback(n);
  }
  return ud(t);
}
const cd = 50;
function ud(t) {
  const e = Yt(), n = At(() => {
    t({
      didTimeout: !1,
      timeRemaining: () => Math.max(0, cd - (Yt() - e))
    });
  }, 0);
  return () => Kt(n);
}
const ld = Pt, dd = 30;
function fd() {
  const t = [];
  function e(r) {
    let o;
    if (r.didTimeout) {
      const i = performance.now();
      o = () => dd - (performance.now() - i);
    } else
      o = r.timeRemaining.bind(r);
    for (; o() > 0 && t.length; )
      t.shift()();
    t.length && n();
  }
  function n() {
    ad(e, { timeout: ld });
  }
  return {
    push(r) {
      t.push(r) === 1 && n();
    }
  };
}
let Er = {};
function Bs(t) {
  const e = t.map((n) => (Er[n] || (Er[n] = pd(n)), Er[n]));
  return Vi(...e);
}
function pd(t) {
  return new nt((e) => {
    const n = Xt[t];
    return Xt[t] = (...r) => {
      n.apply(console, r);
      const o = He("console error");
      Ee(() => {
        e.notify(hd(r, t, o));
      });
    }, () => {
      Xt[t] = n;
    };
  });
}
function hd(t, e, n) {
  const r = t.map((o) => gd(o)).join(" ");
  if (e === Et.error) {
    const o = t.find(Te), i = Qn({
      originalError: o,
      handlingStack: n,
      startClocks: xt(),
      source: jt.CONSOLE,
      handling: "handled",
      nonErrorPrefix: "Provided",
      // if no good stack is computed from the error, let's not use the fallback stack message
      // advising the user to use an instance of Error, as console.error is commonly used without an
      // Error instance.
      useFallbackStack: !1
    });
    return i.message = r, {
      api: e,
      message: r,
      handlingStack: n,
      error: i
    };
  }
  return {
    api: e,
    message: r,
    error: void 0,
    handlingStack: n
  };
}
function gd(t) {
  return typeof t == "string" ? ht(t) : Te(t) ? es(Je(t)) : Xe(ht(t), void 0, 2);
}
function md(t) {
  const e = Ce(t) === "object";
  return e || X.error("Unsupported context:", t), e;
}
function wr(t, e, n) {
  const r = { ...t };
  for (const [o, { required: i, type: s }] of Object.entries(e))
    s === "string" && !jo(r[o]) && (r[o] = String(r[o])), i && jo(r[o]) && X.warn(`The property ${o} of ${n} is required; context will not be sent to the intake.`);
  return r;
}
function jo(t) {
  return t == null || t === "";
}
function wn(t = "", { propertiesConfig: e = {} } = {}) {
  let n = {};
  const r = new nt(), o = {
    getContext: () => tr(n),
    setContext: (i) => {
      md(i) ? n = ht(wr(i, e, t)) : o.clearContext(), r.notify();
    },
    setContextProperty: (i, s) => {
      n = ht(wr({ ...n, [i]: s }, e, t)), r.notify();
    },
    removeContextProperty: (i) => {
      delete n[i], wr(n, e, t), r.notify();
    },
    clearContext: () => {
      n = {}, r.notify();
    },
    changeObservable: r
  };
  return o;
}
function st(t, e, n, r) {
  return G((...o) => (r && Nt({ feature: r }), t()[e][n](...o)));
}
function Sr(t, e, n) {
  t.changeObservable.subscribe(() => {
    const r = t.getContext();
    n.add((o) => o[e].setContext(r));
  });
}
const _d = "_dd_c", bd = [];
function lo(t, e, n, r) {
  const o = yd(n, r);
  bd.push(mt(t, window, "storage", ({ key: u }) => {
    o === u && s();
  })), e.changeObservable.subscribe(a);
  const i = Vt(c(), e.getContext());
  we(i) || e.setContext(i);
  function s() {
    e.setContext(c());
  }
  function a() {
    localStorage.setItem(o, JSON.stringify(e.getContext()));
  }
  function c() {
    const u = localStorage.getItem(o);
    return u ? JSON.parse(u) : {};
  }
}
function yd(t, e) {
  return `${_d}_${t}_${e}`;
}
const he = "DISCARDED", Ft = "SKIPPED";
function Fs() {
  const t = {};
  return {
    register(e, n) {
      return t[e] || (t[e] = []), t[e].push(n), {
        unregister: () => {
          t[e] = t[e].filter((r) => r !== n);
        }
      };
    },
    triggerHook(e, n) {
      const r = t[e] || [], o = [];
      for (const i of r) {
        const s = i(n);
        if (s === he)
          return he;
        s !== Ft && o.push(s);
      }
      return Vt(...o);
    }
  };
}
function Vs(t, e, n) {
  const r = fo();
  return e.storeContextsAcrossPages && lo(
    e,
    r,
    n,
    4
    /* CustomerDataType.Account */
  ), t.register(0, () => {
    const o = r.getContext();
    return we(o) || !o.id ? Ft : {
      account: o
    };
  }), r;
}
function fo() {
  return wn("account", {
    propertiesConfig: {
      id: { type: "string", required: !0 },
      name: { type: "string" }
    }
  });
}
function $s(t, e, n, r) {
  const o = po();
  return e.storeContextsAcrossPages && lo(
    e,
    o,
    n,
    2
    /* CustomerDataType.GlobalContext */
  ), t.register(0, () => {
    const i = o.getContext();
    return r ? { context: i } : i;
  }), o;
}
function po() {
  return wn("global context");
}
function js(t, e, n, r) {
  const o = ho();
  return e.storeContextsAcrossPages && lo(
    e,
    o,
    r,
    1
    /* CustomerDataType.User */
  ), t.register(0, ({ eventType: i, startTime: s }) => {
    const a = o.getContext(), c = n.findTrackedSession(s);
    return c && c.anonymousId && !a.anonymous_id && e.trackAnonymousUser && (a.anonymous_id = c.anonymousId), we(a) ? Ft : {
      type: i,
      usr: a
    };
  }), t.register(1, ({ startTime: i }) => {
    var s;
    return {
      anonymous_id: (s = n.findTrackedSession(i)) === null || s === void 0 ? void 0 : s.anonymousId
    };
  }), o;
}
function ho() {
  return wn("user", {
    propertiesConfig: {
      id: { type: "string" },
      name: { type: "string" },
      email: { type: "string" }
    }
  });
}
const Z = {
  userContext: "userContext",
  globalContext: "globalContext",
  accountContext: "accountContext"
}, at = {
  getContext: "getContext",
  setContext: "setContext",
  setContextProperty: "setContextProperty",
  removeContextProperty: "removeContextProperty",
  clearContext: "clearContext"
};
function zs(t, e, n) {
  const r = t.getReader(), o = [];
  let i = 0;
  s();
  function s() {
    r.read().then(G((c) => {
      if (c.done) {
        a();
        return;
      }
      n.collectStreamBody && o.push(c.value), i += c.value.length, i > n.bytesLimit ? a() : s();
    }), G((c) => e(c)));
  }
  function a() {
    r.cancel().catch(
      // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
      // as an unhandled rejection
      it
    );
    let c, u;
    if (n.collectStreamBody) {
      let f;
      if (o.length === 1)
        f = o[0];
      else {
        f = new Uint8Array(i);
        let l = 0;
        o.forEach((g) => {
          f.set(g, l), l += g.length;
        });
      }
      c = f.slice(0, n.bytesLimit), u = f.length > n.bytesLimit;
    }
    e(void 0, c, u);
  }
}
const Bt = {
  DOCUMENT: "document",
  XHR: "xhr",
  BEACON: "beacon",
  FETCH: "fetch",
  CSS: "css",
  JS: "js",
  IMAGE: "image",
  FONT: "font",
  MEDIA: "media",
  OTHER: "other"
}, Ye = {
  FETCH: Bt.FETCH,
  XHR: Bt.XHR
}, vd = 500;
function Gs(t = Ul) {
  const e = new Mc(vd), n = t().subscribe((r) => {
    e.notify({
      type: 0,
      error: r
    });
  });
  return {
    observable: e,
    stop: () => {
      n.unsubscribe();
    }
  };
}
function Ed() {
  try {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return;
  }
}
function Yn(t, e, n) {
  const r = n.getHandler(), o = Array.isArray(r) ? r : [r];
  return zo[t] >= zo[n.getLevel()] && o.includes(e);
}
const W = {
  ok: "ok",
  debug: "debug",
  info: "info",
  notice: "notice",
  warn: "warn",
  error: "error",
  critical: "critical",
  alert: "alert",
  emerg: "emerg"
}, zo = {
  [W.ok]: 0,
  [W.debug]: 1,
  [W.info]: 2,
  [W.notice]: 4,
  [W.warn]: 5,
  [W.error]: 6,
  [W.critical]: 7,
  [W.alert]: 8,
  [W.emerg]: 9
};
function or(t, {
  /**
   * Set this to `true` to include the error message in the error field. In most cases, the error
   * message is already included in the log message, so we don't need to include it again.
   */
  includeMessage: e = !1
} = {}) {
  return {
    stack: t.stack,
    kind: t.type,
    message: e ? t.message : void 0,
    causes: t.causes,
    fingerprint: t.fingerprint,
    handling: t.handling
  };
}
var wd = function(t, e, n, r) {
  var o = arguments.length, i = o < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, n) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(t, e, n, r);
  else for (var a = t.length - 1; a >= 0; a--) (s = t[a]) && (i = (o < 3 ? s(i) : o > 3 ? s(e, n, i) : s(e, n)) || i);
  return o > 3 && i && Object.defineProperty(e, n, i), i;
};
const _n = {
  console: "console",
  http: "http"
}, Sd = Object.keys(W);
class Wt {
  constructor(e, n, r = _n.http, o = W.debug, i = {}) {
    this.handleLogStrategy = e, this.handlerType = r, this.level = o, this.contextManager = wn("logger"), this.contextManager.setContext(i), n && this.contextManager.setContextProperty("logger", { name: n });
  }
  logImplementation(e, n, r = W.info, o, i) {
    const s = ht(n);
    let a;
    if (o != null) {
      const c = Qn({
        originalError: o,
        nonErrorPrefix: "Provided",
        source: jt.LOGGER,
        handling: "handled",
        startClocks: xt()
      });
      a = Vt({
        error: or(c, { includeMessage: !0 })
      }, c.context, s);
    } else
      a = s;
    this.handleLogStrategy({
      message: ht(e),
      context: a,
      status: r
    }, this, i);
  }
  log(e, n, r = W.info, o) {
    let i;
    Yn(r, _n.http, this) && (i = He("log")), this.logImplementation(e, n, r, o, i);
  }
  setContext(e) {
    this.contextManager.setContext(e);
  }
  getContext() {
    return this.contextManager.getContext();
  }
  setContextProperty(e, n) {
    this.contextManager.setContextProperty(e, n);
  }
  removeContextProperty(e) {
    this.contextManager.removeContextProperty(e);
  }
  clearContext() {
    this.contextManager.clearContext();
  }
  setHandler(e) {
    this.handlerType = e;
  }
  getHandler() {
    return this.handlerType;
  }
  setLevel(e) {
    this.level = e;
  }
  getLevel() {
    return this.level;
  }
}
wd([
  Uc
], Wt.prototype, "logImplementation", null);
Wt.prototype.ok = ae(W.ok);
Wt.prototype.debug = ae(W.debug);
Wt.prototype.info = ae(W.info);
Wt.prototype.notice = ae(W.notice);
Wt.prototype.warn = ae(W.warn);
Wt.prototype.error = ae(W.error);
Wt.prototype.critical = ae(W.critical);
Wt.prototype.alert = ae(W.alert);
Wt.prototype.emerg = ae(W.emerg);
function ae(t) {
  return function(e, n, r) {
    let o;
    Yn(t, _n.http, this) && (o = He("log")), this.logImplementation(e, n, t, r, o);
  };
}
function Go() {
  return {
    view: {
      referrer: document.referrer,
      url: window.location.href
    }
  };
}
const Td = 32 * je;
function Cd(t) {
  t.usePciIntake === !0 && t.site && t.site !== "datadoghq.com" && X.warn("PCI compliance for Logs is only available for Datadog organizations in the US1 site. Default intake will be used.");
  const e = Is(t), n = Ho(t.forwardConsoleLogs, zn(Et), "Forward Console Logs"), r = Ho(t.forwardReports, zn(Ke), "Forward Reports");
  if (!(!e || !n || !r))
    return t.forwardErrorsToLogs && !n.includes(Et.error) && n.push(Et.error), {
      forwardErrorsToLogs: t.forwardErrorsToLogs !== !1,
      forwardConsoleLogs: n,
      forwardReports: r,
      requestErrorResponseLengthLimit: Td,
      ...e
    };
}
function Ho(t, e, n) {
  if (t === void 0)
    return [];
  if (!(t === "all" || Array.isArray(t) && t.every((r) => e.includes(r)))) {
    X.error(`${n} should be "all" or an array with allowed values "${e.join('", "')}"`);
    return;
  }
  return t === "all" ? e : Bu(t);
}
function Ad(t) {
  const e = Rs(t);
  return {
    forward_errors_to_logs: t.forwardErrorsToLogs,
    forward_console_logs: t.forwardConsoleLogs,
    forward_reports: t.forwardReports,
    use_pci_intake: t.usePciIntake,
    ...e
  };
}
function Id(t, e, n) {
  const r = Qr(), o = po();
  Sr(o, Z.globalContext, r);
  const i = fo();
  Sr(i, Z.accountContext, r);
  const s = ho();
  Sr(s, Z.userContext, r);
  let a, c;
  const u = e.observable.subscribe(f);
  function f() {
    if (!c || !a || !e.isGranted())
      return;
    u.unsubscribe();
    const l = n(a, c);
    r.drain(l);
  }
  return {
    init(l) {
      if (!l) {
        X.error("Missing configuration");
        return;
      }
      if (rs(l.enableExperimentalFeatures), ie() && (l = Rd(l)), a = l, At(() => {
        Es(Ad(l));
      }), c) {
        er("DD_LOGS", l);
        return;
      }
      const g = Cd(l);
      g && (c = g, rr().subscribe(it), e.tryToInit(g.trackingConsent), f());
    },
    get initConfiguration() {
      return a;
    },
    globalContext: o,
    accountContext: i,
    userContext: s,
    getInternalContext: it,
    handleLog(l, g, O, E = t(), A = It()) {
      r.add((v) => v.handleLog(l, g, O, E, A));
    }
  };
}
function Rd(t) {
  return { ...t, clientToken: "empty" };
}
function xd(t) {
  const e = Ts(), n = Gs().observable;
  let r = Id(Go, e, (a, c) => {
    const u = t(c, Go, e, n);
    return r = Od(a, u), u;
  });
  const o = () => r, i = {}, s = new Wt((...a) => r.handleLog(...a));
  return xs({
    logger: s,
    init: G((a) => r.init(a)),
    setTrackingConsent: G((a) => {
      e.update(a), Nt({ feature: "set-tracking-consent", tracking_consent: a });
    }),
    getGlobalContext: st(o, Z.globalContext, at.getContext),
    setGlobalContext: st(o, Z.globalContext, at.setContext),
    setGlobalContextProperty: st(o, Z.globalContext, at.setContextProperty),
    removeGlobalContextProperty: st(o, Z.globalContext, at.removeContextProperty),
    clearGlobalContext: st(o, Z.globalContext, at.clearContext),
    createLogger: G((a, c = {}) => (i[a] = new Wt((...u) => r.handleLog(...u), ht(a), c.handler, c.level, ht(c.context)), i[a])),
    getLogger: G((a) => i[a]),
    getInitConfiguration: G(() => tr(r.initConfiguration)),
    getInternalContext: G((a) => r.getInternalContext(a)),
    setUser: st(o, Z.userContext, at.setContext),
    getUser: st(o, Z.userContext, at.getContext),
    setUserProperty: st(o, Z.userContext, at.setContextProperty),
    removeUserProperty: st(o, Z.userContext, at.removeContextProperty),
    clearUser: st(o, Z.userContext, at.clearContext),
    setAccount: st(o, Z.accountContext, at.setContext),
    getAccount: st(o, Z.accountContext, at.getContext),
    setAccountProperty: st(o, Z.accountContext, at.setContextProperty),
    removeAccountProperty: st(o, Z.accountContext, at.removeContextProperty),
    clearAccount: st(o, Z.accountContext, at.clearContext)
  });
}
function Od(t, e) {
  return {
    init: (n) => {
      er("DD_LOGS", n);
    },
    initConfiguration: t,
    ...e
  };
}
const kd = "logs";
function Ld(t, e) {
  const n = Us(t, kd, (r) => Hs(t, r), e);
  return {
    findTrackedSession: (r, o = { returnInactive: !1 }) => {
      const i = n.findSession(r, o);
      return i && i.trackingType === "1" ? {
        id: i.id,
        anonymousId: i.anonymousId
      } : void 0;
    },
    expireObservable: n.expireObservable
  };
}
function Nd(t) {
  const n = Hs(t) === "1" ? {} : void 0;
  return {
    findTrackedSession: () => n,
    expireObservable: new nt()
  };
}
function Hs(t, e) {
  return Pd(e) ? e : de(t.sessionSampleRate) ? "1" : "0";
}
function Pd(t) {
  return t === "0" || t === "1";
}
function Ud(t, e, n, r, o) {
  const i = Sd.concat(["custom"]), s = {};
  i.forEach((a) => {
    s[a] = Dn(a, t.eventRateLimiterThreshold, o);
  }), e.subscribe(0, ({ rawLogsEvent: a, messageContext: c = void 0, savedCommonContext: u = void 0, domainContext: f }) => {
    var l, g;
    const O = qn(a.date), E = u || r(), A = n.triggerHook(0, {
      startTime: O
    });
    if (A === he)
      return;
    const v = Vt({
      view: E.view
    }, A, a, c);
    ((l = t.beforeSend) === null || l === void 0 ? void 0 : l.call(t, v, f)) === !1 || v.origin !== jt.AGENT && ((g = s[v.status]) !== null && g !== void 0 ? g : s.custom).isLimitReached() || e.notify(1, v);
  });
}
const Md = {
  [Et.log]: W.info,
  [Et.debug]: W.debug,
  [Et.info]: W.info,
  [Et.warn]: W.warn,
  [Et.error]: W.error
};
function Dd(t, e) {
  const n = Bs(t.forwardConsoleLogs).subscribe((r) => {
    var o;
    const i = {
      rawLogsEvent: {
        date: It(),
        message: r.message,
        origin: jt.CONSOLE,
        error: r.error && or(r.error),
        status: Md[r.api]
      },
      messageContext: (o = r.error) === null || o === void 0 ? void 0 : o.context,
      domainContext: {
        handlingStack: r.handlingStack
      }
    };
    e.notify(0, i);
  });
  return {
    stop: () => {
      n.unsubscribe();
    }
  };
}
function Bd(t, e) {
  const n = ks(t, t.forwardReports).subscribe((r) => {
    let o = r.message, i;
    const s = r.originalError.type === "deprecation" ? W.warn : W.error;
    s === W.error ? i = or(r) : r.stack && (o += ` Found in ${Ru(r.stack)}`), e.notify(0, {
      rawLogsEvent: {
        date: It(),
        message: o,
        origin: jt.REPORT,
        error: i,
        status: s
      }
    });
  });
  return {
    stop: () => {
      n.unsubscribe();
    }
  };
}
function Fd(t, e) {
  if (!t.forwardErrorsToLogs)
    return { stop: it };
  const n = Ds(t).subscribe((i) => {
    i.state === "complete" && o(Ye.XHR, i);
  }), r = rr().subscribe((i) => {
    i.state === "resolve" && o(Ye.FETCH, i);
  });
  function o(i, s) {
    !As(s.url) && (zd(s) || cs(s.status)) && ("xhr" in s ? Vd(s.xhr, t, a) : s.response ? jd(s.response, t, a) : s.error && $d(s.error, t, a));
    function a(c) {
      const u = {
        isAborted: s.isAborted,
        handlingStack: s.handlingStack
      };
      e.notify(0, {
        rawLogsEvent: {
          message: `${Gd(i)} error ${s.method} ${s.url}`,
          date: s.startClocks.timeStamp,
          error: {
            stack: c || "Failed to load",
            // We don't know if the error was handled or not, so we set it to undefined
            handling: void 0
          },
          http: {
            method: s.method,
            // Cast resource method because of case mismatch cf issue RUMF-1152
            status_code: s.status,
            url: s.url
          },
          status: W.error,
          origin: jt.NETWORK
        },
        domainContext: u
      });
    }
  }
  return {
    stop: () => {
      n.unsubscribe(), r.unsubscribe();
    }
  };
}
function Vd(t, e, n) {
  typeof t.response == "string" ? n(go(t.response, e)) : n(t.response);
}
function $d(t, e, n) {
  n(go(Ze(Je(t)), e));
}
function jd(t, e, n) {
  const r = us(t);
  !r || !r.body ? n() : window.TextDecoder ? Hd(r.body, e.requestErrorResponseLengthLimit, (o, i) => {
    n(o ? `Unable to retrieve response: ${o}` : i);
  }) : r.text().then(G((o) => n(go(o, e))), G((o) => n(`Unable to retrieve response: ${o}`)));
}
function zd(t) {
  return t.status === 0 && t.responseType !== "opaque";
}
function go(t, e) {
  return t.length > e.requestErrorResponseLengthLimit ? `${t.substring(0, e.requestErrorResponseLengthLimit)}...` : t;
}
function Gd(t) {
  return Ye.XHR === t ? "XHR" : "Fetch";
}
function Hd(t, e, n) {
  zs(t, (r, o, i) => {
    if (r)
      n(r);
    else {
      let s = new TextDecoder().decode(o);
      i && (s += "..."), n(void 0, s);
    }
  }, {
    bytesLimit: e,
    collectStreamBody: !0
  });
}
function Kd(t, e, n) {
  if (!t.forwardErrorsToLogs)
    return { stop: it };
  const r = n.subscribe((o) => {
    if (o.type === 0) {
      const i = o.error;
      e.notify(0, {
        rawLogsEvent: {
          message: i.message,
          date: i.startClocks.timeStamp,
          error: or(i),
          origin: jt.SOURCE,
          status: W.error
        },
        messageContext: i.context
      });
    }
  });
  return {
    stop: () => {
      r.unsubscribe();
    }
  };
}
const Yd = Ms;
function Wd(t) {
  function e(n, r, o, i, s) {
    const a = Vt(r.getContext(), n.context);
    if (Yn(n.status, _n.console, r) && Xd(n, a), Yn(n.status, _n.http, r)) {
      const c = {
        rawLogsEvent: {
          date: s || It(),
          message: n.message,
          status: n.status,
          origin: jt.LOGGER
        },
        messageContext: a,
        savedCommonContext: i
      };
      o && (c.domainContext = { handlingStack: o }), t.notify(0, c);
    }
  }
  return {
    handleLog: e
  };
}
const qd = {
  [W.ok]: Et.debug,
  [W.debug]: Et.debug,
  [W.info]: Et.info,
  [W.notice]: Et.info,
  [W.warn]: Et.warn,
  [W.error]: Et.error,
  [W.critical]: Et.error,
  [W.alert]: Et.error,
  [W.emerg]: Et.error
};
function Xd({ status: t, message: e }, n) {
  me[qd[t]].call(Xt, e, n);
}
function Jd(t, e, n, r, o) {
  const i = to(t, {
    endpoint: t.logsEndpointBuilder,
    encoder: Kn()
  }, t.replica && {
    endpoint: t.replica.logsEndpointBuilder,
    encoder: Kn()
  }, n, r, o.expireObservable);
  return e.subscribe(1, (s) => {
    i.add(s);
  }), i;
}
function Zd(t) {
  const e = Qe();
  t.subscribe(1, (n) => {
    e.send("log", n);
  });
}
function Qd(t) {
  return {
    get: (e) => {
      const n = t.findTrackedSession(e);
      if (n)
        return {
          session_id: n.id
        };
    }
  };
}
function tf(t) {
  return (e) => {
    t.notify(0, {
      rawLogsEvent: {
        message: e.message,
        date: e.startClocks.timeStamp,
        origin: jt.AGENT,
        status: W.error
      }
    }), se("Error reported to customer", { "error.message": e.message });
  };
}
const ef = Fs;
function nf(t) {
  const e = window;
  let n = !1;
  t.register(0, ({ startTime: i }) => {
    const s = r(i);
    return s || Ft;
  }), t.register(1, ({ startTime: i }) => {
    var s, a;
    const c = r(i);
    return c ? {
      application: { id: c.application_id },
      view: { id: (s = c.view) === null || s === void 0 ? void 0 : s.id },
      action: { id: (a = c.user_action) === null || a === void 0 ? void 0 : a.id }
    } : Ft;
  });
  function r(i) {
    const s = nr(), a = s ? e.DD_RUM_SYNTHETICS : e.DD_RUM, c = o(i, a);
    if (c)
      return c;
    s && !n && (n = !0, se("Logs sent before RUM is injected by the synthetics worker", {
      testId: so(),
      resultId: ao()
    }));
  }
  function o(i, s) {
    if (s && s.getInternalContext)
      return s.getInternalContext(i);
  }
  return {
    stop: () => {
      n = !1;
    }
  };
}
function rf(t, e, n) {
  t.register(0, ({ startTime: r }) => {
    const o = n.findTrackedSession(r);
    return n.findTrackedSession(r, { returnInactive: !0 }) ? {
      service: e.service,
      session_id: o ? o.id : void 0,
      session: o ? { id: o.id } : void 0
    } : he;
  }), t.register(1, ({ startTime: r }) => {
    const o = n.findTrackedSession(r);
    return !o || !o.id ? Ft : {
      session: { id: o.id }
    };
  });
}
const Tr = "logs";
function of(t, e, n, r) {
  const o = new Yd(), i = ef(), s = [];
  o.subscribe(1, (x) => Zr("logs", x));
  const a = tf(o), c = bs(t), u = vs("browser-logs-sdk", t, i, a, c, Kn);
  s.push(u.stop);
  const f = t.sessionStoreStrategyType && !ie() && !nr() ? Ld(t, n) : Nd(t);
  rf(i, t, f);
  const l = Vs(i, t, Tr), g = js(i, t, f, Tr), O = $s(i, t, Tr, !1), { stop: E } = nf(i);
  Fd(t, o), Kd(t, o, r), r.unbuffer(), Dd(t, o), Bd(t, o);
  const { handleLog: A } = Wd(o);
  if (Ud(t, o, i, e, a), ie())
    Zd(o);
  else {
    const { stop: x } = Jd(t, o, a, c, f);
    s.push(() => x());
  }
  const v = Qd(f);
  return {
    handleLog: A,
    getInternalContext: v.get,
    accountContext: l,
    globalContext: O,
    userContext: g,
    stop: () => {
      s.forEach((x) => x()), E();
    }
  };
}
const ce = xd(of);
Os(qt(), "DD_LOGS", ce);
const Y = {
  ACTION: "action",
  ERROR: "error",
  LONG_TASK: "long_task",
  VIEW: "view",
  RESOURCE: "resource",
  VITAL: "vital"
}, Ks = {
  LONG_TASK: "long-task",
  LONG_ANIMATION_FRAME: "long-animation-frame"
}, oe = {
  INITIAL_LOAD: "initial_load",
  ROUTE_CHANGE: "route_change",
  BF_CACHE: "bf_cache"
}, mo = {
  CLICK: "click",
  CUSTOM: "custom"
}, sn = {
  RAGE_CLICK: "rage_click",
  ERROR_CLICK: "error_click",
  DEAD_CLICK: "dead_click"
}, Ys = {
  DURATION: "duration"
};
function sf() {
  return { vitalsByName: /* @__PURE__ */ new Map(), vitalsByReference: /* @__PURE__ */ new WeakMap() };
}
function af(t, e, n) {
  function r(i) {
    return !e.wasInPageStateDuringPeriod("frozen", i.startClocks.relative, i.duration);
  }
  function o(i) {
    r(i) && t.notify(12, uf(i));
  }
  return {
    addDurationVital: o,
    startDurationVital: (i, s = {}) => Ws(n, i, s),
    stopDurationVital: (i, s = {}) => {
      qs(o, n, i, s);
    }
  };
}
function Ws({ vitalsByName: t, vitalsByReference: e }, n, r = {}) {
  const o = {
    name: n,
    startClocks: xt(),
    context: r.context,
    description: r.description
  }, i = { __dd_vital_reference: !0 };
  return t.set(n, o), e.set(i, o), i;
}
function qs(t, { vitalsByName: e, vitalsByReference: n }, r, o = {}) {
  const i = typeof r == "string" ? e.get(r) : n.get(r);
  i && (t(cf(i, i.startClocks, o, xt())), typeof r == "string" ? e.delete(r) : n.delete(r));
}
function cf(t, e, n, r) {
  var o;
  return {
    name: t.name,
    type: Ys.DURATION,
    startClocks: e,
    duration: Ct(e.timeStamp, r.timeStamp),
    context: Vt(t.context, n.context),
    description: (o = n.description) !== null && o !== void 0 ? o : t.description
  };
}
function uf(t, e) {
  const n = {
    date: t.startClocks.timeStamp,
    vital: {
      id: Ot(),
      type: t.type,
      name: t.name,
      duration: K(t.duration),
      description: t.description
    },
    type: Y.VITAL
  };
  return n._dd = {
    vital: {
      computed_value: !0
    }
  }, {
    rawRumEvent: n,
    startTime: t.startClocks.relative,
    duration: t.duration,
    customerContext: t.context,
    domainContext: {}
  };
}
function Xs(t, e, n) {
  if (t)
    for (const r of t) {
      const o = r[e];
      o && o(n);
    }
}
const Ko = /* @__PURE__ */ new Map();
function Js(t, e) {
  if (e === 100)
    return !0;
  if (e === 0)
    return !1;
  const n = Ko.get(e);
  if (n && t === n.sessionId)
    return n.decision;
  let r;
  return window.BigInt ? r = lf(BigInt(`0x${t.split("-")[4]}`), e) : r = de(e), Ko.set(e, { sessionId: t, decision: r }), r;
}
function lf(t, e) {
  const n = BigInt("1111111111111111111"), r = BigInt("0x10000000000000000"), o = t * n % r;
  return Number(o) <= e / 100 * Number(r);
}
function df() {
  return Qs(64);
}
function Zs() {
  return Qs(63);
}
function Qs(t) {
  const e = crypto.getRandomValues(new Uint32Array(2));
  return t === 63 && (e[e.length - 1] >>>= 1), {
    toString(n = 10) {
      let r = e[1], o = e[0], i = "";
      do {
        const s = r % n * 4294967296 + o;
        r = Math.floor(r / n), o = Math.floor(s / n), i = (s % n).toString(n) + i;
      } while (r || o);
      return i;
    }
  };
}
function ke(t) {
  return t.toString(16).padStart(16, "0");
}
function ff(t) {
  const e = t;
  return Ce(e) === "object" && no(e.match) && Array.isArray(e.propagatorTypes);
}
function pf(t) {
  t.status === 0 && !t.isAborted && (t.traceId = void 0, t.spanId = void 0, t.traceSampled = void 0);
}
function hf(t, e, n, r) {
  return {
    clearTracingIfNeeded: pf,
    traceFetch: (o) => Yo(t, o, e, n, r, (i) => {
      var s;
      if (o.input instanceof Request && !(!((s = o.init) === null || s === void 0) && s.headers))
        o.input = new Request(o.input), Object.keys(i).forEach((a) => {
          o.input.headers.append(a, i[a]);
        });
      else {
        o.init = fn(o.init);
        const a = [];
        o.init.headers instanceof Headers ? o.init.headers.forEach((c, u) => {
          a.push([u, c]);
        }) : Array.isArray(o.init.headers) ? o.init.headers.forEach((c) => {
          a.push(c);
        }) : o.init.headers && Object.keys(o.init.headers).forEach((c) => {
          a.push([c, o.init.headers[c]]);
        }), o.init.headers = a.concat(qr(i));
      }
    }),
    traceXhr: (o, i) => Yo(t, o, e, n, r, (s) => {
      Object.keys(s).forEach((a) => {
        i.setRequestHeader(a, s[a]);
      });
    })
  };
}
function Yo(t, e, n, r, o, i) {
  const s = n.findTrackedSession();
  if (!s)
    return;
  const a = t.allowedTracingUrls.find((f) => ro([f.match], e.url, !0));
  if (!a)
    return;
  const c = Js(s.id, t.traceSampleRate);
  (c || t.traceContextInjection === jr.ALL) && (e.traceSampled = c, e.traceId = df(), e.spanId = Zs(), i(gf(e.traceId, e.spanId, e.traceSampled, s.id, a.propagatorTypes, r, o, t)));
}
function gf(t, e, n, r, o, i, s, a) {
  const c = {};
  if (o.forEach((u) => {
    switch (u) {
      case "datadog": {
        Object.assign(c, {
          "x-datadog-origin": "rum",
          "x-datadog-parent-id": e.toString(),
          "x-datadog-sampling-priority": n ? "1" : "0",
          "x-datadog-trace-id": t.toString()
        });
        break;
      }
      // https://www.w3.org/TR/trace-context/
      case "tracecontext": {
        Object.assign(c, {
          traceparent: `00-0000000000000000${ke(t)}-${ke(e)}-0${n ? "1" : "0"}`,
          tracestate: `dd=s:${n ? "1" : "0"};o:rum`
        });
        break;
      }
      // https://github.com/openzipkin/b3-propagation
      case "b3": {
        Object.assign(c, {
          b3: `${ke(t)}-${ke(e)}-${n ? "1" : "0"}`
        });
        break;
      }
      case "b3multi": {
        Object.assign(c, {
          "X-B3-TraceId": ke(t),
          "X-B3-SpanId": ke(e),
          "X-B3-Sampled": n ? "1" : "0"
        });
        break;
      }
    }
  }), a.propagateTraceBaggage) {
    const u = {
      "session.id": r
    }, f = i.getContext().id;
    typeof f == "string" && (u["user.id"] = f);
    const l = s.getContext().id;
    typeof l == "string" && (u["account.id"] = l);
    const g = Object.entries(u).map(([O, E]) => `${O}=${encodeURIComponent(E)}`).join(",");
    g && (c.baggage = g);
  }
  return c;
}
const ta = ["tracecontext", "datadog"];
function mf(t) {
  var e, n, r, o, i, s, a;
  if (t.trackFeatureFlagsForEvents !== void 0 && !Array.isArray(t.trackFeatureFlagsForEvents) && X.warn("trackFeatureFlagsForEvents should be an array"), !t.applicationId) {
    X.error("Application ID is not configured, no RUM data will be collected.");
    return;
  }
  if (!Be(t.sessionReplaySampleRate, "Session Replay") || !Be(t.traceSampleRate, "Trace"))
    return;
  if (t.excludedActivityUrls !== void 0 && !Array.isArray(t.excludedActivityUrls)) {
    X.error("Excluded Activity Urls should be an array");
    return;
  }
  const c = _f(t);
  if (!c)
    return;
  const u = Is(t);
  if (!u)
    return;
  const f = (e = t.sessionReplaySampleRate) !== null && e !== void 0 ? e : 0;
  return {
    applicationId: t.applicationId,
    version: t.version || void 0,
    actionNameAttribute: t.actionNameAttribute,
    sessionReplaySampleRate: f,
    startSessionReplayRecordingManually: t.startSessionReplayRecordingManually !== void 0 ? !!t.startSessionReplayRecordingManually : f === 0,
    traceSampleRate: (n = t.traceSampleRate) !== null && n !== void 0 ? n : 100,
    rulePsr: bn(t.traceSampleRate) ? t.traceSampleRate / 100 : void 0,
    allowedTracingUrls: c,
    excludedActivityUrls: (r = t.excludedActivityUrls) !== null && r !== void 0 ? r : [],
    workerUrl: t.workerUrl,
    compressIntakeRequests: !!t.compressIntakeRequests,
    trackUserInteractions: !!(!((o = t.trackUserInteractions) !== null && o !== void 0) || o),
    trackViewsManually: !!t.trackViewsManually,
    trackResources: !!(!((i = t.trackResources) !== null && i !== void 0) || i),
    trackLongTasks: !!(!((s = t.trackLongTasks) !== null && s !== void 0) || s),
    trackBfcacheViews: !!t.trackBfcacheViews,
    subdomain: t.subdomain,
    defaultPrivacyLevel: Vn(ln, t.defaultPrivacyLevel) ? t.defaultPrivacyLevel : ln.MASK,
    enablePrivacyForActionName: !!t.enablePrivacyForActionName,
    customerDataTelemetrySampleRate: 1,
    traceContextInjection: Vn(jr, t.traceContextInjection) ? t.traceContextInjection : jr.SAMPLED,
    plugins: t.plugins || [],
    trackFeatureFlagsForEvents: t.trackFeatureFlagsForEvents || [],
    profilingSampleRate: (a = t.profilingSampleRate) !== null && a !== void 0 ? a : 0,
    propagateTraceBaggage: !!t.propagateTraceBaggage,
    ...u
  };
}
function _f(t) {
  if (t.allowedTracingUrls === void 0)
    return [];
  if (!Array.isArray(t.allowedTracingUrls)) {
    X.error("Allowed Tracing URLs should be an array");
    return;
  }
  if (t.allowedTracingUrls.length !== 0 && t.service === void 0) {
    X.error("Service needs to be configured when tracing is enabled");
    return;
  }
  const e = [];
  return t.allowedTracingUrls.forEach((n) => {
    no(n) ? e.push({ match: n, propagatorTypes: ta }) : ff(n) ? e.push(n) : X.warn("Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter", n);
  }), e;
}
function bf(t) {
  const e = /* @__PURE__ */ new Set();
  return Array.isArray(t.allowedTracingUrls) && t.allowedTracingUrls.length > 0 && t.allowedTracingUrls.forEach((n) => {
    no(n) ? ta.forEach((r) => e.add(r)) : Ce(n) === "object" && Array.isArray(n.propagatorTypes) && n.propagatorTypes.forEach((r) => e.add(r));
  }), Array.from(e);
}
function yf(t) {
  var e;
  const n = Rs(t);
  return {
    session_replay_sample_rate: t.sessionReplaySampleRate,
    start_session_replay_recording_manually: t.startSessionReplayRecordingManually,
    trace_sample_rate: t.traceSampleRate,
    trace_context_injection: t.traceContextInjection,
    action_name_attribute: t.actionNameAttribute,
    use_allowed_tracing_urls: Array.isArray(t.allowedTracingUrls) && t.allowedTracingUrls.length > 0,
    selected_tracing_propagators: bf(t),
    default_privacy_level: t.defaultPrivacyLevel,
    enable_privacy_for_action_name: t.enablePrivacyForActionName,
    use_excluded_activity_urls: Array.isArray(t.excludedActivityUrls) && t.excludedActivityUrls.length > 0,
    use_worker_url: !!t.workerUrl,
    compress_intake_requests: t.compressIntakeRequests,
    track_views_manually: t.trackViewsManually,
    track_user_interactions: t.trackUserInteractions,
    track_resources: t.trackResources,
    track_long_task: t.trackLongTasks,
    track_bfcache_views: t.trackBfcacheViews,
    plugins: (e = t.plugins) === null || e === void 0 ? void 0 : e.map((r) => {
      var o;
      return {
        name: r.name,
        ...(o = r.getConfigurationTelemetry) === null || o === void 0 ? void 0 : o.call(r)
      };
    }),
    track_feature_flags_for_events: t.trackFeatureFlagsForEvents,
    ...n
  };
}
const vf = "v1", Ef = [
  "applicationId",
  "service",
  "env",
  "version",
  "sessionSampleRate",
  "sessionReplaySampleRate",
  "defaultPrivacyLevel",
  "enablePrivacyForActionName"
];
function wf(t, e) {
  Tf(t, (n) => {
    e(Sf(t, n));
  });
}
function Sf(t, e) {
  const n = { ...t };
  return Ef.forEach((r) => {
    r in e && (n[r] = e[r]);
  }), n;
}
function Tf(t, e) {
  const n = new XMLHttpRequest();
  mt(t, n, "load", function() {
    if (n.status === 200) {
      const r = JSON.parse(n.responseText);
      r.rum ? e(r.rum) : X.error("No remote configuration for RUM.");
    } else
      Wo();
  }), mt(t, n, "error", function() {
    Wo();
  }), n.open("GET", Cf(t)), n.send();
}
function Cf(t) {
  return `https://sdk-configuration.${Cs("rum", t)}/${vf}/${encodeURIComponent(t.remoteConfigurationId)}.json`;
}
function Wo() {
  X.error("Error fetching the remote configuration.");
}
function Af({ ignoreInitIfSyntheticsWillInjectRum: t = !0, startDeflateWorker: e }, n, r, o) {
  const i = Qr(), s = po();
  Cr(s, Z.globalContext, i);
  const a = ho();
  Cr(a, Z.userContext, i);
  const c = fo();
  Cr(c, Z.accountContext, i);
  let u, f, l, g;
  const O = n.observable.subscribe(A), E = {};
  function A() {
    if (!l || !g || !n.isGranted())
      return;
    O.unsubscribe();
    let T;
    if (g.trackViewsManually) {
      if (!u)
        return;
      i.remove(u.callback), T = u.options;
    }
    const R = o(g, f, T);
    i.drain(R);
  }
  function v(T) {
    const R = ie();
    if (R && (T = If(T)), l = T, At(() => {
      Es(yf(T));
    }), g) {
      er("DD_RUM", T);
      return;
    }
    const U = mf(T);
    if (U) {
      if (!R && !U.sessionStoreStrategyType) {
        X.warn("No storage available for session. We will not send any data.");
        return;
      }
      U.compressIntakeRequests && !R && e && (f = e(
        U,
        "Datadog RUM",
        // Worker initialization can fail asynchronously, especially in Firefox where even CSP
        // issues are reported asynchronously. For now, the SDK will continue its execution even if
        // data won't be sent to Datadog. We could improve this behavior in the future.
        it
      ), !f) || (g = U, rr().subscribe(it), n.tryToInit(U.trackingConsent), A());
    }
  }
  const x = (T) => {
    i.add((R) => R.addDurationVital(T));
  };
  return {
    init(T, R) {
      if (!T) {
        X.error("Missing configuration");
        return;
      }
      rs(T.enableExperimentalFeatures), l = T, !(t && nr()) && (Xs(T.plugins, "onInit", { initConfiguration: T, publicApi: R }), T.remoteConfigurationId ? wf(T, v) : v(T));
    },
    get initConfiguration() {
      return l;
    },
    getInternalContext: it,
    stopSession: it,
    addTiming(T, R = It()) {
      i.add((U) => U.addTiming(T, R));
    },
    startView(T, R = xt()) {
      const U = (b) => {
        b.startView(T, R);
      };
      i.add(U), u || (u = { options: T, callback: U }, A());
    },
    setViewName(T) {
      i.add((R) => R.setViewName(T));
    },
    // View context APIs
    setViewContext(T) {
      i.add((R) => R.setViewContext(T));
    },
    setViewContextProperty(T, R) {
      i.add((U) => U.setViewContextProperty(T, R));
    },
    getViewContext: () => E,
    globalContext: s,
    userContext: a,
    accountContext: c,
    addAction(T) {
      i.add((R) => R.addAction(T));
    },
    addError(T) {
      i.add((R) => R.addError(T));
    },
    addFeatureFlagEvaluation(T, R) {
      i.add((U) => U.addFeatureFlagEvaluation(T, R));
    },
    startDurationVital(T, R) {
      return Ws(r, T, R);
    },
    stopDurationVital(T, R) {
      qs(x, r, T, R);
    },
    addDurationVital: x
  };
}
function If(t) {
  var e, n;
  return {
    ...t,
    applicationId: "00000000-aaaa-0000-aaaa-000000000000",
    clientToken: "empty",
    sessionSampleRate: 100,
    defaultPrivacyLevel: (e = t.defaultPrivacyLevel) !== null && e !== void 0 ? e : (n = Qe()) === null || n === void 0 ? void 0 : n.getPrivacyLevel()
  };
}
function Cr(t, e, n) {
  t.changeObservable.subscribe(() => {
    const r = t.getContext();
    n.add((o) => o[e].setContext(r));
  });
}
function Rf(t, e, n, r = {}) {
  const o = Ts(), i = sf(), s = Gs().observable;
  let a = Af(r, o, i, (l, g, O) => {
    const E = t(l, e, n, O, g && r.createDeflateEncoder ? (A) => r.createDeflateEncoder(l, g, A) : Kn, o, i, s, r.sdkName);
    return e.onRumStart(E.lifeCycle, l, E.session, E.viewHistory, g), n.onRumStart(E.lifeCycle, E.hooks, l, E.session, E.viewHistory), a = xf(a, E), Xs(l.plugins, "onRumStart", {
      strategy: a,
      // TODO: remove this in the next major release
      addEvent: E.addEvent
    }), E;
  });
  const c = () => a, u = G((l) => {
    const g = typeof l == "object" ? l : { name: l };
    a.startView(g), Nt({ feature: "start-view" });
  }), f = xs({
    init: G((l) => {
      a.init(l, f);
    }),
    setTrackingConsent: G((l) => {
      o.update(l), Nt({ feature: "set-tracking-consent", tracking_consent: l });
    }),
    setViewName: G((l) => {
      a.setViewName(l), Nt({ feature: "set-view-name" });
    }),
    setViewContext: G((l) => {
      a.setViewContext(l), Nt({ feature: "set-view-context" });
    }),
    setViewContextProperty: G((l, g) => {
      a.setViewContextProperty(l, g), Nt({ feature: "set-view-context-property" });
    }),
    getViewContext: G(() => (Nt({ feature: "set-view-context-property" }), a.getViewContext())),
    getInternalContext: G((l) => a.getInternalContext(l)),
    getInitConfiguration: G(() => tr(a.initConfiguration)),
    addAction: (l, g) => {
      const O = He("action");
      Ee(() => {
        a.addAction({
          name: ht(l),
          context: ht(g),
          startClocks: xt(),
          type: mo.CUSTOM,
          handlingStack: O
        }), Nt({ feature: "add-action" });
      });
    },
    addError: (l, g) => {
      const O = He("error");
      Ee(() => {
        a.addError({
          error: l,
          // Do not sanitize error here, it is needed unserialized by computeRawError()
          handlingStack: O,
          context: ht(g),
          startClocks: xt()
        }), Nt({ feature: "add-error" });
      });
    },
    addTiming: G((l, g) => {
      a.addTiming(ht(l), g);
    }),
    setGlobalContext: st(c, Z.globalContext, at.setContext, "set-global-context"),
    getGlobalContext: st(c, Z.globalContext, at.getContext, "get-global-context"),
    setGlobalContextProperty: st(c, Z.globalContext, at.setContextProperty, "set-global-context-property"),
    removeGlobalContextProperty: st(c, Z.globalContext, at.removeContextProperty, "remove-global-context-property"),
    clearGlobalContext: st(c, Z.globalContext, at.clearContext, "clear-global-context"),
    setUser: st(c, Z.userContext, at.setContext, "set-user"),
    getUser: st(c, Z.userContext, at.getContext, "get-user"),
    setUserProperty: st(c, Z.userContext, at.setContextProperty, "set-user-property"),
    removeUserProperty: st(c, Z.userContext, at.removeContextProperty, "remove-user-property"),
    clearUser: st(c, Z.userContext, at.clearContext, "clear-user"),
    setAccount: st(c, Z.accountContext, at.setContext, "set-account"),
    getAccount: st(c, Z.accountContext, at.getContext, "get-account"),
    setAccountProperty: st(c, Z.accountContext, at.setContextProperty, "set-account-property"),
    removeAccountProperty: st(c, Z.accountContext, at.removeContextProperty, "remove-account-property"),
    clearAccount: st(c, Z.accountContext, at.clearContext, "clear-account"),
    startView: u,
    stopSession: G(() => {
      a.stopSession(), Nt({ feature: "stop-session" });
    }),
    addFeatureFlagEvaluation: G((l, g) => {
      a.addFeatureFlagEvaluation(ht(l), ht(g)), Nt({ feature: "add-feature-flag-evaluation" });
    }),
    getSessionReplayLink: G(() => e.getSessionReplayLink()),
    startSessionReplayRecording: G((l) => {
      e.start(l), Nt({ feature: "start-session-replay-recording", force: l && l.force });
    }),
    stopSessionReplayRecording: G(() => e.stop()),
    addDurationVital: G((l, g) => {
      Nt({ feature: "add-duration-vital" }), a.addDurationVital({
        name: ht(l),
        type: Ys.DURATION,
        startClocks: Cc(g.startTime),
        duration: g.duration,
        context: ht(g && g.context),
        description: ht(g && g.description)
      });
    }),
    startDurationVital: G((l, g) => (Nt({ feature: "start-duration-vital" }), a.startDurationVital(ht(l), {
      context: ht(g && g.context),
      description: ht(g && g.description)
    }))),
    stopDurationVital: G((l, g) => {
      Nt({ feature: "stop-duration-vital" }), a.stopDurationVital(typeof l == "string" ? ht(l) : l, {
        context: ht(g && g.context),
        description: ht(g && g.description)
      });
    })
  });
  return f;
}
function xf(t, e) {
  return {
    init: (n) => {
      er("DD_RUM", n);
    },
    initConfiguration: t.initConfiguration,
    ...e
  };
}
function Of() {
  const t = kf();
  return new nt((e) => {
    if (!t)
      return;
    const n = new t(G((r) => e.notify(r)));
    return n.observe(document, {
      attributes: !0,
      characterData: !0,
      childList: !0,
      subtree: !0
    }), () => n.disconnect();
  });
}
function kf() {
  let t;
  const e = window;
  if (e.Zone && (t = fe(e, "MutationObserver"), e.MutationObserver && t === e.MutationObserver)) {
    const n = new e.MutationObserver(it), r = fe(n, "originalInstance");
    t = r && r.constructor;
  }
  return t || (t = e.MutationObserver), t;
}
function Lf() {
  const t = new nt(), { stop: e } = Jt(window, "open", () => t.notify());
  return { observable: t, stop: e };
}
function Nf(t, e, n, r, o) {
  return {
    get: (i) => {
      const s = n.findView(i), a = o.findUrl(i), c = e.findTrackedSession(i);
      if (c && s && a) {
        const u = r.findActionId(i);
        return {
          application_id: t,
          session_id: c.id,
          user_action: u ? { id: u } : void 0,
          view: { id: s.id, name: s.name, referrer: a.referrer, url: a.url }
        };
      }
    }
  };
}
const Pf = Ms, Uf = Se;
function Mf(t) {
  const e = en({ expireDelay: Uf });
  t.subscribe(1, (r) => {
    e.add(n(r), r.startClocks.relative);
  }), t.subscribe(6, ({ endClocks: r }) => {
    e.closeActive(r.relative);
  }), t.subscribe(3, (r) => {
    const o = e.find(r.startClocks.relative);
    o && (r.name && (o.name = r.name), r.context && (o.context = r.context), o.sessionIsActive = r.sessionIsActive);
  }), t.subscribe(10, () => {
    e.reset();
  });
  function n(r) {
    return {
      service: r.service,
      version: r.version,
      context: r.context,
      id: r.id,
      name: r.name,
      startClocks: r.startClocks
    };
  }
  return {
    findView: (r) => e.find(r),
    stop: () => {
      e.stop();
    }
  };
}
const ea = "initial_document", Df = [
  [Bt.DOCUMENT, (t) => ea === t],
  [Bt.XHR, (t) => t === "xmlhttprequest"],
  [Bt.FETCH, (t) => t === "fetch"],
  [Bt.BEACON, (t) => t === "beacon"],
  [Bt.CSS, (t, e) => /\.css$/i.test(e)],
  [Bt.JS, (t, e) => /\.js$/i.test(e)],
  [
    Bt.IMAGE,
    (t, e) => ["image", "img", "icon"].includes(t) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(e) !== null
  ],
  [Bt.FONT, (t, e) => /\.(woff|eot|woff2|ttf)$/i.exec(e) !== null],
  [
    Bt.MEDIA,
    (t, e) => ["audio", "video"].includes(t) || /\.(mp3|mp4)$/i.exec(e) !== null
  ]
];
function Bf(t) {
  const e = t.name;
  if (!wl(e))
    return se(`Failed to construct URL for "${t.name}"`), Bt.OTHER;
  const n = Sl(e);
  for (const [r, o] of Df)
    if (o(t.initiatorType, n))
      return r;
  return Bt.OTHER;
}
function qo(...t) {
  for (let e = 1; e < t.length; e += 1)
    if (t[e - 1] > t[e])
      return !1;
  return !0;
}
function Ff(t) {
  return t.initiatorType === "xmlhttprequest" || t.initiatorType === "fetch";
}
function na(t) {
  const { duration: e, startTime: n, responseEnd: r } = t;
  return e === 0 && n < r ? Ct(n, r) : e;
}
function Vf(t) {
  if (!oa(t))
    return;
  const { startTime: e, fetchStart: n, workerStart: r, redirectStart: o, redirectEnd: i, domainLookupStart: s, domainLookupEnd: a, connectStart: c, secureConnectionStart: u, connectEnd: f, requestStart: l, responseStart: g, responseEnd: O } = t, E = {
    download: ge(e, g, O),
    first_byte: ge(e, l, g)
  };
  return 0 < r && r < n && (E.worker = ge(e, r, n)), n < f && (E.connect = ge(e, c, f), c <= u && u <= f && (E.ssl = ge(e, u, f))), n < a && (E.dns = ge(e, s, a)), e < i && (E.redirect = ge(e, o, i)), E;
}
function ra(t) {
  return t.duration >= 0;
}
function oa(t) {
  const e = qo(t.startTime, t.fetchStart, t.domainLookupStart, t.domainLookupEnd, t.connectStart, t.connectEnd, t.requestStart, t.responseStart, t.responseEnd), n = $f(t) ? qo(t.startTime, t.redirectStart, t.redirectEnd, t.fetchStart) : !0;
  return e && n;
}
function $f(t) {
  return t.redirectEnd > t.startTime;
}
function ge(t, e, n) {
  if (t <= e && e <= n)
    return {
      duration: K(Ct(e, n)),
      start: K(Ct(t, e))
    };
}
function ia(t) {
  return t.nextHopProtocol === "" ? void 0 : t.nextHopProtocol;
}
function sa(t) {
  return t.deliveryType === "" ? "other" : t.deliveryType;
}
function jf(t) {
  if (t.startTime < t.responseStart) {
    const { encodedBodySize: e, decodedBodySize: n, transferSize: r } = t;
    return {
      size: n,
      encoded_body_size: e,
      decoded_body_size: n,
      transfer_size: r
    };
  }
  return {
    size: void 0,
    encoded_body_size: void 0,
    decoded_body_size: void 0,
    transfer_size: void 0
  };
}
function _o(t) {
  return t && (!As(t) || os(mn.TRACK_INTAKE_REQUESTS));
}
const zf = /data:(.+)?(;base64)?,/g, Gf = 24e3;
function Hf(t, e = Gf) {
  if (t.length <= e || !t.startsWith("data:"))
    return t;
  const n = t.substring(0, 100).match(zf);
  return n ? `${n[0]}[...]` : t;
}
let Xo = 1;
function Kf(t, e, n, r, o) {
  const i = hf(e, n, r, o);
  Yf(t, e, i), Wf(t, i);
}
function Yf(t, e, n) {
  const r = Ds(e).subscribe((o) => {
    const i = o;
    if (_o(i.url))
      switch (i.state) {
        case "start":
          n.traceXhr(i, i.xhr), i.requestIndex = aa(), t.notify(7, {
            requestIndex: i.requestIndex,
            url: i.url
          });
          break;
        case "complete":
          n.clearTracingIfNeeded(i), t.notify(8, {
            duration: i.duration,
            method: i.method,
            requestIndex: i.requestIndex,
            spanId: i.spanId,
            startClocks: i.startClocks,
            status: i.status,
            traceId: i.traceId,
            traceSampled: i.traceSampled,
            type: Ye.XHR,
            url: i.url,
            xhr: i.xhr,
            isAborted: i.isAborted,
            handlingStack: i.handlingStack
          });
          break;
      }
  });
  return { stop: () => r.unsubscribe() };
}
function Wf(t, e) {
  const n = rr().subscribe((r) => {
    const o = r;
    if (_o(o.url))
      switch (o.state) {
        case "start":
          e.traceFetch(o), o.requestIndex = aa(), t.notify(7, {
            requestIndex: o.requestIndex,
            url: o.url
          });
          break;
        case "resolve":
          qf(o, (i) => {
            e.clearTracingIfNeeded(o), t.notify(8, {
              duration: i,
              method: o.method,
              requestIndex: o.requestIndex,
              responseType: o.responseType,
              spanId: o.spanId,
              startClocks: o.startClocks,
              status: o.status,
              traceId: o.traceId,
              traceSampled: o.traceSampled,
              type: Ye.FETCH,
              url: o.url,
              response: o.response,
              init: o.init,
              input: o.input,
              isAborted: o.isAborted,
              handlingStack: o.handlingStack
            });
          });
          break;
      }
  });
  return { stop: () => n.unsubscribe() };
}
function aa() {
  const t = Xo;
  return Xo += 1, t;
}
function qf(t, e) {
  const n = t.response && us(t.response);
  !n || !n.body ? e(Ct(t.startClocks.timeStamp, It())) : zs(n.body, () => {
    e(Ct(t.startClocks.timeStamp, It()));
  }, {
    bytesLimit: Number.POSITIVE_INFINITY,
    collectStreamBody: !1
  });
}
function ca(t) {
  return bn(t) && t < 0 ? void 0 : t;
}
function ua({ lifeCycle: t, isChildEvent: e, onChange: n = it }) {
  const r = {
    errorCount: 0,
    longTaskCount: 0,
    resourceCount: 0,
    actionCount: 0,
    frustrationCount: 0
  }, o = t.subscribe(13, (i) => {
    var s;
    if (!(i.type === "view" || i.type === "vital" || !e(i)))
      switch (i.type) {
        case Y.ERROR:
          r.errorCount += 1, n();
          break;
        case Y.ACTION:
          r.actionCount += 1, i.action.frustration && (r.frustrationCount += i.action.frustration.type.length), n();
          break;
        case Y.LONG_TASK:
          r.longTaskCount += 1, n();
          break;
        case Y.RESOURCE:
          !((s = i._dd) === null || s === void 0) && s.discarded || (r.resourceCount += 1, n());
          break;
      }
  });
  return {
    stop: () => {
      o.unsubscribe();
    },
    eventCounts: r
  };
}
function Xf(t, e) {
  const n = Yt();
  let r = !1;
  const { stop: o } = pe(t, window, [
    "click",
    "mousedown",
    "keydown",
    "touchstart",
    "pointerdown"
    /* DOM_EVENT.POINTER_DOWN */
  ], (a) => {
    if (!a.cancelable)
      return;
    const c = {
      entryType: "first-input",
      processingStart: zt(),
      processingEnd: zt(),
      startTime: a.timeStamp,
      duration: 0,
      // arbitrary value to avoid nullable duration and simplify INP logic
      name: "",
      cancelable: !1,
      target: null,
      toJSON: () => ({})
    };
    a.type === "pointerdown" ? i(t, c) : s(c);
  }, { passive: !0, capture: !0 });
  return { stop: o };
  function i(a, c) {
    pe(a, window, [
      "pointerup",
      "pointercancel"
      /* DOM_EVENT.POINTER_CANCEL */
    ], (u) => {
      u.type === "pointerup" && s(c);
    }, { once: !0 });
  }
  function s(a) {
    if (!r) {
      r = !0, o();
      const c = a.processingStart - a.startTime;
      c >= 0 && c < Yt() - n && e(a);
    }
  }
}
var rt;
(function(t) {
  t.EVENT = "event", t.FIRST_INPUT = "first-input", t.LARGEST_CONTENTFUL_PAINT = "largest-contentful-paint", t.LAYOUT_SHIFT = "layout-shift", t.LONG_TASK = "longtask", t.LONG_ANIMATION_FRAME = "long-animation-frame", t.NAVIGATION = "navigation", t.PAINT = "paint", t.RESOURCE = "resource", t.VISIBILITY_STATE = "visibility-state";
})(rt || (rt = {}));
function Zt(t, e) {
  return new nt((n) => {
    if (!window.PerformanceObserver)
      return;
    const r = (c) => {
      const u = Qf(c);
      u.length > 0 && n.notify(u);
    };
    let o, i = !0;
    const s = new PerformanceObserver(G((c) => {
      i ? o = At(() => r(c.getEntries())) : r(c.getEntries());
    }));
    try {
      s.observe(e);
    } catch {
      if ([
        rt.RESOURCE,
        rt.NAVIGATION,
        rt.LONG_TASK,
        rt.PAINT
      ].includes(e.type)) {
        e.buffered && (o = At(() => r(performance.getEntriesByType(e.type))));
        try {
          s.observe({ entryTypes: [e.type] });
        } catch {
          return;
        }
      }
    }
    i = !1, Jf(t);
    let a;
    return !Ae(rt.FIRST_INPUT) && e.type === rt.FIRST_INPUT && ({ stop: a } = Xf(t, (c) => {
      r([c]);
    })), () => {
      s.disconnect(), a && a(), Kt(o);
    };
  });
}
let an;
function Jf(t) {
  return !an && Zf() && "addEventListener" in performance && (an = mt(t, performance, "resourcetimingbufferfull", () => {
    performance.clearResourceTimings();
  })), () => {
    an == null || an.stop();
  };
}
function Zf() {
  return window.performance !== void 0 && "getEntries" in performance;
}
function Ae(t) {
  return window.PerformanceObserver && PerformanceObserver.supportedEntryTypes !== void 0 && PerformanceObserver.supportedEntryTypes.includes(t);
}
function Qf(t) {
  return t.filter((e) => !tp(e));
}
function tp(t) {
  return t.entryType === rt.RESOURCE && (!_o(t.name) || !ra(t));
}
function la(t) {
  return t.nodeType === Node.TEXT_NODE;
}
function ep(t) {
  return t.nodeType === Node.COMMENT_NODE;
}
function Ie(t) {
  return t.nodeType === Node.ELEMENT_NODE;
}
function da(t) {
  return Ie(t) && !!t.shadowRoot;
}
function np(t) {
  const e = t;
  return !!e.host && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && Ie(e.host);
}
function o_(t) {
  return t.childNodes.length > 0 || da(t);
}
function i_(t, e) {
  let n = t.firstChild;
  for (; n; )
    e(n), n = n.nextSibling;
  da(t) && e(t.shadowRoot);
}
function rp(t) {
  return np(t) ? t.host : t.parentNode;
}
const fa = 100, op = 100, Jo = "data-dd-excluded-activity-mutations";
function bo(t, e, n, r, o, i) {
  const s = sp(t, e, n, r);
  return ip(s, o, i);
}
function ip(t, e, n) {
  let r, o = !1;
  const i = At(G(() => u({ hadActivity: !1 })), fa), s = n !== void 0 ? At(G(() => u({ hadActivity: !0, end: It() })), n) : void 0, a = t.subscribe(({ isBusy: f }) => {
    Kt(i), Kt(r);
    const l = It();
    f || (r = At(G(() => u({ hadActivity: !0, end: l })), op));
  }), c = () => {
    o = !0, Kt(i), Kt(r), Kt(s), a.unsubscribe();
  };
  function u(f) {
    o || (c(), e(f));
  }
  return { stop: c };
}
function sp(t, e, n, r) {
  return new nt((o) => {
    const i = [];
    let s, a = 0;
    return i.push(e.subscribe((u) => {
      u.every(ap) || c();
    }), n.subscribe(c), Zt(r, { type: rt.RESOURCE }).subscribe((u) => {
      u.some((f) => !Ar(r, f.name)) && c();
    }), t.subscribe(7, (u) => {
      Ar(r, u.url) || (s === void 0 && (s = u.requestIndex), a += 1, c());
    }), t.subscribe(8, (u) => {
      Ar(r, u.url) || s === void 0 || // If the request started before the tracking start, ignore it
      u.requestIndex < s || (a -= 1, c());
    })), () => {
      i.forEach((u) => u.unsubscribe());
    };
    function c() {
      o.notify({ isBusy: a > 0 });
    }
  });
}
function Ar(t, e) {
  return ro(t.excludedActivityUrls, e);
}
function ap(t) {
  const e = t.type === "characterData" ? t.target.parentElement : t.target;
  return !!(e && Ie(e) && e.matches(`[${Jo}], [${Jo}] *`));
}
const ct = {
  IGNORE: "ignore",
  HIDDEN: "hidden",
  ALLOW: ln.ALLOW,
  MASK: ln.MASK,
  MASK_USER_INPUT: ln.MASK_USER_INPUT
}, cp = "data-dd-privacy", s_ = "hidden", up = "dd-privacy-", Ir = "***", a_ = "data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==", lp = {
  INPUT: !0,
  OUTPUT: !0,
  TEXTAREA: !0,
  SELECT: !0,
  OPTION: !0,
  DATALIST: !0,
  OPTGROUP: !0
}, dp = "x";
function pa(t, e, n) {
  if (n && n.has(t))
    return n.get(t);
  const r = rp(t), o = r ? pa(r, e, n) : e, i = pp(t), s = fp(i, o);
  return n && n.set(t, s), s;
}
function fp(t, e) {
  switch (e) {
    // These values cannot be overridden
    case ct.HIDDEN:
    case ct.IGNORE:
      return e;
  }
  switch (t) {
    case ct.ALLOW:
    case ct.MASK:
    case ct.MASK_USER_INPUT:
    case ct.HIDDEN:
    case ct.IGNORE:
      return t;
    default:
      return e;
  }
}
function pp(t) {
  if (Ie(t)) {
    if (t.tagName === "BASE")
      return ct.ALLOW;
    if (t.tagName === "INPUT") {
      const e = t;
      if (e.type === "password" || e.type === "email" || e.type === "tel" || e.type === "hidden")
        return ct.MASK;
      const n = e.getAttribute("autocomplete");
      if (n && (n.startsWith("cc-") || n.endsWith("-password")))
        return ct.MASK;
    }
    if (t.matches(Fe(ct.HIDDEN)))
      return ct.HIDDEN;
    if (t.matches(Fe(ct.MASK)))
      return ct.MASK;
    if (t.matches(Fe(ct.MASK_USER_INPUT)))
      return ct.MASK_USER_INPUT;
    if (t.matches(Fe(ct.ALLOW)))
      return ct.ALLOW;
    if (mp(t))
      return ct.IGNORE;
  }
}
function hp(t, e) {
  switch (e) {
    case ct.MASK:
    case ct.HIDDEN:
    case ct.IGNORE:
      return !0;
    case ct.MASK_USER_INPUT:
      return la(t) ? Zo(t.parentNode) : Zo(t);
    default:
      return !1;
  }
}
function Zo(t) {
  if (!t || t.nodeType !== t.ELEMENT_NODE)
    return !1;
  const e = t;
  if (e.tagName === "INPUT")
    switch (e.type) {
      case "button":
      case "color":
      case "reset":
      case "submit":
        return !1;
    }
  return !!lp[e.tagName];
}
const gp = (t) => t.replace(/\S/g, dp);
function c_(t, e, n) {
  var r;
  const o = (r = t.parentElement) === null || r === void 0 ? void 0 : r.tagName;
  let i = t.textContent || "";
  if (e && !i.trim())
    return;
  const s = n;
  if (o === "SCRIPT")
    i = Ir;
  else if (s === ct.HIDDEN)
    i = Ir;
  else if (hp(t, s))
    if (
      // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
      o === "DATALIST" || o === "SELECT" || o === "OPTGROUP"
    ) {
      if (!i.trim())
        return;
    } else o === "OPTION" ? i = Ir : i = gp(i);
  return i;
}
function mp(t) {
  if (t.nodeName === "SCRIPT")
    return !0;
  if (t.nodeName === "LINK") {
    const n = e("rel");
    return (
      // Link as script - Ignore only when rel=preload, modulepreload or prefetch
      /preload|prefetch/i.test(n) && e("as") === "script" || // Favicons
      n === "shortcut icon" || n === "icon"
    );
  }
  if (t.nodeName === "META") {
    const n = e("name"), r = e("rel"), o = e("property");
    return (
      // Favicons
      /^msapplication-tile(image|color)$/.test(n) || n === "application-name" || r === "icon" || r === "apple-touch-icon" || r === "shortcut icon" || // Description
      n === "keywords" || n === "description" || // Social
      /^(og|twitter|fb):/.test(o) || /^(og|twitter):/.test(n) || n === "pinterest" || // Robots
      n === "robots" || n === "googlebot" || n === "bingbot" || // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
      // X-Translated-By
      t.hasAttribute("http-equiv") || // Authorship
      n === "author" || n === "generator" || n === "framework" || n === "publisher" || n === "progid" || /^article:/.test(o) || /^product:/.test(o) || // Verification
      n === "google-site-verification" || n === "yandex-verification" || n === "csrf-token" || n === "p:domain_verify" || n === "verify-v1" || n === "verification" || n === "shopify-checkout-api-token"
    );
  }
  function e(n) {
    return (t.getAttribute(n) || "").toLowerCase();
  }
  return !1;
}
function Fe(t) {
  return `[${cp}="${t}"], .${up}${t}`;
}
const yo = "data-dd-action-name", _p = "Masked Element";
function bp(t, { enablePrivacyForActionName: e, actionNameAttribute: n }, r) {
  const o = Qo(t, yo) || n && Qo(t, n);
  return o ? {
    name: o,
    nameSource: "custom_attribute"
    /* ActionNameSource.CUSTOM_ATTRIBUTE */
  } : r === ct.MASK ? {
    name: _p,
    nameSource: "mask_placeholder"
    /* ActionNameSource.MASK_PLACEHOLDER */
  } : ti(t, n, yp, e) || ti(t, n, vp, e) || {
    name: "",
    nameSource: "blank"
    /* ActionNameSource.BLANK */
  };
}
function Qo(t, e) {
  const n = t.closest(`[${e}]`);
  if (!n)
    return;
  const r = n.getAttribute(e);
  return ga(ha(r.trim()));
}
const yp = [
  // associated LABEL text
  (t, e) => {
    if ("labels" in t && t.labels && t.labels.length > 0)
      return Bn(t.labels[0], e);
  },
  // INPUT button (and associated) value
  (t) => {
    if (t.nodeName === "INPUT") {
      const e = t, n = e.getAttribute("type");
      if (n === "button" || n === "submit" || n === "reset")
        return {
          name: e.value,
          nameSource: "text_content"
          /* ActionNameSource.TEXT_CONTENT */
        };
    }
  },
  // BUTTON, LABEL or button-like element text
  (t, e, n) => {
    if (t.nodeName === "BUTTON" || t.nodeName === "LABEL" || t.getAttribute("role") === "button")
      return Bn(t, e, n);
  },
  (t) => cn(t, "aria-label"),
  // associated element text designated by the aria-labelledby attribute
  (t, e, n) => {
    const r = t.getAttribute("aria-labelledby");
    if (r)
      return {
        name: r.split(/\s+/).map((o) => wp(t, o)).filter((o) => !!o).map((o) => ma(o, e, n)).join(" "),
        nameSource: "text_content"
      };
  },
  (t) => cn(t, "alt"),
  (t) => cn(t, "name"),
  (t) => cn(t, "title"),
  (t) => cn(t, "placeholder"),
  // SELECT first OPTION text
  (t, e) => {
    if ("options" in t && t.options.length > 0)
      return Bn(t.options[0], e);
  }
], vp = [
  (t, e, n) => Bn(t, e, n)
], Ep = 10;
function ti(t, e, n, r) {
  let o = t, i = 0;
  for (; i <= Ep && o && o.nodeName !== "BODY" && o.nodeName !== "HTML" && o.nodeName !== "HEAD"; ) {
    for (const s of n) {
      const a = s(o, e, r);
      if (a) {
        const { name: c, nameSource: u } = a, f = c && c.trim();
        if (f)
          return { name: ga(ha(f)), nameSource: u };
      }
    }
    if (o.nodeName === "FORM")
      break;
    o = o.parentElement, i += 1;
  }
}
function ha(t) {
  return t.replace(/\s+/g, " ");
}
function ga(t) {
  return t.length > 100 ? `${$i(t, 100)} [...]` : t;
}
function wp(t, e) {
  return t.ownerDocument ? t.ownerDocument.getElementById(e) : null;
}
function cn(t, e) {
  return {
    name: t.getAttribute(e) || "",
    nameSource: "standard_attribute"
  };
}
function Bn(t, e, n) {
  return {
    name: ma(t, e, n) || "",
    nameSource: "text_content"
  };
}
function ma(t, e, n) {
  if (!t.isContentEditable) {
    if ("innerText" in t) {
      let r = t.innerText;
      const o = (i) => {
        const s = t.querySelectorAll(i);
        for (let a = 0; a < s.length; a += 1) {
          const c = s[a];
          if ("innerText" in c) {
            const u = c.innerText;
            u && u.trim().length > 0 && (r = r.replace(u, ""));
          }
        }
      };
      return o(`[${yo}]`), e && o(`[${e}]`), n && o(`${Fe(ct.HIDDEN)}, ${Fe(ct.MASK)}`), r;
    }
    return t.textContent;
  }
}
const Sp = [
  yo,
  // Common test attributes (list provided by google recorder)
  "data-testid",
  "data-test",
  "data-qa",
  "data-cy",
  "data-test-id",
  "data-qa-id",
  "data-testing",
  // FullStory decorator attributes:
  "data-component",
  "data-element",
  "data-source-file"
], Tp = [ba, Ap], Cp = [
  ba,
  Ip,
  Rp
];
function Sn(t, e) {
  if (!t.isConnected)
    return;
  let n, r = t;
  for (; r && r.nodeName !== "HTML"; ) {
    const o = ei(r, Tp, Op, e, n);
    if (o)
      return o;
    n = ei(r, Cp, kp, e, n) || ir(xp(r), n), r = r.parentElement;
  }
  return n;
}
function _a(t) {
  return /[0-9]/.test(t);
}
function Ap(t) {
  if (t.id && !_a(t.id))
    return `#${CSS.escape(t.id)}`;
}
function Ip(t) {
  if (t.tagName === "BODY")
    return;
  const e = t.classList;
  for (let n = 0; n < e.length; n += 1) {
    const r = e[n];
    if (!_a(r))
      return `${CSS.escape(t.tagName)}.${CSS.escape(r)}`;
  }
}
function Rp(t) {
  return CSS.escape(t.tagName);
}
function ba(t, e) {
  if (e) {
    const r = n(e);
    if (r)
      return r;
  }
  for (const r of Sp) {
    const o = n(r);
    if (o)
      return o;
  }
  function n(r) {
    if (t.hasAttribute(r))
      return `${CSS.escape(t.tagName)}[${r}="${CSS.escape(t.getAttribute(r))}"]`;
  }
}
function xp(t) {
  let e = t.parentElement.firstElementChild, n = 1;
  for (; e && e !== t; )
    e.tagName === t.tagName && (n += 1), e = e.nextElementSibling;
  return `${CSS.escape(t.tagName)}:nth-of-type(${n})`;
}
function ei(t, e, n, r, o) {
  for (const i of e) {
    const s = i(t, r);
    if (s && n(t, s, o))
      return ir(s, o);
  }
}
function Op(t, e, n) {
  return t.ownerDocument.querySelectorAll(ir(e, n)).length === 1;
}
function kp(t, e, n) {
  let r;
  if (n === void 0)
    r = (s) => s.matches(e);
  else {
    const s = ir(`${e}:scope`, n);
    r = (a) => a.querySelector(s) !== null;
  }
  let i = t.parentElement.firstElementChild;
  for (; i; ) {
    if (i !== t && r(i))
      return !1;
    i = i.nextElementSibling;
  }
  return !0;
}
function ir(t, e) {
  return e ? `${t}>${e}` : t;
}
const ya = Pt, Lp = 100;
function Np(t, e) {
  const n = [];
  let r = 0, o;
  i(t);
  function i(c) {
    c.stopObservable.subscribe(s), n.push(c), Kt(o), o = At(a, ya);
  }
  function s() {
    r === 1 && n.every((c) => c.isStopped()) && (r = 2, e(n));
  }
  function a() {
    Kt(o), r === 0 && (r = 1, s());
  }
  return {
    tryAppend: (c) => r !== 0 ? !1 : n.length > 0 && !Pp(n[n.length - 1].event, c.event) ? (a(), !1) : (i(c), !0),
    stop: () => {
      a();
    }
  };
}
function Pp(t, e) {
  return t.target === e.target && Up(t, e) <= Lp && t.timeStamp - e.timeStamp <= ya;
}
function Up(t, e) {
  return Math.sqrt(Math.pow(t.clientX - e.clientX, 2) + Math.pow(t.clientY - e.clientY, 2));
}
function Mp(t, { onPointerDown: e, onPointerUp: n }) {
  let r, o = {
    selection: !1,
    input: !1,
    scroll: !1
  }, i;
  const s = [
    mt(t, window, "pointerdown", (a) => {
      ri(a) && (r = ni(), o = {
        selection: !1,
        input: !1,
        scroll: !1
      }, i = e(a));
    }, { capture: !0 }),
    mt(t, window, "selectionchange", () => {
      (!r || !ni()) && (o.selection = !0);
    }, { capture: !0 }),
    mt(t, window, "scroll", () => {
      o.scroll = !0;
    }, { capture: !0, passive: !0 }),
    mt(t, window, "pointerup", (a) => {
      if (ri(a) && i) {
        const c = o;
        n(i, a, () => c), i = void 0;
      }
    }, { capture: !0 }),
    mt(t, window, "input", () => {
      o.input = !0;
    }, { capture: !0 })
  ];
  return {
    stop: () => {
      s.forEach((a) => a.stop());
    }
  };
}
function ni() {
  const t = window.getSelection();
  return !t || t.isCollapsed;
}
function ri(t) {
  return t.target instanceof Element && // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
  // the future.
  t.isPrimary !== !1;
}
const oi = 3;
function Dp(t, e) {
  if (Bp(t))
    return e.addFrustration(sn.RAGE_CLICK), t.some(ii) && e.addFrustration(sn.DEAD_CLICK), e.hasError && e.addFrustration(sn.ERROR_CLICK), { isRage: !0 };
  const n = t.some((r) => r.getUserActivity().selection);
  return t.forEach((r) => {
    r.hasError && r.addFrustration(sn.ERROR_CLICK), ii(r) && // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
    !n && r.addFrustration(sn.DEAD_CLICK);
  }), { isRage: !1 };
}
function Bp(t) {
  if (t.some((e) => e.getUserActivity().selection || e.getUserActivity().scroll))
    return !1;
  for (let e = 0; e < t.length - (oi - 1); e += 1)
    if (t[e + oi - 1].event.timeStamp - t[e].event.timeStamp <= Pt)
      return !0;
  return !1;
}
const Fp = (
  // inputs that don't trigger a meaningful event like "input" when clicked, including textual
  // inputs (using a negative selector is shorter here)
  'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),textarea,select,[contenteditable],[contenteditable] *,canvas,a[href],a[href] *'
);
function ii(t) {
  if (t.hasPageActivity || t.getUserActivity().input || t.getUserActivity().scroll)
    return !1;
  let e = t.event.target;
  return e.tagName === "LABEL" && e.hasAttribute("for") && (e = document.getElementById(e.getAttribute("for"))), !e || !e.matches(Fp);
}
const va = 10 * Pt, dn = /* @__PURE__ */ new Map();
function Vp(t) {
  const e = dn.get(t);
  return dn.delete(t), e;
}
function Ea(t, e) {
  dn.set(t, e), dn.forEach((n, r) => {
    Ct(r, zt()) > va && dn.delete(r);
  });
}
const $p = 5 * $t;
function jp(t, e, n, r) {
  const o = en({ expireDelay: $p }), i = new nt();
  let s;
  t.subscribe(10, () => {
    o.reset();
  }), t.subscribe(5, f), t.subscribe(11, (l) => {
    l.reason === Ve.UNLOADING && f();
  });
  const { stop: a } = Mp(r, {
    onPointerDown: (l) => zp(r, t, e, l, n),
    onPointerUp: ({ clickActionBase: l, hadActivityOnPointerDown: g }, O, E) => {
      Gp(r, t, e, n, o, i, u, l, O, E, g);
    }
  });
  return {
    stop: () => {
      f(), i.notify(), a();
    },
    actionContexts: {
      findActionId: (l) => o.findAll(l)
    }
  };
  function u(l) {
    if (!s || !s.tryAppend(l)) {
      const g = l.clone();
      s = Np(l, (O) => {
        Kp(O, g);
      });
    }
  }
  function f() {
    s && s.stop();
  }
}
function zp(t, e, n, r, o) {
  const i = t.enablePrivacyForActionName ? pa(r.target, t.defaultPrivacyLevel) : ct.ALLOW;
  if (i === ct.HIDDEN)
    return;
  const s = Hp(r, i, t);
  let a = !1;
  return bo(
    e,
    n,
    o,
    t,
    (c) => {
      a = c.hadActivity;
    },
    // We don't care about the activity duration, we just want to know whether an activity did happen
    // within the "validation delay" or not. Limit the duration so the callback is called sooner.
    fa
  ), { clickActionBase: s, hadActivityOnPointerDown: () => a };
}
function Gp(t, e, n, r, o, i, s, a, c, u, f) {
  var l;
  const g = wa(e, o, u, a, c);
  s(g);
  const O = (l = a == null ? void 0 : a.target) === null || l === void 0 ? void 0 : l.selector;
  O && Ea(c.timeStamp, O);
  const { stop: E } = bo(e, n, r, t, (x) => {
    x.hadActivity && x.end < g.startClocks.timeStamp ? g.discard() : x.hadActivity ? g.stop(x.end) : f() ? g.stop(
      // using the click start as activity end, so the click will have some activity but its
      // duration will be 0 (as the activity started before the click start)
      g.startClocks.timeStamp
    ) : g.stop();
  }, va), A = e.subscribe(5, ({ endClocks: x }) => {
    g.stop(x.timeStamp);
  }), v = i.subscribe(() => {
    g.stop();
  });
  g.stopObservable.subscribe(() => {
    A.unsubscribe(), E(), v.unsubscribe();
  });
}
function Hp(t, e, n) {
  const r = t.target.getBoundingClientRect(), o = Sn(t.target, n.actionNameAttribute);
  o && Ea(t.timeStamp, o);
  const i = bp(t.target, n, e);
  return {
    type: mo.CLICK,
    target: {
      width: Math.round(r.width),
      height: Math.round(r.height),
      selector: o
    },
    position: {
      // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
      x: Math.round(t.clientX - r.left),
      y: Math.round(t.clientY - r.top)
    },
    name: i.name,
    nameSource: i.nameSource
  };
}
function wa(t, e, n, r, o) {
  const i = Ot(), s = xt(), a = e.add(i, s.relative), c = ua({
    lifeCycle: t,
    isChildEvent: (E) => E.action !== void 0 && (Array.isArray(E.action.id) ? E.action.id.includes(i) : E.action.id === i)
  });
  let u = 0, f;
  const l = [], g = new nt();
  function O(E) {
    u === 0 && (f = E, u = 1, f ? a.close(qn(f)) : a.remove(), c.stop(), g.notify());
  }
  return {
    event: o,
    stop: O,
    stopObservable: g,
    get hasError() {
      return c.eventCounts.errorCount > 0;
    },
    get hasPageActivity() {
      return f !== void 0;
    },
    getUserActivity: n,
    addFrustration: (E) => {
      l.push(E);
    },
    startClocks: s,
    isStopped: () => u === 1 || u === 2,
    clone: () => wa(t, e, n, r, o),
    validate: (E) => {
      if (O(), u !== 1)
        return;
      const { resourceCount: A, errorCount: v, longTaskCount: x } = c.eventCounts, k = {
        duration: f && Ct(s.timeStamp, f),
        startClocks: s,
        id: i,
        frustrationTypes: l,
        counts: {
          resourceCount: A,
          errorCount: v,
          longTaskCount: x
        },
        events: E ?? [o],
        event: o,
        ...r
      };
      t.notify(0, k), u = 2;
    },
    discard: () => {
      O(), u = 2;
    }
  };
}
function Kp(t, e) {
  const { isRage: n } = Dp(t, e);
  n ? (t.forEach((r) => r.discard()), e.stop(It()), e.validate(t.map((r) => r.event))) : (e.discard(), t.forEach((r) => r.validate()));
}
function Yp(t, e, n, r, o) {
  t.subscribe(0, (a) => t.notify(12, si(a))), e.register(0, ({ startTime: a, eventType: c }) => {
    if (c !== Y.ERROR && c !== Y.RESOURCE && c !== Y.LONG_TASK)
      return Ft;
    const u = i.findActionId(a);
    return u ? {
      type: c,
      action: { id: u }
    } : Ft;
  }), e.register(1, ({ startTime: a }) => ({
    action: { id: i.findActionId(a) }
  }));
  let i = { findActionId: it }, s = it;
  return o.trackUserInteractions && ({ actionContexts: i, stop: s } = jp(t, n, r, o)), {
    addAction: (a) => {
      t.notify(12, si(a));
    },
    actionContexts: i,
    stop: s
  };
}
function si(t) {
  const e = On(t) ? {
    action: {
      id: t.id,
      loading_time: ca(K(t.duration)),
      frustration: {
        type: t.frustrationTypes
      },
      error: {
        count: t.counts.errorCount
      },
      long_task: {
        count: t.counts.longTaskCount
      },
      resource: {
        count: t.counts.resourceCount
      }
    },
    _dd: {
      action: {
        target: t.target,
        position: t.position,
        name_source: t.nameSource
      }
    }
  } : void 0, n = Vt({
    action: { id: Ot(), target: { name: t.name }, type: t.type },
    date: t.startClocks.timeStamp,
    type: Y.ACTION
  }, e), r = On(t) ? t.duration : void 0, o = On(t) ? void 0 : t.context, i = On(t) ? { events: t.events } : { handlingStack: t.handlingStack };
  return {
    customerContext: o,
    rawRumEvent: n,
    duration: r,
    startTime: t.startClocks.relative,
    domainContext: i
  };
}
function On(t) {
  return t.type !== mo.CUSTOM;
}
function Wp(t) {
  const e = Bs([Et.error]).subscribe((n) => t.notify(n.error));
  return {
    stop: () => {
      e.unsubscribe();
    }
  };
}
function qp(t, e) {
  const n = ks(t, [
    Ke.cspViolation,
    Ke.intervention
  ]).subscribe((r) => e.notify(r));
  return {
    stop: () => {
      n.unsubscribe();
    }
  };
}
function Xp(t, e, n) {
  const r = new nt();
  return n.subscribe((o) => {
    o.type === 0 && r.notify(o.error);
  }), Wp(r), qp(e, r), r.subscribe((o) => t.notify(14, { error: o })), Jp(t);
}
function Jp(t) {
  return t.subscribe(14, ({ error: e, customerContext: n }) => {
    n = Vt(e.context, n), t.notify(12, {
      customerContext: n,
      ...Zp(e)
    });
  }), {
    addError: ({ error: e, handlingStack: n, componentStack: r, startClocks: o, context: i }) => {
      const s = Qn({
        originalError: e,
        handlingStack: n,
        componentStack: r,
        startClocks: o,
        nonErrorPrefix: "Provided",
        source: jt.CUSTOM,
        handling: "handled"
      });
      t.notify(14, {
        customerContext: i,
        error: s
      });
    }
  };
}
function Zp(t) {
  const e = {
    date: t.startClocks.timeStamp,
    error: {
      id: Ot(),
      message: t.message,
      source: t.source,
      stack: t.stack,
      handling_stack: t.handlingStack,
      component_stack: t.componentStack,
      type: t.type,
      handling: t.handling,
      causes: t.causes,
      source_type: "browser",
      fingerprint: t.fingerprint,
      csp: t.csp
    },
    type: Y.ERROR
  }, n = {
    error: t.originalError,
    handlingStack: t.handlingStack
  };
  return {
    rawRumEvent: e,
    startTime: t.startClocks.relative,
    domainContext: n
  };
}
const ai = /* @__PURE__ */ new WeakSet();
function Qp(t) {
  if (!performance || !("getEntriesByName" in performance))
    return;
  const e = performance.getEntriesByName(t.url, "resource");
  if (!e.length || !("toJSON" in e[0]))
    return;
  const n = e.filter((r) => !ai.has(r)).filter((r) => ra(r) && oa(r)).filter((r) => th(r, t.startClocks.relative, Sa({ startTime: t.startClocks.relative, duration: t.duration })));
  if (n.length === 1)
    return ai.add(n[0]), n[0].toJSON();
}
function Sa(t) {
  return We(t.startTime, t.duration);
}
function th(t, e, n) {
  return t.startTime >= e - 1 && Sa(t) <= We(n, 1);
}
const eh = 2 * $t;
function nh(t) {
  const e = rh(t) || oh(t);
  if (!(!e || e.traceTime <= Yt() - eh))
    return e.traceId;
}
function rh(t) {
  const e = t.querySelector("meta[name=dd-trace-id]"), n = t.querySelector("meta[name=dd-trace-time]");
  return Ta(e && e.content, n && n.content);
}
function oh(t) {
  const e = ih(t);
  if (e)
    return Ta(hn(e, "trace-id"), hn(e, "trace-time"));
}
function Ta(t, e) {
  const n = e && Number(e);
  if (!(!t || !n))
    return {
      traceId: t,
      traceTime: n
    };
}
function ih(t) {
  for (let e = 0; e < t.childNodes.length; e += 1) {
    const n = ci(t.childNodes[e]);
    if (n)
      return n;
  }
  if (t.body)
    for (let e = t.body.childNodes.length - 1; e >= 0; e -= 1) {
      const n = t.body.childNodes[e], r = ci(n);
      if (r)
        return r;
      if (!la(n))
        break;
    }
}
function ci(t) {
  if (t && ep(t)) {
    const e = /^\s*DATADOG;(.*?)\s*$/.exec(t.data);
    if (e)
      return e[1];
  }
}
function Ca() {
  if (Ae(rt.NAVIGATION)) {
    const n = performance.getEntriesByType(rt.NAVIGATION)[0];
    if (n)
      return n;
  }
  const t = sh(), e = {
    entryType: rt.NAVIGATION,
    initiatorType: "navigation",
    name: window.location.href,
    startTime: 0,
    duration: t.loadEventEnd,
    decodedBodySize: 0,
    encodedBodySize: 0,
    transferSize: 0,
    workerStart: 0,
    toJSON: () => ({ ...e, toJSON: void 0 }),
    ...t
  };
  return e;
}
function sh() {
  const t = {}, e = performance.timing;
  for (const n in e)
    if (bn(e[n])) {
      const r = n, o = e[r];
      t[r] = o === 0 ? 0 : qn(o);
    }
  return t;
}
function ah(t, e, n = Ca) {
  co(t, "interactive", () => {
    const r = n(), o = Object.assign(r.toJSON(), {
      entryType: rt.RESOURCE,
      initiatorType: ea,
      // The ResourceTiming duration entry should be `responseEnd - startTime`. With
      // NavigationTiming entries, `startTime` is always 0, so set it to `responseEnd`.
      duration: r.responseEnd,
      traceId: nh(document),
      toJSON: () => ({ ...o, toJSON: void 0 })
    });
    e(o);
  });
}
function ch(t, e, n, r = fd(), o = ah) {
  t.subscribe(8, (a) => {
    s(() => uh(a, e, n));
  });
  const i = Zt(e, {
    type: rt.RESOURCE,
    buffered: !0
  }).subscribe((a) => {
    for (const c of a)
      Ff(c) || s(() => ui(c, e));
  });
  o(e, (a) => {
    s(() => ui(a, e));
  });
  function s(a) {
    r.push(() => {
      const c = a();
      c && t.notify(12, c);
    });
  }
  return {
    stop: () => {
      i.unsubscribe();
    }
  };
}
function uh(t, e, n) {
  const r = Qp(t), o = r ? yn(r.startTime) : t.startClocks, i = lh(t, e);
  if (!e.trackResources && !i)
    return;
  const s = t.type === Ye.XHR ? Bt.XHR : Bt.FETCH, a = r ? Aa(r) : void 0, c = r ? na(r) : fh(n, o, t.duration), u = Vt({
    date: o.timeStamp,
    resource: {
      id: Ot(),
      type: s,
      duration: K(c),
      method: t.method,
      status_code: t.status,
      protocol: r && ia(r),
      url: Hf(t.url),
      delivery_type: r && sa(r)
    },
    type: Y.RESOURCE,
    _dd: {
      discarded: !e.trackResources
    }
  }, i, a);
  return {
    startTime: o.relative,
    duration: c,
    rawRumEvent: u,
    domainContext: {
      performanceEntry: r,
      xhr: t.xhr,
      response: t.response,
      requestInput: t.input,
      requestInit: t.init,
      error: t.error,
      isAborted: t.isAborted,
      handlingStack: t.handlingStack
    }
  };
}
function ui(t, e) {
  const n = yn(t.startTime), r = dh(t, e);
  if (!e.trackResources && !r)
    return;
  const o = Bf(t), i = Aa(t), s = na(t), a = Vt({
    date: n.timeStamp,
    resource: {
      id: Ot(),
      type: o,
      duration: K(s),
      url: t.name,
      status_code: ph(t.responseStatus),
      protocol: ia(t),
      delivery_type: sa(t)
    },
    type: Y.RESOURCE,
    _dd: {
      discarded: !e.trackResources
    }
  }, r, i);
  return {
    startTime: n.relative,
    duration: s,
    rawRumEvent: a,
    domainContext: {
      performanceEntry: t
    }
  };
}
function Aa(t) {
  const { renderBlockingStatus: e } = t;
  return {
    resource: {
      render_blocking_status: e,
      ...jf(t),
      ...Vf(t)
    }
  };
}
function lh(t, e) {
  if (t.traceSampled && t.traceId && t.spanId)
    return {
      _dd: {
        span_id: t.spanId.toString(),
        trace_id: t.traceId.toString(),
        rule_psr: e.rulePsr
      }
    };
}
function dh(t, e) {
  if (t.traceId)
    return {
      _dd: {
        trace_id: t.traceId,
        span_id: Zs().toString(),
        rule_psr: e.rulePsr
      }
    };
}
function fh(t, e, n) {
  return t.wasInPageStateDuringPeriod("frozen", e.relative, n) ? void 0 : n;
}
function ph(t) {
  return t === 0 ? void 0 : t;
}
function hh(t, e, n) {
  const { stop: r, eventCounts: o } = ua({
    lifeCycle: t,
    isChildEvent: (i) => i.view.id === e,
    onChange: n
  });
  return {
    stop: r,
    eventCounts: o
  };
}
const gh = 10 * $t;
function mh(t, e, n) {
  return {
    stop: Zt(t, {
      type: rt.PAINT,
      buffered: !0
    }).subscribe((o) => {
      const i = o.find((s) => s.name === "first-contentful-paint" && s.startTime < e.timeStamp && s.startTime < gh);
      i && n(i.startTime);
    }).unsubscribe
  };
}
function _h(t, e) {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      e(Ct(t, zt()));
    });
  });
}
function bh(t, e, n) {
  const r = Zt(t, {
    type: rt.FIRST_INPUT,
    buffered: !0
  }).subscribe((o) => {
    const i = o.find((s) => s.startTime < e.timeStamp);
    if (i) {
      const s = Ct(i.startTime, i.processingStart);
      let a;
      i.target && Ie(i.target) && (a = Sn(i.target, t.actionNameAttribute)), n({
        // Ensure firstInputDelay to be positive, see
        // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
        delay: s >= 0 ? s : 0,
        time: i.startTime,
        targetSelector: a
      });
    }
  });
  return {
    stop: () => {
      r.unsubscribe();
    }
  };
}
function yh(t, e, n = Ca) {
  return wh(t, () => {
    const r = n();
    Eh(r) || e(vh(r));
  });
}
function vh(t) {
  return {
    domComplete: t.domComplete,
    domContentLoaded: t.domContentLoadedEventEnd,
    domInteractive: t.domInteractive,
    loadEvent: t.loadEventEnd,
    // In some cases the value reported is negative or is larger
    // than the current page time. Ignore these cases:
    // https://github.com/GoogleChrome/web-vitals/issues/137
    // https://github.com/GoogleChrome/web-vitals/issues/162
    firstByte: t.responseStart >= 0 && t.responseStart <= zt() ? t.responseStart : void 0
  };
}
function Eh(t) {
  return t.loadEventEnd <= 0;
}
function wh(t, e) {
  let n;
  const { stop: r } = co(t, "complete", () => {
    n = At(() => e());
  });
  return {
    stop: () => {
      r(), Kt(n);
    }
  };
}
const Sh = 10 * $t;
function Th(t, e, n, r) {
  let o = 1 / 0;
  const { stop: i } = pe(t, n, [
    "pointerdown",
    "keydown"
    /* DOM_EVENT.KEY_DOWN */
  ], (c) => {
    o = c.timeStamp;
  }, { capture: !0, once: !0 });
  let s = 0;
  const a = Zt(t, {
    type: rt.LARGEST_CONTENTFUL_PAINT,
    buffered: !0
  }).subscribe((c) => {
    const u = jc(c, (f) => f.entryType === rt.LARGEST_CONTENTFUL_PAINT && f.startTime < o && f.startTime < e.timeStamp && f.startTime < Sh && // Ensure to get the LCP entry with the biggest size, see
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1516655
    f.size > s);
    if (u) {
      let f;
      u.element && (f = Sn(u.element, t.actionNameAttribute)), r({
        value: u.startTime,
        targetSelector: f,
        resourceUrl: Ch(u)
      }), s = u.size;
    }
  });
  return {
    stop: () => {
      i(), a.unsubscribe();
    }
  };
}
function Ch(t) {
  return t.url === "" ? void 0 : t.url;
}
function Ia(t, e, n = window) {
  if (document.visibilityState === "hidden")
    return { timeStamp: 0, stop: it };
  if (Ae(rt.VISIBILITY_STATE)) {
    const i = performance.getEntriesByType(rt.VISIBILITY_STATE).filter((s) => s.name === "hidden").find((s) => s.startTime >= e.relative);
    if (i)
      return { timeStamp: i.startTime, stop: it };
  }
  let r = 1 / 0;
  const { stop: o } = pe(t, n, [
    "pagehide",
    "visibilitychange"
    /* DOM_EVENT.VISIBILITY_CHANGE */
  ], (i) => {
    (i.type === "pagehide" || document.visibilityState === "hidden") && (r = i.timeStamp, o());
  }, { capture: !0 });
  return {
    get timeStamp() {
      return r;
    },
    stop: o
  };
}
function Ah(t, e, n, r) {
  const o = {}, { stop: i } = yh(t, (l) => {
    n(l.loadEvent), o.navigationTimings = l, r();
  }), s = Ia(t, e), { stop: a } = mh(t, s, (l) => {
    o.firstContentfulPaint = l, r();
  }), { stop: c } = Th(t, s, window, (l) => {
    o.largestContentfulPaint = l, r();
  }), { stop: u } = bh(t, s, (l) => {
    o.firstInput = l, r();
  });
  function f() {
    i(), a(), c(), u(), s.stop();
  }
  return {
    stop: f,
    initialViewMetrics: o
  };
}
const zr = (t, e) => t * e, Ih = (t, e) => {
  const n = Math.max(t.left, e.left), r = Math.max(t.top, e.top), o = Math.min(t.right, e.right), i = Math.min(t.bottom, e.bottom);
  return n >= o || r >= i ? 0 : zr(o - n, i - r);
}, li = (t) => {
  const e = zr(t.previousRect.width, t.previousRect.height), n = zr(t.currentRect.width, t.currentRect.height), r = Ih(t.previousRect, t.currentRect);
  return e + n - r;
};
function Rh(t, e, n) {
  if (!Nh())
    return {
      stop: it
    };
  let r = 0, o;
  n({
    value: 0
  });
  const i = Lh(), s = Zt(t, {
    type: rt.LAYOUT_SHIFT,
    buffered: !0
  }).subscribe((a) => {
    var c;
    for (const u of a) {
      if (u.hadRecentInput || u.startTime < e)
        continue;
      const { cumulatedValue: f, isMaxValue: l } = i.update(u);
      if (l) {
        const g = xh(u.sources);
        o = {
          target: g != null && g.node ? new WeakRef(g.node) : void 0,
          time: Ct(e, u.startTime),
          previousRect: g == null ? void 0 : g.previousRect,
          currentRect: g == null ? void 0 : g.currentRect,
          devicePixelRatio: window.devicePixelRatio
        };
      }
      if (f > r) {
        r = f;
        const g = (c = o == null ? void 0 : o.target) === null || c === void 0 ? void 0 : c.deref();
        n({
          value: un(r, 4),
          targetSelector: g && Sn(g, t.actionNameAttribute),
          time: o == null ? void 0 : o.time,
          previousRect: o != null && o.previousRect ? di(o.previousRect) : void 0,
          currentRect: o != null && o.currentRect ? di(o.currentRect) : void 0,
          devicePixelRatio: o == null ? void 0 : o.devicePixelRatio
        });
      }
    }
  });
  return {
    stop: () => {
      s.unsubscribe();
    }
  };
}
function xh(t) {
  let e;
  for (const n of t)
    if (n.node && Ie(n.node)) {
      const r = li(n);
      (!e || li(e) < r) && (e = n);
    }
  return e;
}
function di({ x: t, y: e, width: n, height: r }) {
  return { x: t, y: e, width: n, height: r };
}
const Oh = 5 * Pt, kh = Pt;
function Lh() {
  let t = 0, e, n, r = 0;
  return {
    update: (o) => {
      const i = e === void 0 || o.startTime - n >= kh || o.startTime - e >= Oh;
      let s;
      return i ? (e = n = o.startTime, r = t = o.value, s = !0) : (t += o.value, n = o.startTime, s = o.value > r, s && (r = o.value)), {
        cumulatedValue: t,
        isMaxValue: s
      };
    }
  };
}
function Nh() {
  return Ae(rt.LAYOUT_SHIFT) && "WeakRef" in window;
}
let Fn, Ra = 0, Rr = 1 / 0, xr = 0;
function Ph() {
  "interactionCount" in performance || Fn || (Fn = new window.PerformanceObserver(G((t) => {
    t.getEntries().forEach((e) => {
      const n = e;
      n.interactionId && (Rr = Math.min(Rr, n.interactionId), xr = Math.max(xr, n.interactionId), Ra = (xr - Rr) / 7 + 1);
    });
  })), Fn.observe({ type: "event", buffered: !0, durationThreshold: 0 }));
}
const fi = () => Fn ? Ra : window.performance.interactionCount || 0, pi = 10, Uh = 1 * $t;
function Mh(t, e, n) {
  if (!Fh())
    return {
      getInteractionToNextPaint: () => {
      },
      setViewEnd: it,
      stop: it
    };
  const { getViewInteractionCount: r, stopViewInteractionCount: o } = Bh(n);
  let i = 1 / 0;
  const s = Dh(r);
  let a = -1, c, u;
  function f(O) {
    for (const A of O)
      A.interactionId && // Check the entry start time is inside the view bounds because some view interactions can be reported after the view end (if long duration).
      A.startTime >= e && A.startTime <= i && s.process(A);
    const E = s.estimateP98Interaction();
    E && E.duration !== a && (a = E.duration, u = Ct(e, E.startTime), c = Vp(E.startTime), !c && E.target && Ie(E.target) && (c = Sn(E.target, t.actionNameAttribute)));
  }
  const l = Zt(t, {
    type: rt.FIRST_INPUT,
    buffered: !0
  }).subscribe(f), g = Zt(t, {
    type: rt.EVENT,
    // durationThreshold only impact PerformanceEventTiming entries used for INP computation which requires a threshold at 40 (default is 104ms)
    // cf: https://github.com/GoogleChrome/web-vitals/blob/3806160ffbc93c3c4abf210a167b81228172b31c/src/onINP.ts#L202-L210
    durationThreshold: 40,
    buffered: !0
  }).subscribe(f);
  return {
    getInteractionToNextPaint: () => {
      if (a >= 0)
        return {
          value: Math.min(a, Uh),
          targetSelector: c,
          time: u
        };
      if (r())
        return {
          value: 0
        };
    },
    setViewEnd: (O) => {
      i = O, o();
    },
    stop: () => {
      g.unsubscribe(), l.unsubscribe();
    }
  };
}
function Dh(t) {
  const e = [];
  function n() {
    e.sort((r, o) => o.duration - r.duration).splice(pi);
  }
  return {
    /**
     * Process the performance entry:
     * - if its duration is long enough, add the performance entry to the list of worst interactions
     * - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
     */
    process(r) {
      const o = e.findIndex((s) => r.interactionId === s.interactionId), i = e[e.length - 1];
      o !== -1 ? r.duration > e[o].duration && (e[o] = r, n()) : (e.length < pi || r.duration > i.duration) && (e.push(r), n());
    },
    /**
     * Compute the p98 longest interaction.
     * For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
     */
    estimateP98Interaction() {
      const r = Math.min(e.length - 1, Math.floor(t() / 50));
      return e[r];
    }
  };
}
function Bh(t) {
  Ph();
  const e = t === oe.INITIAL_LOAD ? 0 : fi();
  let n = { stopped: !1 };
  function r() {
    return fi() - e;
  }
  return {
    getViewInteractionCount: () => n.stopped ? n.interactionCount : r(),
    stopViewInteractionCount: () => {
      n = { stopped: !0, interactionCount: r() };
    }
  };
}
function Fh() {
  return Ae(rt.EVENT) && window.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype;
}
function Vh(t, e, n, r, o, i, s) {
  let a = o === oe.INITIAL_LOAD, c = !0;
  const u = [], f = Ia(r, i);
  function l() {
    if (!c && !a && u.length > 0) {
      const O = Math.max(...u);
      O < f.timeStamp - i.relative && s(O);
    }
  }
  const { stop: g } = bo(t, e, n, r, (O) => {
    c && (c = !1, O.hadActivity && u.push(Ct(i.timeStamp, O.end)), l());
  });
  return {
    stop: () => {
      g(), f.stop();
    },
    setLoadEvent: (O) => {
      a && (a = !1, u.push(O), l());
    }
  };
}
function u_() {
  let t;
  const e = window.visualViewport;
  return e ? t = e.pageLeft - e.offsetLeft : window.scrollX !== void 0 ? t = window.scrollX : t = window.pageXOffset || 0, Math.round(t);
}
function $h() {
  let t;
  const e = window.visualViewport;
  return e ? t = e.pageTop - e.offsetTop : window.scrollY !== void 0 ? t = window.scrollY : t = window.pageYOffset || 0, Math.round(t);
}
let Or;
function jh(t) {
  return Or || (Or = zh(t)), Or;
}
function zh(t) {
  return new nt((e) => {
    const { throttled: n } = Jn(() => {
      e.notify(vo());
    }, 200);
    return mt(t, window, "resize", n, { capture: !0, passive: !0 }).stop;
  });
}
function vo() {
  const t = window.visualViewport;
  return t ? {
    width: Number(t.width * t.scale),
    height: Number(t.height * t.scale)
  } : {
    width: Number(window.innerWidth || 0),
    height: Number(window.innerHeight || 0)
  };
}
const Gh = Pt;
function Hh(t, e, n, r = Yh(t)) {
  let o = 0, i = 0, s = 0;
  const a = r.subscribe(({ scrollDepth: c, scrollTop: u, scrollHeight: f }) => {
    let l = !1;
    if (c > o && (o = c, l = !0), f > i) {
      i = f;
      const g = zt();
      s = Ct(e.relative, g), l = !0;
    }
    l && n({
      maxDepth: Math.min(o, i),
      maxDepthScrollTop: u,
      maxScrollHeight: i,
      maxScrollHeightTime: s
    });
  });
  return {
    stop: () => a.unsubscribe()
  };
}
function Kh() {
  const t = $h(), { height: e } = vo(), n = Math.round((document.scrollingElement || document.documentElement).scrollHeight), r = Math.round(e + t);
  return {
    scrollHeight: n,
    scrollDepth: r,
    scrollTop: t
  };
}
function Yh(t, e = Gh) {
  return new nt((n) => {
    function r() {
      n.notify(Kh());
    }
    if (window.ResizeObserver) {
      const o = Jn(r, e, {
        leading: !1,
        trailing: !0
      }), i = document.scrollingElement || document.documentElement, s = new ResizeObserver(G(o.throttled));
      i && s.observe(i);
      const a = mt(t, window, "scroll", o.throttled, {
        passive: !0
      });
      return () => {
        o.cancel(), s.disconnect(), a.stop();
      };
    }
  });
}
function Wh(t, e, n, r, o, i, s) {
  const a = {}, { stop: c, setLoadEvent: u } = Vh(t, e, n, r, i, s, (A) => {
    a.loadingTime = A, o();
  }), { stop: f } = Hh(r, s, (A) => {
    a.scroll = A;
  }), { stop: l } = Rh(r, s.relative, (A) => {
    a.cumulativeLayoutShift = A, o();
  }), { stop: g, getInteractionToNextPaint: O, setViewEnd: E } = Mh(r, s.relative, i);
  return {
    stop: () => {
      c(), l(), f();
    },
    stopINPTracking: g,
    setLoadEvent: u,
    setViewEnd: E,
    getCommonViewMetrics: () => (a.interactionToNextPaint = O(), a)
  };
}
function qh(t, e) {
  const { stop: n } = mt(t, window, "pageshow", (r) => {
    r.persisted && e(r);
  }, { capture: !0 });
  return n;
}
function Xh(t, e, n) {
  _h(t.relative, (r) => {
    e.firstContentfulPaint = r, e.largestContentfulPaint = { value: r }, n();
  });
}
const Jh = 3e3, Zh = 5 * $t, Qh = 5 * $t;
function tg(t, e, n, r, o, i, s, a) {
  const c = /* @__PURE__ */ new Set();
  let u = g(oe.INITIAL_LOAD, Mi(), a), f;
  O();
  let l;
  s && (l = E(i), o.trackBfcacheViews && (f = qh(o, (A) => {
    u.end();
    const v = yn(A.timeStamp);
    u = g(oe.BF_CACHE, v, void 0);
  })));
  function g(A, v, x) {
    const k = eg(e, n, r, o, t, A, v, x);
    return c.add(k), k.stopObservable.subscribe(() => {
      c.delete(k);
    }), k;
  }
  function O() {
    e.subscribe(10, () => {
      u = g(oe.ROUTE_CHANGE, void 0, {
        name: u.name,
        service: u.service,
        version: u.version,
        context: u.contextManager.getContext()
      });
    }), e.subscribe(9, () => {
      u.end({ sessionIsActive: !1 });
    });
  }
  function E(A) {
    return A.subscribe(({ oldLocation: v, newLocation: x }) => {
      rg(v, x) && (u.end(), u = g(oe.ROUTE_CHANGE));
    });
  }
  return {
    addTiming: (A, v = It()) => {
      u.addTiming(A, v);
    },
    startView: (A, v) => {
      u.end({ endClocks: v }), u = g(oe.ROUTE_CHANGE, v, A);
    },
    setViewContext: (A) => {
      u.contextManager.setContext(A);
    },
    setViewContextProperty: (A, v) => {
      u.contextManager.setContextProperty(A, v);
    },
    setViewName: (A) => {
      u.setViewName(A);
    },
    getViewContext: () => u.contextManager.getContext(),
    stop: () => {
      l && l.unsubscribe(), f && f(), u.end(), c.forEach((A) => A.stop());
    }
  };
}
function eg(t, e, n, r, o, i, s = xt(), a) {
  const c = Ot(), u = new nt(), f = {};
  let l = 0, g;
  const O = fn(o), E = wn();
  let A = !0, v = a == null ? void 0 : a.name;
  const x = (a == null ? void 0 : a.service) || r.service, k = (a == null ? void 0 : a.version) || r.version, T = a == null ? void 0 : a.context;
  T && E.setContext(T);
  const R = {
    id: c,
    name: v,
    startClocks: s,
    service: x,
    version: k,
    context: T
  };
  t.notify(1, R), t.notify(2, R);
  const { throttled: U, cancel: b } = Jn(J, Jh, {
    leading: !1
  }), { setLoadEvent: C, setViewEnd: h, stop: _, stopINPTracking: p, getCommonViewMetrics: S } = Wh(t, e, n, r, tt, i, s), { stop: I, initialViewMetrics: $ } = i === oe.INITIAL_LOAD ? Ah(r, s, C, tt) : { stop: it, initialViewMetrics: {} };
  i === oe.BF_CACHE && Xh(s, $, tt);
  const { stop: F, eventCounts: z } = hh(t, c, tt), B = qe(J, Zh), ot = t.subscribe(11, (ft) => {
    ft.reason === Ve.UNLOADING && J();
  });
  J(), E.changeObservable.subscribe(tt);
  function gt() {
    t.notify(3, {
      id: c,
      name: v,
      context: E.getContext(),
      startClocks: s,
      sessionIsActive: A
    });
  }
  function tt() {
    gt(), U();
  }
  function J() {
    b(), gt(), l += 1;
    const ft = g === void 0 ? It() : g.timeStamp;
    t.notify(4, {
      customTimings: f,
      documentVersion: l,
      id: c,
      name: v,
      service: x,
      version: k,
      context: E.getContext(),
      loadingType: i,
      location: O,
      startClocks: s,
      commonViewMetrics: S(),
      initialViewMetrics: $,
      duration: Ct(s.timeStamp, ft),
      isActive: g === void 0,
      sessionIsActive: A,
      eventCounts: z
    });
  }
  return {
    get name() {
      return v;
    },
    service: x,
    version: k,
    contextManager: E,
    stopObservable: u,
    end(ft = {}) {
      var Ut, Mt;
      g || (g = (Ut = ft.endClocks) !== null && Ut !== void 0 ? Ut : xt(), A = (Mt = ft.sessionIsActive) !== null && Mt !== void 0 ? Mt : !0, t.notify(5, { endClocks: g }), t.notify(6, { endClocks: g }), Xn(B), h(g.relative), _(), ot.unsubscribe(), J(), At(() => {
        this.stop();
      }, Qh));
    },
    stop() {
      I(), F(), p(), u.notify();
    },
    addTiming(ft, Ut) {
      if (g)
        return;
      const Mt = xc(Ut) ? Ut : Ct(s.timeStamp, Ut);
      f[ng(ft)] = Mt, tt();
    },
    setViewName(ft) {
      v = ft, J();
    }
  };
}
function ng(t) {
  const e = t.replace(/[^a-zA-Z0-9-_.@$]/g, "_");
  return e !== t && X.warn(`Invalid timing name: ${t}, sanitized to: ${e}`), e;
}
function rg(t, e) {
  return t.pathname !== e.pathname || !og(e.hash) && hi(e.hash) !== hi(t.hash);
}
function og(t) {
  const e = t.substring(1);
  return e !== "" && !!document.getElementById(e);
}
function hi(t) {
  const e = t.indexOf("?");
  return e < 0 ? t : t.slice(0, e);
}
function ig(t, e, n, r, o, i, s, a, c, u) {
  return t.subscribe(4, (f) => t.notify(12, sg(f, n, a))), e.register(0, ({ startTime: f, eventType: l }) => {
    const g = c.findView(f);
    return g ? {
      type: l,
      service: g.service,
      version: g.version,
      context: g.context,
      view: {
        id: g.id,
        name: g.name
      }
    } : he;
  }), e.register(1, ({ startTime: f }) => {
    var l;
    return {
      view: {
        id: (l = c.findView(f)) === null || l === void 0 ? void 0 : l.id
      }
    };
  }), tg(r, t, o, i, n, s, !n.trackViewsManually, u);
}
function sg(t, e, n) {
  var r, o, i, s, a, c, u, f, l, g, O, E, A, v, x, k, T, R;
  const U = n.getReplayStats(t.id), b = (o = (r = t.commonViewMetrics) === null || r === void 0 ? void 0 : r.cumulativeLayoutShift) === null || o === void 0 ? void 0 : o.devicePixelRatio, C = {
    _dd: {
      document_version: t.documentVersion,
      replay_stats: U,
      cls: b ? {
        device_pixel_ratio: b
      } : void 0,
      configuration: {
        start_session_replay_recording_manually: e.startSessionReplayRecordingManually
      }
    },
    date: t.startClocks.timeStamp,
    type: Y.VIEW,
    view: {
      action: {
        count: t.eventCounts.actionCount
      },
      frustration: {
        count: t.eventCounts.frustrationCount
      },
      cumulative_layout_shift: (i = t.commonViewMetrics.cumulativeLayoutShift) === null || i === void 0 ? void 0 : i.value,
      cumulative_layout_shift_time: K((s = t.commonViewMetrics.cumulativeLayoutShift) === null || s === void 0 ? void 0 : s.time),
      cumulative_layout_shift_target_selector: (a = t.commonViewMetrics.cumulativeLayoutShift) === null || a === void 0 ? void 0 : a.targetSelector,
      first_byte: K((c = t.initialViewMetrics.navigationTimings) === null || c === void 0 ? void 0 : c.firstByte),
      dom_complete: K((u = t.initialViewMetrics.navigationTimings) === null || u === void 0 ? void 0 : u.domComplete),
      dom_content_loaded: K((f = t.initialViewMetrics.navigationTimings) === null || f === void 0 ? void 0 : f.domContentLoaded),
      dom_interactive: K((l = t.initialViewMetrics.navigationTimings) === null || l === void 0 ? void 0 : l.domInteractive),
      error: {
        count: t.eventCounts.errorCount
      },
      first_contentful_paint: K(t.initialViewMetrics.firstContentfulPaint),
      first_input_delay: K((g = t.initialViewMetrics.firstInput) === null || g === void 0 ? void 0 : g.delay),
      first_input_time: K((O = t.initialViewMetrics.firstInput) === null || O === void 0 ? void 0 : O.time),
      first_input_target_selector: (E = t.initialViewMetrics.firstInput) === null || E === void 0 ? void 0 : E.targetSelector,
      interaction_to_next_paint: K((A = t.commonViewMetrics.interactionToNextPaint) === null || A === void 0 ? void 0 : A.value),
      interaction_to_next_paint_time: K((v = t.commonViewMetrics.interactionToNextPaint) === null || v === void 0 ? void 0 : v.time),
      interaction_to_next_paint_target_selector: (x = t.commonViewMetrics.interactionToNextPaint) === null || x === void 0 ? void 0 : x.targetSelector,
      is_active: t.isActive,
      name: t.name,
      largest_contentful_paint: K((k = t.initialViewMetrics.largestContentfulPaint) === null || k === void 0 ? void 0 : k.value),
      largest_contentful_paint_target_selector: (T = t.initialViewMetrics.largestContentfulPaint) === null || T === void 0 ? void 0 : T.targetSelector,
      load_event: K((R = t.initialViewMetrics.navigationTimings) === null || R === void 0 ? void 0 : R.loadEvent),
      loading_time: ca(K(t.commonViewMetrics.loadingTime)),
      loading_type: t.loadingType,
      long_task: {
        count: t.eventCounts.longTaskCount
      },
      performance: ag(t.commonViewMetrics, t.initialViewMetrics),
      resource: {
        count: t.eventCounts.resourceCount
      },
      time_spent: K(t.duration)
    },
    display: t.commonViewMetrics.scroll ? {
      scroll: {
        max_depth: t.commonViewMetrics.scroll.maxDepth,
        max_depth_scroll_top: t.commonViewMetrics.scroll.maxDepthScrollTop,
        max_scroll_height: t.commonViewMetrics.scroll.maxScrollHeight,
        max_scroll_height_time: K(t.commonViewMetrics.scroll.maxScrollHeightTime)
      }
    } : void 0,
    privacy: {
      replay_level: e.defaultPrivacyLevel
    },
    device: {
      locale: navigator.language,
      locales: navigator.languages,
      time_zone: Ed()
    }
  };
  return we(t.customTimings) || (C.view.custom_timings = Lc(t.customTimings, K)), {
    rawRumEvent: C,
    startTime: t.startClocks.relative,
    duration: t.duration,
    domainContext: {
      location: t.location
    }
  };
}
function ag({ cumulativeLayoutShift: t, interactionToNextPaint: e }, { firstContentfulPaint: n, firstInput: r, largestContentfulPaint: o }) {
  return {
    cls: t && {
      score: t.value,
      timestamp: K(t.time),
      target_selector: t.targetSelector,
      previous_rect: t.previousRect,
      current_rect: t.currentRect
    },
    fcp: n && { timestamp: K(n) },
    fid: r && {
      duration: K(r.delay),
      timestamp: K(r.time),
      target_selector: r.targetSelector
    },
    inp: e && {
      duration: K(e.value),
      timestamp: K(e.time),
      target_selector: e.targetSelector
    },
    lcp: o && {
      timestamp: K(o.value),
      target_selector: o.targetSelector,
      resource_url: o.resourceUrl
    }
  };
}
const cg = "rum";
function ug(t, e, n) {
  const r = Us(t, cg, (o) => dg(t, o), n);
  return r.expireObservable.subscribe(() => {
    e.notify(
      9
      /* LifeCycleEventType.SESSION_EXPIRED */
    );
  }), r.renewObservable.subscribe(() => {
    e.notify(
      10
      /* LifeCycleEventType.SESSION_RENEWED */
    );
  }), r.sessionStateUpdateObservable.subscribe(({ previousState: o, newState: i }) => {
    if (!o.forcedReplay && i.forcedReplay) {
      const s = r.findSession();
      s && (s.isReplayForced = !0);
    }
  }), {
    findTrackedSession: (o) => {
      const i = r.findSession(o);
      if (!(!i || i.trackingType === "0"))
        return {
          id: i.id,
          sessionReplay: i.trackingType === "1" ? 1 : i.isReplayForced ? 2 : 0,
          anonymousId: i.anonymousId
        };
    },
    expire: r.expire,
    expireObservable: r.expireObservable,
    setForcedReplay: () => r.updateSessionState({ forcedReplay: "1" })
  };
}
function lg() {
  const t = {
    id: "00000000-aaaa-0000-aaaa-000000000000",
    sessionReplay: _s(
      "records"
      /* BridgeCapability.RECORDS */
    ) ? 1 : 0
  };
  return {
    findTrackedSession: () => t,
    expire: it,
    expireObservable: new nt(),
    setForcedReplay: it
  };
}
function dg(t, e) {
  return fg(e) ? e : de(t.sessionSampleRate) ? de(t.sessionReplaySampleRate) ? "1" : "2" : "0";
}
function fg(t) {
  return t === "0" || t === "1" || t === "2";
}
function pg(t, e, n, r, o, i) {
  const s = t.replica, a = to(t, {
    endpoint: t.rumEndpointBuilder,
    encoder: i(
      2
      /* DeflateEncoderStreamId.RUM */
    )
  }, s && {
    endpoint: s.rumEndpointBuilder,
    transformMessage: (c) => Vt(c, { application: { id: s.applicationId } }),
    encoder: i(
      3
      /* DeflateEncoderStreamId.RUM_REPLICA */
    )
  }, n, r, o);
  return e.subscribe(13, (c) => {
    c.type === Y.VIEW ? a.upsert(c, c.view.id) : a.add(c);
  }), a;
}
function hg(t) {
  const e = Qe();
  t.subscribe(13, (n) => {
    e.send("rum", n);
  });
}
const gg = Se;
function mg(t, e, n, r) {
  const o = en({ expireDelay: gg });
  let i;
  t.subscribe(1, ({ startClocks: c }) => {
    const u = r.href;
    o.add(a({
      url: u,
      referrer: i || document.referrer
    }), c.relative), i = u;
  }), t.subscribe(6, ({ endClocks: c }) => {
    o.closeActive(c.relative);
  });
  const s = n.subscribe(({ newLocation: c }) => {
    const u = o.find();
    if (u) {
      const f = zt();
      o.closeActive(f), o.add(a({
        url: c.href,
        referrer: u.referrer
      }), f);
    }
  });
  function a({ url: c, referrer: u }) {
    return {
      url: c,
      referrer: u
    };
  }
  return e.register(0, ({ startTime: c, eventType: u }) => {
    const f = o.find(c);
    return f ? {
      type: u,
      view: {
        url: f.url,
        referrer: f.referrer
      }
    } : he;
  }), {
    findUrl: (c) => o.find(c),
    stop: () => {
      s.unsubscribe(), o.stop();
    }
  };
}
function _g(t, e) {
  let n = fn(e);
  return new nt((r) => {
    const { stop: o } = bg(t, s), { stop: i } = yg(t, s);
    function s() {
      if (n.href === e.href)
        return;
      const a = fn(e);
      r.notify({
        newLocation: a,
        oldLocation: n
      }), n = a;
    }
    return () => {
      o(), i();
    };
  });
}
function bg(t, e) {
  const { stop: n } = Jt(gi("pushState"), "pushState", ({ onPostCall: i }) => {
    i(e);
  }), { stop: r } = Jt(gi("replaceState"), "replaceState", ({ onPostCall: i }) => {
    i(e);
  }), { stop: o } = mt(t, window, "popstate", e);
  return {
    stop: () => {
      n(), r(), o();
    }
  };
}
function yg(t, e) {
  return mt(t, window, "hashchange", e);
}
function gi(t) {
  return Object.prototype.hasOwnProperty.call(history, t) ? history : History.prototype;
}
const vg = Se;
function Eg(t, e, n) {
  const r = en({
    expireDelay: vg
  });
  return t.subscribe(1, ({ startClocks: o }) => {
    r.add({}, o.relative);
  }), t.subscribe(6, ({ endClocks: o }) => {
    r.closeActive(o.relative);
  }), e.register(0, ({ startTime: o, eventType: i }) => {
    if (!n.trackFeatureFlagsForEvents.concat([
      Y.VIEW,
      Y.ERROR
    ]).includes(i))
      return Ft;
    const a = r.find(o);
    return !a || we(a) ? Ft : {
      type: i,
      feature_flags: a
    };
  }), {
    addFeatureFlagEvaluation: (o, i) => {
      const s = r.find();
      s && (s[o] = i);
    }
  };
}
const wg = 10 * Pt;
let $e, kn;
function Sg(t, e, n, r) {
  e.enabled && de(t.customerDataTelemetrySampleRate) && (xa(), kn = !1, n.subscribe(13, () => {
    kn = !0;
  }), r.subscribe(({ bytesCount: i, messagesCount: s }) => {
    kn && (kn = !1, $e.batchCount += 1, _i($e.batchBytesCount, i), _i($e.batchMessagesCount, s));
  }), qe(Tg, wg));
}
function Tg() {
  $e.batchCount !== 0 && (se("Customer data measures", $e), xa());
}
function mi() {
  return { min: 1 / 0, max: 0, sum: 0 };
}
function _i(t, e) {
  t.sum += e, t.min = Math.min(t.min, e), t.max = Math.max(t.max, e);
}
function xa() {
  $e = {
    batchCount: 0,
    batchBytesCount: mi(),
    batchMessagesCount: mi()
  };
}
const Cg = 4e3, Ag = 500, Ig = Se;
function Rg(t, e, n = Ag) {
  const r = en({
    expireDelay: Ig,
    maxEntries: Cg
  });
  let o;
  Ae(rt.VISIBILITY_STATE) && performance.getEntriesByType(rt.VISIBILITY_STATE).forEach((u) => {
    const f = u.name === "hidden" ? "hidden" : "active";
    s(f, u.startTime);
  }), s(Oa(), zt());
  const { stop: i } = pe(e, window, [
    "pageshow",
    "focus",
    "blur",
    "visibilitychange",
    "resume",
    "freeze",
    "pagehide"
  ], (c) => {
    s(Og(c), c.timeStamp);
  }, { capture: !0 });
  function s(c, u = zt()) {
    c !== o && (o = c, r.closeActive(u), r.add({ state: o, startTime: u }, u));
  }
  function a(c, u, f) {
    return r.findAll(u, f).some((l) => l.state === c);
  }
  return t.register(0, ({ startTime: c, duration: u = 0, eventType: f }) => {
    if (f === Y.VIEW) {
      const l = r.findAll(c, u);
      return {
        type: f,
        _dd: { page_states: xg(l, c, n) }
      };
    }
    return f === Y.ACTION || f === Y.ERROR ? {
      type: f,
      view: { in_foreground: a("active", c, 0) }
    } : Ft;
  }), {
    wasInPageStateDuringPeriod: a,
    addPageState: s,
    stop: () => {
      i(), r.stop();
    }
  };
}
function xg(t, e, n) {
  if (t.length !== 0)
    return t.slice(-n).reverse().map(({ state: r, startTime: o }) => ({
      state: r,
      start: K(Ct(e, o))
    }));
}
function Og(t) {
  return t.type === "freeze" ? "frozen" : t.type === "pagehide" ? t.persisted ? "frozen" : "terminated" : Oa();
}
function Oa() {
  return document.visibilityState === "hidden" ? "hidden" : document.hasFocus() ? "active" : "passive";
}
function kg(t, e) {
  let n;
  const r = requestAnimationFrame(G(() => {
    n = vo();
  })), o = jh(e).subscribe((i) => {
    n = i;
  }).unsubscribe;
  return t.register(0, ({ eventType: i }) => ({
    type: i,
    display: n ? { viewport: n } : void 0
  })), {
    stop: () => {
      o(), r && cancelAnimationFrame(r);
    }
  };
}
function Lg(t, e) {
  const n = window.cookieStore ? Ng(t) : Ug;
  return new nt((r) => n(e, (o) => r.notify(o)));
}
function Ng(t) {
  return (e, n) => mt(t, window.cookieStore, "change", (o) => {
    const i = o.changed.find((s) => s.name === e) || o.deleted.find((s) => s.name === e);
    i && n(i.value);
  }).stop;
}
const Pg = Pt;
function Ug(t, e) {
  const n = hn(document.cookie, t), r = qe(() => {
    const o = hn(document.cookie, t);
    o !== n && e(o);
  }, Pg);
  return () => {
    Xn(r);
  };
}
const bi = "datadog-ci-visibility-test-execution-id";
function Mg(t, e, n = Lg(t, bi)) {
  var r;
  let o = le(bi) || ((r = window.Cypress) === null || r === void 0 ? void 0 : r.env("traceId"));
  const i = n.subscribe((s) => {
    o = s;
  });
  return e.register(0, ({ eventType: s }) => typeof o != "string" ? Ft : {
    type: s,
    session: {
      type: "ci_test"
    },
    ci_test: {
      test_execution_id: o
    }
  }), {
    stop: () => {
      i.unsubscribe();
    }
  };
}
function Dg(t, e) {
  const n = Zt(e, {
    type: rt.LONG_ANIMATION_FRAME,
    buffered: !0
  }).subscribe((r) => {
    for (const o of r) {
      const i = yn(o.startTime), s = {
        date: i.timeStamp,
        long_task: {
          id: Ot(),
          entry_type: Ks.LONG_ANIMATION_FRAME,
          duration: K(o.duration),
          blocking_duration: K(o.blockingDuration),
          first_ui_event_timestamp: K(o.firstUIEventTimestamp),
          render_start: K(o.renderStart),
          style_and_layout_start: K(o.styleAndLayoutStart),
          start_time: K(o.startTime),
          scripts: o.scripts.map((a) => ({
            duration: K(a.duration),
            pause_duration: K(a.pauseDuration),
            forced_style_and_layout_duration: K(a.forcedStyleAndLayoutDuration),
            start_time: K(a.startTime),
            execution_start: K(a.executionStart),
            source_url: a.sourceURL,
            source_function_name: a.sourceFunctionName,
            source_char_position: a.sourceCharPosition,
            invoker: a.invoker,
            invoker_type: a.invokerType,
            window_attribution: a.windowAttribution
          }))
        },
        type: Y.LONG_TASK,
        _dd: {
          discarded: !1
        }
      };
      t.notify(12, {
        rawRumEvent: s,
        startTime: i.relative,
        duration: o.duration,
        domainContext: { performanceEntry: o }
      });
    }
  });
  return { stop: () => n.unsubscribe() };
}
function Bg(t, e) {
  const n = Zt(e, {
    type: rt.LONG_TASK,
    buffered: !0
  }).subscribe((r) => {
    for (const o of r) {
      if (o.entryType !== rt.LONG_TASK || !e.trackLongTasks)
        break;
      const i = yn(o.startTime), s = {
        date: i.timeStamp,
        long_task: {
          id: Ot(),
          entry_type: Ks.LONG_TASK,
          duration: K(o.duration)
        },
        type: Y.LONG_TASK,
        _dd: {
          discarded: !1
        }
      };
      t.notify(12, {
        rawRumEvent: s,
        startTime: i.relative,
        duration: o.duration,
        domainContext: { performanceEntry: o }
      });
    }
  });
  return {
    stop() {
      n.unsubscribe();
    }
  };
}
function Fg(t) {
  t.register(0, ({ eventType: e }) => {
    if (!Ps())
      return Ft;
    const n = so(), r = ao();
    return {
      type: e,
      session: {
        type: "synthetics"
      },
      synthetics: {
        test_id: n,
        result_id: r,
        injected: nr()
      }
    };
  });
}
function Vg(t, e, n) {
  const r = tr(t), o = n(r);
  return qr(e).forEach(([i, s]) => (
    // Traverse both object and clone simultaneously up to the path and apply the modification from the clone to the original object when the type is valid
    Gr(t, r, i.split(/\.|(?=\[\])/), s)
  )), o;
}
function Gr(t, e, n, r) {
  const [o, ...i] = n;
  if (o === "[]") {
    Array.isArray(t) && Array.isArray(e) && t.forEach((s, a) => Gr(s, e[a], i, r));
    return;
  }
  if (!(!yi(t) || !yi(e))) {
    if (i.length > 0)
      return Gr(t[o], e[o], i, r);
    $g(t, o, e[o], r);
  }
}
function $g(t, e, n, r) {
  const o = Ce(n);
  o === r ? t[e] = ht(n) : r === "object" && (o === "undefined" || o === "null") && (t[e] = {});
}
function yi(t) {
  return Ce(t) === "object";
}
const Le = {
  "view.name": "string",
  "view.url": "string",
  "view.referrer": "string"
}, Ne = {
  context: "object"
}, Pe = {
  service: "string",
  version: "string"
};
let ka;
function jg(t, e, n, r) {
  ka = {
    [Y.VIEW]: {
      "view.performance.lcp.resource_url": "string",
      ...Ne,
      ...Le,
      ...Pe
    },
    [Y.ERROR]: {
      "error.message": "string",
      "error.stack": "string",
      "error.resource.url": "string",
      "error.fingerprint": "string",
      ...Ne,
      ...Le,
      ...Pe
    },
    [Y.RESOURCE]: {
      "resource.url": "string",
      ...os(mn.WRITABLE_RESOURCE_GRAPHQL) ? { "resource.graphql": "object" } : {},
      ...Ne,
      ...Le,
      ...Pe
    },
    [Y.ACTION]: {
      "action.target.name": "string",
      ...Ne,
      ...Le,
      ...Pe
    },
    [Y.LONG_TASK]: {
      "long_task.scripts[].source_url": "string",
      "long_task.scripts[].invoker": "string",
      ...Ne,
      ...Le,
      ...Pe
    },
    [Y.VITAL]: {
      ...Ne,
      ...Le,
      ...Pe
    }
  };
  const o = {
    [Y.ERROR]: Dn(Y.ERROR, t.eventRateLimiterThreshold, r),
    [Y.ACTION]: Dn(Y.ACTION, t.eventRateLimiterThreshold, r),
    [Y.VITAL]: Dn(Y.VITAL, t.eventRateLimiterThreshold, r)
  };
  e.subscribe(12, ({ startTime: i, duration: s, rawRumEvent: a, domainContext: c, customerContext: u }) => {
    const f = n.triggerHook(0, {
      eventType: a.type,
      startTime: i,
      duration: s
    });
    if (f === he)
      return;
    const l = Vt(f, { context: u }, a);
    zg(l, t.beforeSend, c, o) && (we(l.context) && delete l.context, e.notify(13, l));
  });
}
function zg(t, e, n, r) {
  var o;
  if (e) {
    const s = Vg(t, ka[t.type], (a) => e(a, n));
    if (s === !1 && t.type !== Y.VIEW)
      return !1;
    s === !1 && X.warn("Can't dismiss view events using beforeSend!");
  }
  return !((o = r[t.type]) === null || o === void 0 ? void 0 : o.isLimitReached());
}
function Gg(t, e, n, r) {
  t.register(0, ({ eventType: o, startTime: i }) => {
    const s = e.findTrackedSession(i), a = r.findView(i);
    if (!s || !a)
      return he;
    let c, u, f;
    return o === Y.VIEW ? (c = n.getReplayStats(a.id) ? !0 : void 0, u = s.sessionReplay === 1, f = a.sessionIsActive ? void 0 : !1) : c = n.isRecording() ? !0 : void 0, {
      type: o,
      session: {
        id: s.id,
        type: "user",
        has_replay: c,
        sampled_for_replay: u,
        is_active: f
      }
    };
  }), t.register(1, ({ startTime: o }) => {
    const i = e.findTrackedSession(o);
    return i ? {
      session: {
        id: i.id
      }
    } : Ft;
  });
}
function Hg(t) {
  t.register(0, ({ eventType: e }) => ({
    type: e,
    connectivity: ss()
  }));
}
function Kg(t, e, n) {
  t.register(0, ({ eventType: r }) => ({
    type: r,
    _dd: {
      format_version: 2,
      drift: Ic(),
      configuration: {
        session_sample_rate: un(e.sessionSampleRate, 3),
        session_replay_sample_rate: un(e.sessionReplaySampleRate, 3),
        profiling_sample_rate: un(e.profilingSampleRate, 3)
      },
      browser_sdk_version: ie() ? "6.14.0" : void 0,
      sdk_name: n
    },
    application: {
      id: e.applicationId
    },
    date: It(),
    source: "browser"
  })), t.register(1, () => ({
    application: { id: e.applicationId }
  }));
}
const Yg = Fs, Wg = [
  Y.ACTION,
  Y.ERROR,
  Y.LONG_TASK,
  Y.RESOURCE,
  Y.VITAL
];
function qg(t) {
  return {
    addEvent: (e, n, r, o) => {
      Wg.includes(n.type) && t.notify(12, {
        startTime: e,
        rawRumEvent: n,
        domainContext: r,
        duration: o
      });
    }
  };
}
function Xg(t, e, n, r, o, i, s, a, c) {
  const u = [], f = new Pf(), l = Yg();
  f.subscribe(13, (St) => Zr("rum", St));
  const g = (St) => {
    f.notify(14, { error: St }), se("Error reported to customer", { "error.message": St.message });
  }, O = bs(t), E = O.subscribe((St) => {
    f.notify(11, St);
  });
  u.push(() => E.unsubscribe());
  const A = vs("browser-rum-sdk", t, l, g, O, o);
  u.push(A.stop);
  const v = ie() ? lg() : ug(t, f, i);
  if (ie())
    hg(f);
  else {
    const St = pg(t, f, g, O, v.expireObservable, o);
    u.push(() => St.stop()), Sg(t, A, f, St.flushObservable);
  }
  const x = Of(), k = _g(t, location), { observable: T, stop: R } = Lf();
  u.push(R), Kg(l, t, c);
  const U = Rg(l, t), b = Mf(f);
  u.push(() => b.stop());
  const C = mg(f, l, k, location);
  u.push(() => C.stop());
  const h = Eg(f, l, t);
  Gg(l, v, e, b), Hg(l);
  const _ = $s(l, t, "rum", !0), p = js(l, t, v, "rum"), S = Vs(l, t, "rum"), { actionContexts: I, addAction: $, addEvent: F, stop: z } = Jg(f, l, t, U, x, T, g);
  u.push(z);
  const { addTiming: B, startView: ot, setViewName: gt, setViewContext: tt, setViewContextProperty: J, getViewContext: ft, stop: Ut } = ig(f, l, t, location, x, T, k, e, b, r);
  u.push(Ut);
  const { stop: Mt } = ch(f, t, U);
  if (u.push(Mt), t.trackLongTasks)
    if (Ae(rt.LONG_ANIMATION_FRAME)) {
      const { stop: St } = Dg(f, t);
      u.push(St);
    } else
      Bg(f, t);
  const { addError: Re } = Xp(f, t, a);
  a.unbuffer(), Kf(f, t, v, p, S);
  const Qt = af(f, U, s), te = Nf(t.applicationId, v, b, I, C);
  return u.push(() => n.stop()), {
    addAction: $,
    addEvent: F,
    addError: Re,
    addTiming: B,
    addFeatureFlagEvaluation: h.addFeatureFlagEvaluation,
    startView: ot,
    setViewContext: tt,
    setViewContextProperty: J,
    getViewContext: ft,
    setViewName: gt,
    lifeCycle: f,
    viewHistory: b,
    session: v,
    stopSession: () => v.expire(),
    getInternalContext: te.get,
    startDurationVital: Qt.startDurationVital,
    stopDurationVital: Qt.stopDurationVital,
    addDurationVital: Qt.addDurationVital,
    globalContext: _,
    userContext: p,
    accountContext: S,
    stop: () => {
      u.forEach((St) => St());
    },
    hooks: l
  };
}
function Jg(t, e, n, r, o, i, s) {
  const a = Yp(t, e, o, i, n), c = qg(t), u = kg(e, n), f = Mg(n, e);
  return Fg(e), jg(n, t, e, s), {
    pageStateHistory: r,
    addAction: a.addAction,
    addEvent: c.addEvent,
    actionContexts: a.actionContexts,
    stop: () => {
      a.stop(), f.stop(), u.stop(), r.stop();
    }
  };
}
function Zg(t, { session: e, viewContext: n, errorType: r }) {
  const o = e ? e.id : "no-session-id", i = [];
  r !== void 0 && i.push(`error-type=${r}`), n && (i.push(`seed=${n.id}`), i.push(`from=${n.startClocks.timeStamp}`));
  const s = Qg(t), a = `/rum/replay/sessions/${o}`;
  return `${s}${a}?${i.join("&")}`;
}
function Qg(t) {
  const e = t.site, n = t.subdomain || tm(t);
  return `https://${n ? `${n}.` : ""}${e}`;
}
function tm(t) {
  switch (t.site) {
    case ye:
    case Nu:
      return "app";
    case is:
      return "dd";
    default:
      return;
  }
}
const em = 1e3;
let Ht;
function l_(t) {
  return sr(t).segments_count;
}
function d_(t) {
  sr(t).segments_count += 1;
}
function f_(t) {
  sr(t).records_count += 1;
}
function p_(t, e) {
  sr(t).segments_total_raw_size += e;
}
function nm(t) {
  return Ht == null ? void 0 : Ht.get(t);
}
function sr(t) {
  Ht || (Ht = /* @__PURE__ */ new Map());
  let e;
  return Ht.has(t) ? e = Ht.get(t) : (e = {
    records_count: 0,
    segments_count: 0,
    segments_total_raw_size: 0
  }, Ht.set(t, e), Ht.size > em && rm()), e;
}
function rm() {
  if (!Ht)
    return;
  const t = Ht.keys().next().value;
  t && Ht.delete(t);
}
function La(t, e, n) {
  let r = 0, o = [], i, s = 0;
  const a = [], { stop: c } = mt(t, e, "message", ({ data: l }) => {
    if (l.type !== "wrote" || l.streamId !== n)
      return;
    r += l.additionalBytesCount, o.push(l.result), i = l.trailer;
    const g = a.shift();
    g && g.id === l.id ? g.writeCallback ? g.writeCallback(l.result.byteLength) : g.finishCallback && g.finishCallback() : (c(), se("Worker responses received out of order."));
  });
  function u() {
    const l = o.length === 0 ? new Uint8Array(0) : kc(o.concat(i)), g = {
      rawBytesCount: r,
      output: l,
      outputBytesCount: l.byteLength,
      encoding: "deflate"
    };
    return r = 0, o = [], g;
  }
  function f() {
    s > 0 && (e.postMessage({
      action: "reset",
      streamId: n
    }), s = 0);
  }
  return {
    isAsync: !0,
    get isEmpty() {
      return s === 0;
    },
    write(l, g) {
      e.postMessage({
        action: "write",
        id: s,
        data: l,
        streamId: n
      }), a.push({
        id: s,
        writeCallback: g,
        data: l
      }), s += 1;
    },
    finish(l) {
      f(), a.length ? (a.forEach((g) => {
        delete g.writeCallback;
      }), a[a.length - 1].finishCallback = () => l(u())) : l(u());
    },
    finishSync() {
      f();
      const l = a.map((g) => (delete g.writeCallback, delete g.finishCallback, g.data)).join("");
      return { ...u(), pendingData: l };
    },
    estimateEncodedBytesCount(l) {
      return l.length / 8;
    },
    stop() {
      c();
    }
  };
}
function Eo({ configuredUrl: t, error: e, source: n, scriptType: r }) {
  if (X.error(`${n} failed to start: an error occurred while initializing the ${r}:`, e), e instanceof Event || e instanceof Error && om(e.message)) {
    let o;
    t ? o = `Please make sure the ${r} URL ${t} is correct and CSP is correctly configured.` : o = "Please make sure CSP is correctly configured.", X.error(`${o} See documentation at ${Wn}/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay`);
  } else r === "worker" && eo(e);
}
function om(t) {
  return t.includes("Content Security Policy") || // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
  t.includes("requires 'TrustedScriptURL'");
}
const im = 30 * Pt;
function Na(t) {
  return new Worker(t.workerUrl || URL.createObjectURL(new Blob(['(()=>{function t(t){const e=t.reduce((t,e)=>t+e.length,0),a=new Uint8Array(e);let n=0;for(const e of t)a.set(e,n),n+=e.length;return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),n=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),r=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),i=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=Array(576);e(s);var h=Array(60);e(h);var l=Array(512);e(l);var _=Array(256);e(_);var o=Array(29);e(o);var d,u,f,c=Array(30);function p(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t&&t.length}function g(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(c);var v=function(t){return t<256?l[t]:l[256+(t>>>7)]},w=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},m=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,w(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},b=function(t,e,a){m(t,a[2*e],a[2*e+1])},y=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},z=function(t,e,a){var n,r,i=Array(16),s=0;for(n=1;n<=15;n++)i[n]=s=s+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=y(i[h]++,h))}},k=function(t){var e;for(e=0;e<286;e++)t.dyn_ltree[2*e]=0;for(e=0;e<30;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},x=function(t){t.bi_valid>8?w(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},A=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},U=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&A(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!A(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},B=function(t,e,r){var i,s,h,l,d=0;if(0!==t.last_lit)do{i=t.pending_buf[t.d_buf+2*d]<<8|t.pending_buf[t.d_buf+2*d+1],s=t.pending_buf[t.l_buf+d],d++,0===i?b(t,s,e):(h=_[s],b(t,h+256+1,e),0!==(l=a[h])&&(s-=o[h],m(t,s,l)),i--,h=v(i),b(t,h,r),0!==(l=n[h])&&(i-=c[h],m(t,i,l)))}while(d<t.last_lit);b(t,256,e)},I=function(t,e){var a,n,r,i=e.dyn_tree,s=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,_=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==i[2*a]?(t.heap[++t.heap_len]=_=a,t.depth[a]=0):i[2*a+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=_<2?++_:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=s[2*r+1]);for(e.max_code=_,a=t.heap_len>>1;a>=1;a--)U(t,i,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],U(t,i,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,i[2*r]=i[2*a]+i[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,i[2*a+1]=i[2*n+1]=r,t.heap[1]=r++,U(t,i,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,i,s,h,l=e.dyn_tree,_=e.max_code,o=e.stat_desc.static_tree,d=e.stat_desc.has_stree,u=e.stat_desc.extra_bits,f=e.stat_desc.extra_base,c=e.stat_desc.max_length,p=0;for(i=0;i<=15;i++)t.bl_count[i]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(i=l[2*l[2*(n=t.heap[a])+1]+1]+1)>c&&(i=c,p++),l[2*n+1]=i,n>_||(t.bl_count[i]++,s=0,n>=f&&(s=u[n-f]),h=l[2*n],t.opt_len+=h*(i+s),d&&(t.static_len+=h*(o[2*n+1]+s)));if(0!==p){do{for(i=c-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[c]--,p-=2}while(p>0);for(i=c;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--a])>_||(l[2*r+1]!==i&&(t.opt_len+=(i-l[2*r+1])*l[2*r],l[2*r+1]=i),n--)}}(t,e),z(i,_,t.bl_count)},E=function(t,e,a){var n,r,i=-1,s=e[1],h=0,l=7,_=4;for(0===s&&(l=138,_=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++h<l&&r===s||(h<_?t.bl_tree[2*r]+=h:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):h<=10?t.bl_tree[34]++:t.bl_tree[36]++,h=0,i=r,0===s?(l=138,_=3):r===s?(l=6,_=3):(l=7,_=4))},C=function(t,e,a){var n,r,i=-1,s=e[1],h=0,l=7,_=4;for(0===s&&(l=138,_=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++h<l&&r===s)){if(h<_)do{b(t,r,t.bl_tree)}while(0!==--h);else 0!==r?(r!==i&&(b(t,r,t.bl_tree),h--),b(t,16,t.bl_tree),m(t,h-3,2)):h<=10?(b(t,17,t.bl_tree),m(t,h-3,3)):(b(t,18,t.bl_tree),m(t,h-11,7));h=0,i=r,0===s?(l=138,_=3):r===s?(l=6,_=3):(l=7,_=4)}},D=!1,M=function(t,e,a,n){m(t,0+(n?1:0),3),function(t,e,a){x(t),w(t,a),w(t,~a),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a)},j=M,L=function(t,e,a,n){for(var r=65535&t,i=t>>>16&65535,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16},S=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),T=function(t,e,a,n){var r=S,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},O={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"},q=j,F=function(t,e,a){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&a,t.last_lit++,0===e?t.dyn_ltree[2*a]++:(t.matches++,e--,t.dyn_ltree[2*(_[a]+256+1)]++,t.dyn_dtree[2*v(e)]++),t.last_lit===t.lit_bufsize-1},G=-2,H=258,J=262,K=103,N=113,P=666,Q=function(t,e){return t.msg=O[e],e},R=function(t){return(t<<1)-(t>4?9:0)},V=function(t){for(var e=t.length;--e>=0;)t[e]=0},W=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},X=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},Y=function(t,e){(function(t,e,a,n){var r,l,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,a=4093624447;for(e=0;e<=31;e++,a>>>=1)if(1&a&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<256;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),I(t,t.l_desc),I(t,t.d_desc),_=function(t){var e;for(E(t,t.dyn_ltree,t.l_desc.max_code),E(t,t.dyn_dtree,t.d_desc.max_code),I(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*i[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),r=t.opt_len+3+7>>>3,(l=t.static_len+3+7>>>3)<=r&&(r=l)):r=l=a+5,a+4<=r&&-1!==e?M(t,e,a,n):4===t.strategy||l===r?(m(t,2+(n?1:0),3),B(t,s,h)):(m(t,4+(n?1:0),3),function(t,e,a,n){var r;for(m(t,e-257,5),m(t,a-1,5),m(t,n-4,4),r=0;r<n;r++)m(t,t.bl_tree[2*i[r]+1],3);C(t,t.dyn_ltree,e-1),C(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),B(t,t.dyn_ltree,t.dyn_dtree)),k(t),n&&x(t)})(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,X(t.strm)},Z=function(t,e){t.pending_buf[t.pending++]=e},$=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},tt=function(t,e,a,n){var r=t.avail_in;return r>n&&(r=n),0===r?0:(t.avail_in-=r,e.set(t.input.subarray(t.next_in,t.next_in+r),a),1===t.state.wrap?t.adler=L(t.adler,e,r,a):2===t.state.wrap&&(t.adler=T(t.adler,e,r,a)),t.next_in+=r,t.total_in+=r,r)},et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,h=t.nice_match,l=t.strstart>t.w_size-J?t.strstart-(t.w_size-J):0,_=t.window,o=t.w_mask,d=t.prev,u=t.strstart+H,f=_[i+s-1],c=_[i+s];t.prev_length>=t.good_match&&(r>>=2),h>t.lookahead&&(h=t.lookahead);do{if(_[(a=e)+s]===c&&_[a+s-1]===f&&_[a]===_[i]&&_[++a]===_[i+1]){i+=2,a++;do{}while(_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&i<u);if(n=H-(u-i),i=u-H,n>s){if(t.match_start=e,s=n,n>=h)break;f=_[i+s-1],c=_[i+s]}}}while((e=d[e&o])>l&&0!==--r);return s<=t.lookahead?s:t.lookahead},at=function(t){var e,a,n,r,i,s=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=s+(s-J)){t.window.set(t.window.subarray(s,s+s),0),t.match_start-=s,t.strstart-=s,t.block_start-=s,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=s?n-s:0}while(--a);e=a=s;do{n=t.prev[--e],t.prev[e]=n>=s?n-s:0}while(--a);r+=s}if(0===t.strm.avail_in)break;if(a=tt(t.strm,t.window,t.strstart+t.lookahead,r),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=W(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=W(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<J&&0!==t.strm.avail_in)},nt=function(t,e){for(var a,n;;){if(t.lookahead<J){if(at(t),t.lookahead<J&&0===e)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-J&&(t.match_length=et(t,a)),t.match_length>=3)if(n=F(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!==--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=W(t,t.ins_h,t.window[t.strstart+1]);else n=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2},rt=function(t,e){for(var a,n,r;;){if(t.lookahead<J){if(at(t),t.lookahead<J&&0===e)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-J&&(t.match_length=et(t,a),t.match_length<=5&&(1===t.strategy||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=F(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!==--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(Y(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=F(t,0,t.window[t.strstart-1]))&&Y(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=F(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2};function it(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var st=[new it(0,0,0,0,function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(at(t),0===t.lookahead&&0===e)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,Y(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-J&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(Y(t,!1),t.strm.avail_out),1)}),new it(4,4,8,4,nt),new it(4,5,16,8,nt),new it(4,6,32,32,nt),new it(4,4,16,16,rt),new it(8,16,32,32,rt),new it(8,16,128,128,rt),new it(8,32,128,256,rt),new it(32,128,258,1024,rt),new it(32,258,258,4096,rt)];function ht(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=8,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),V(this.dyn_ltree),V(this.dyn_dtree),V(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),V(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),V(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}for(var lt=function(t){var e,i=function(t){if(!t||!t.state)return Q(t,G);t.total_in=t.total_out=0,t.data_type=2;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:N,t.adler=2===e.wrap?0:1,e.last_flush=0,function(t){D||(function(){var t,e,i,g,v,w=Array(16);for(i=0,g=0;g<28;g++)for(o[g]=i,t=0;t<1<<a[g];t++)_[i++]=g;for(_[i-1]=g,v=0,g=0;g<16;g++)for(c[g]=v,t=0;t<1<<n[g];t++)l[v++]=g;for(v>>=7;g<30;g++)for(c[g]=v<<7,t=0;t<1<<n[g]-7;t++)l[256+v++]=g;for(e=0;e<=15;e++)w[e]=0;for(t=0;t<=143;)s[2*t+1]=8,t++,w[8]++;for(;t<=255;)s[2*t+1]=9,t++,w[9]++;for(;t<=279;)s[2*t+1]=7,t++,w[7]++;for(;t<=287;)s[2*t+1]=8,t++,w[8]++;for(z(s,287,w),t=0;t<30;t++)h[2*t+1]=5,h[2*t]=y(t,5);d=new p(s,a,257,286,15),u=new p(h,n,0,30,15),f=new p([],r,0,19,7)}(),D=!0),t.l_desc=new g(t.dyn_ltree,d),t.d_desc=new g(t.dyn_dtree,u),t.bl_desc=new g(t.bl_tree,f),t.bi_buf=0,t.bi_valid=0,k(t)}(e),0}(t);return 0===i&&((e=t.state).window_size=2*e.w_size,V(e.head),e.max_lazy_match=st[e.level].max_lazy,e.good_match=st[e.level].good_length,e.nice_match=st[e.level].nice_length,e.max_chain_length=st[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),i},_t=function(t,e){var a,n;if(!t||!t.state||e>5||e<0)return t?Q(t,G):G;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===P&&4!==e)return Q(t,0===t.avail_out?-5:G);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,Z(r,31),Z(r,139),Z(r,8),r.gzhead?(Z(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),Z(r,255&r.gzhead.time),Z(r,r.gzhead.time>>8&255),Z(r,r.gzhead.time>>16&255),Z(r,r.gzhead.time>>24&255),Z(r,9===r.level?2:r.strategy>=2||r.level<2?4:0),Z(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(Z(r,255&r.gzhead.extra.length),Z(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=T(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(Z(r,0),Z(r,0),Z(r,0),Z(r,0),Z(r,0),Z(r,9===r.level?2:r.strategy>=2||r.level<2?4:0),Z(r,3),r.status=N);else{var h=8+(r.w_bits-8<<4)<<8;h|=(r.strategy>=2||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(h|=32),h+=31-h%31,r.status=N,$(r,h),0!==r.strstart&&($(r,t.adler>>>16),$(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending!==r.pending_buf_size));)Z(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,Z(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,Z(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=T(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=K)}else r.status=K;if(r.status===K&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&X(t),r.pending+2<=r.pending_buf_size&&(Z(r,255&t.adler),Z(r,t.adler>>8&255),t.adler=0,r.status=N)):r.status=N),0!==r.pending){if(X(t),0===t.avail_out)return r.last_flush=-1,0}else if(0===t.avail_in&&R(e)<=R(i)&&4!==e)return Q(t,-5);if(r.status===P&&0!==t.avail_in)return Q(t,-5);if(0!==t.avail_in||0!==r.lookahead||0!==e&&r.status!==P){var l=2===r.strategy?function(t,e){for(var a;;){if(0===t.lookahead&&(at(t),0===t.lookahead)){if(0===e)return 1;break}if(t.match_length=0,a=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2}(r,e):3===r.strategy?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=H){if(at(t),t.lookahead<=H&&0===e)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+H;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=H-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=F(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2}(r,e):st[r.level].func(r,e);if(3!==l&&4!==l||(r.status=P),1===l||3===l)return 0===t.avail_out&&(r.last_flush=-1),0;if(2===l&&(1===e?function(t){m(t,2,3),b(t,256,s),function(t){16===t.bi_valid?(w(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}(r):5!==e&&(q(r,0,0,!1),3===e&&(V(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),X(t),0===t.avail_out))return r.last_flush=-1,0}return 4!==e?0:r.wrap<=0?1:(2===r.wrap?(Z(r,255&t.adler),Z(r,t.adler>>8&255),Z(r,t.adler>>16&255),Z(r,t.adler>>24&255),Z(r,255&t.total_in),Z(r,t.total_in>>8&255),Z(r,t.total_in>>16&255),Z(r,t.total_in>>24&255)):($(r,t.adler>>>16),$(r,65535&t.adler)),X(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?0:1)},ot=function(t){if(!t||!t.state)return G;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==K&&e!==N&&e!==P?Q(t,G):(t.state=null,e===N?Q(t,-3):0)},dt=new Uint8Array(256),ut=0;ut<256;ut++)dt[ut]=ut>=252?6:ut>=248?5:ut>=240?4:ut>=224?3:ut>=192?2:1;dt[254]=dt[254]=1;var ft=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0},ct=Object.prototype.toString;function pt(){this.options={level:-1,method:8,chunkSize:16384,windowBits:15,memLevel:8,strategy:0};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new ft,this.strm.avail_out=0;var e,a,n=function(t,e,a,n,r,i){if(!t)return G;var s=1;if(-1===e&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||8!==a||n<8||n>15||e<0||e>9||i<0||i>4)return Q(t,G);8===n&&(n=9);var h=new ht;return t.state=h,h.strm=t,h.wrap=s,h.gzhead=null,h.w_bits=n,h.w_size=1<<h.w_bits,h.w_mask=h.w_size-1,h.hash_bits=r+7,h.hash_size=1<<h.hash_bits,h.hash_mask=h.hash_size-1,h.hash_shift=~~((h.hash_bits+3-1)/3),h.window=new Uint8Array(2*h.w_size),h.head=new Uint16Array(h.hash_size),h.prev=new Uint16Array(h.w_size),h.lit_bufsize=1<<r+6,h.pending_buf_size=4*h.lit_bufsize,h.pending_buf=new Uint8Array(h.pending_buf_size),h.d_buf=1*h.lit_bufsize,h.l_buf=3*h.lit_bufsize,h.level=e,h.strategy=i,h.method=a,lt(t)}(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(0!==n)throw Error(O[n]);if(t.header&&(e=this.strm,a=t.header,e&&e.state&&(2!==e.state.wrap||(e.state.gzhead=a))),t.dictionary){var r;if(r="[object ArrayBuffer]"===ct.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,0!==(n=function(t,e){var a=e.length;if(!t||!t.state)return G;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return G;if(1===r&&(t.adler=L(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(V(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,h=t.next_in,l=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,at(n);n.lookahead>=3;){var _=n.strstart,o=n.lookahead-2;do{n.ins_h=W(n,n.ins_h,n.window[_+3-1]),n.prev[_&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=_,_++}while(--o);n.strstart=_,n.lookahead=2,at(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=h,t.input=l,t.avail_in=s,n.wrap=r,0}(this.strm,r)))throw Error(O[n]);this._dict_set=!0}}function gt(t,e,a){try{t.postMessage({type:"errored",error:e,streamId:a})}catch(n){t.postMessage({type:"errored",error:e+"",streamId:a})}}function vt(t){const e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}pt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?4:0,"[object ArrayBuffer]"===ct.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(2===n||3===n)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if(1===(a=_t(r,n)))return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=ot(this.strm),this.onEnd(a),this.ended=!0,0===a;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},pt.prototype.onData=function(t){this.chunks.push(t)},pt.prototype.onEnd=function(t){0===t&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,h=t.length;i<h;i++){var l=t[i];r.set(l,s),s+=l.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e=self){try{const a=new Map;e.addEventListener("message",n=>{try{const r=function(e,a){switch(a.action){case"init":return{type:"initialized",version:"6.14.0"};case"write":{let n=e.get(a.streamId);n||(n=new pt,e.set(a.streamId,n));const r=n.chunks.length,i=function(t){if("function"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);let e,a,n,r,i,s=t.length,h=0;for(r=0;r<s;r++)a=t.charCodeAt(r),55296==(64512&a)&&r+1<s&&(n=t.charCodeAt(r+1),56320==(64512&n)&&(a=65536+(a-55296<<10)+(n-56320),r++)),h+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(h),i=0,r=0;i<h;r++)a=t.charCodeAt(r),55296==(64512&a)&&r+1<s&&(n=t.charCodeAt(r+1),56320==(64512&n)&&(a=65536+(a-55296<<10)+(n-56320),r++)),a<128?e[i++]=a:a<2048?(e[i++]=192|a>>>6,e[i++]=128|63&a):a<65536?(e[i++]=224|a>>>12,e[i++]=128|a>>>6&63,e[i++]=128|63&a):(e[i++]=240|a>>>18,e[i++]=128|a>>>12&63,e[i++]=128|a>>>6&63,e[i++]=128|63&a);return e}(a.data);return n.push(i,2),{type:"wrote",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:vt(n),additionalBytesCount:i.length}}case"reset":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){gt(e,t,n.data&&"streamId"in n.data?n.data.streamId:void 0)}})}catch(t){gt(e,t)}}()})();'])));
}
let wt = {
  status: 0
  /* DeflateWorkerStatus.Nil */
};
function Pa(t, e, n, r = Na) {
  switch (wt.status === 0 && sm(t, e, r), wt.status) {
    case 1:
      return wt.initializationFailureCallbacks.push(n), wt.worker;
    case 3:
      return wt.worker;
  }
}
function vi() {
  return wt.status;
}
function sm(t, e, n = Na) {
  try {
    const r = n(t), { stop: o } = mt(t, r, "error", (a) => {
      kr(t, e, a);
    }), { stop: i } = mt(t, r, "message", ({ data: a }) => {
      a.type === "errored" ? kr(t, e, a.error, a.streamId) : a.type === "initialized" && cm(a.version);
    });
    r.postMessage({ action: "init" }), At(() => am(e), im), wt = { status: 1, worker: r, stop: () => {
      o(), i();
    }, initializationFailureCallbacks: [] };
  } catch (r) {
    kr(t, e, r);
  }
}
function am(t) {
  wt.status === 1 && (X.error(`${t} failed to start: a timeout occurred while initializing the Worker`), wt.initializationFailureCallbacks.forEach((e) => e()), wt = {
    status: 2
    /* DeflateWorkerStatus.Error */
  });
}
function cm(t) {
  wt.status === 1 && (wt = { status: 3, worker: wt.worker, stop: wt.stop, version: t });
}
function kr(t, e, n, r) {
  wt.status === 1 || wt.status === 0 ? (Eo({
    configuredUrl: t.workerUrl,
    error: n,
    source: e,
    scriptType: "worker"
  }), wt.status === 1 && wt.initializationFailureCallbacks.forEach((o) => o()), wt = {
    status: 2
    /* DeflateWorkerStatus.Error */
  }) : eo(n, {
    worker_version: wt.status === 3 && wt.version,
    stream_id: r
  });
}
function Ua() {
  return (
    // Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from == "function" && typeof CSSSupportsRule == "function" && typeof URL.createObjectURL == "function" && "forEach" in NodeList.prototype
  );
}
function um(t, e, n, r) {
  const o = e.findTrackedSession(), i = lm(o, r), s = n.findView();
  return Zg(t, {
    viewContext: s,
    errorType: i,
    session: o
  });
}
function lm(t, e) {
  if (!Ua())
    return "browser-not-supported";
  if (!t)
    return "rum-not-tracked";
  if (t.sessionReplay === 0)
    return "incorrect-session-plan";
  if (!e)
    return "replay-not-started";
}
function dm(t, e, n, r, o, i) {
  let s = 0, a;
  e.subscribe(9, () => {
    (s === 2 || s === 3) && (f(), s = 1);
  }), e.subscribe(10, () => {
    s === 1 && u();
  });
  const c = async () => {
    const [l] = await Promise.all([o(), Ql(t, "interactive")]);
    if (s !== 2)
      return;
    const g = i();
    if (!g || !l) {
      s = 0;
      return;
    }
    ({ stop: a } = l(e, t, n, r, g)), s = 3;
  };
  function u(l) {
    const g = n.findTrackedSession();
    if (fm(g, l)) {
      s = 1;
      return;
    }
    pm(s) || (s = 2, c().catch(pn), hm(g, l) && n.setForcedReplay());
  }
  function f() {
    s === 3 && (a == null || a()), s = 0;
  }
  return {
    start: u,
    stop: f,
    getSessionReplayLink() {
      return um(
        t,
        n,
        r,
        s !== 0
        /* RecorderStatus.Stopped */
      );
    },
    isRecording: () => s === 3
  };
}
function fm(t, e) {
  return !t || t.sessionReplay === 0 && (!e || !e.force);
}
function pm(t) {
  return t === 2 || t === 3;
}
function hm(t, e) {
  return e && e.force && t.sessionReplay === 0;
}
function gm() {
  let t = 0;
  return {
    strategy: {
      start() {
        t = 1;
      },
      stop() {
        t = 2;
      },
      isRecording: () => !1,
      getSessionReplayLink: it
    },
    shouldStartImmediately(e) {
      return t === 1 || t === 0 && !e.startSessionReplayRecordingManually;
    }
  };
}
function mm(t, e) {
  if (ie() && !_s(
    "records"
    /* BridgeCapability.RECORDS */
  ) || !Ua())
    return {
      start: it,
      stop: it,
      getReplayStats: () => {
      },
      onRumStart: it,
      isRecording: () => !1,
      getSessionReplayLink: () => {
      }
    };
  let { strategy: n, shouldStartImmediately: r } = gm();
  return {
    start: (i) => n.start(i),
    stop: () => n.stop(),
    getSessionReplayLink: () => n.getSessionReplayLink(),
    onRumStart: o,
    isRecording: () => (
      // The worker is started optimistically, meaning we could have started to record but its
      // initialization fails a bit later. This could happen when:
      // * the worker URL (blob or plain URL) is blocked by CSP in Firefox only (Chromium and Safari
      // throw an exception when instantiating the worker, and IE doesn't care about CSP)
      // * the browser fails to load the worker in case the workerUrl is used
      // * an unexpected error occurs in the Worker before initialization, ex:
      //   * a runtime exception collected by monitor()
      //   * a syntax error notified by the browser via an error event
      // * the worker is unresponsive for some reason and timeouts
      //
      // It is not expected to happen often. Nonetheless, the "replayable" status on RUM events is
      // an important part of the Datadog App:
      // * If we have a false positive (we set has_replay: true even if no replay data is present),
      // we might display broken links to the Session Replay player.
      // * If we have a false negative (we don't set has_replay: true even if replay data is
      // available), it is less noticeable because no link will be displayed.
      //
      // Thus, it is better to have false negative, so let's make sure the worker is correctly
      // initialized before advertizing that we are recording.
      //
      // In the future, when the compression worker will also be used for RUM data, this will be
      // less important since no RUM event will be sent when the worker fails to initialize.
      vi() === 3 && n.isRecording()
    ),
    getReplayStats: (i) => vi() === 3 ? nm(i) : void 0
  };
  function o(i, s, a, c, u) {
    let f;
    function l() {
      return f || (u ?? (u = Pa(s, "Datadog Session Replay", () => {
        n.stop();
      }, e)), u && (f = La(
        s,
        u,
        1
        /* DeflateEncoderStreamId.REPLAY */
      ))), f;
    }
    n = dm(s, i, a, c, t, l), r(s) && n.start();
  }
}
async function _m(t = bm) {
  try {
    return await t();
  } catch (e) {
    Eo({
      error: e,
      source: "Recorder",
      scriptType: "module"
    });
  }
}
async function bm() {
  return (await import(
    /* webpackChunkName: "recorder" */
    "./startRecording-C_GoQ95M.js"
  )).startRecording;
}
function ym() {
  return qt().Profiler !== void 0;
}
const vm = (t) => {
  let e = {
    status: "starting"
  };
  return t.register(0, ({ eventType: n }) => n !== Y.VIEW && n !== Y.LONG_TASK ? Ft : {
    type: n,
    _dd: {
      profiling: e
    }
  }), {
    get: () => e,
    set: (n) => {
      e = n;
    }
  };
};
async function Em(t = wm) {
  try {
    return await t();
  } catch (e) {
    Eo({
      error: e,
      source: "Profiler",
      scriptType: "module"
    });
  }
}
async function wm() {
  return (await import(
    /* webpackChunkName: "profiler" */
    "./profiler-D9FxwYTZ.js"
  )).createRumProfiler;
}
function Sm() {
  let t;
  function e(n, r, o, i, s) {
    const a = i.findTrackedSession();
    if (!a || !Js(a.id, o.profilingSampleRate))
      return;
    const c = vm(r);
    if (!ym()) {
      c.set({
        status: "error",
        error_reason: "not-supported-by-browser"
      });
      return;
    }
    Em().then((u) => {
      if (!u) {
        se("[DD_RUM] Failed to lazy load the RUM Profiler"), c.set({ status: "error", error_reason: "failed-to-lazy-load" });
        return;
      }
      t = u(o, n, i, c), t.start(s.findView());
    }).catch(pn);
  }
  return {
    onRumStart: e,
    stop: () => {
      t == null || t.stop().catch(pn);
    }
  };
}
const Tm = mm(_m), Cm = Sm(), Gt = Rf(Xg, Tm, Cm, {
  startDeflateWorker: Pa,
  createDeflateEncoder: La,
  sdkName: "rum"
});
Os(qt(), "DD_RUM", Gt);
function Am() {
  return crypto.randomUUID();
}
function Hr() {
  const t = sessionStorage.getItem(Kr);
  if (t) return t;
  const e = Am();
  return sessionStorage.setItem(Kr, e), e;
}
function Ln(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Lr = { exports: {} }, Ei;
function Im() {
  return Ei || (Ei = 1, function(t, e) {
    (function(n) {
      t.exports = n();
    })(function() {
      return function n(r, o, i) {
        function s(u, f) {
          if (!o[u]) {
            if (!r[u]) {
              var l = typeof Ln == "function" && Ln;
              if (!f && l) return l(u, !0);
              if (a) return a(u, !0);
              throw new Error("Cannot find module '" + u + "'");
            }
            f = o[u] = { exports: {} }, r[u][0].call(f.exports, function(g) {
              var O = r[u][1][g];
              return s(O || g);
            }, f, f.exports, n, r, o, i);
          }
          return o[u].exports;
        }
        for (var a = typeof Ln == "function" && Ln, c = 0; c < i.length; c++) s(i[c]);
        return s;
      }({ 1: [function(n, r, o) {
        (function(i, s, a, c, u, f, l, g, O) {
          var E = n("crypto");
          function A(b, C) {
            C = k(b, C);
            var h;
            return (h = C.algorithm !== "passthrough" ? E.createHash(C.algorithm) : new U()).write === void 0 && (h.write = h.update, h.end = h.update), R(C, h).dispatch(b), h.update || h.end(""), h.digest ? h.digest(C.encoding === "buffer" ? void 0 : C.encoding) : (b = h.read(), C.encoding !== "buffer" ? b.toString(C.encoding) : b);
          }
          (o = r.exports = A).sha1 = function(b) {
            return A(b);
          }, o.keys = function(b) {
            return A(b, { excludeValues: !0, algorithm: "sha1", encoding: "hex" });
          }, o.MD5 = function(b) {
            return A(b, { algorithm: "md5", encoding: "hex" });
          }, o.keysMD5 = function(b) {
            return A(b, { algorithm: "md5", encoding: "hex", excludeValues: !0 });
          };
          var v = E.getHashes ? E.getHashes().slice() : ["sha1", "md5"], x = (v.push("passthrough"), ["buffer", "hex", "binary", "base64"]);
          function k(b, C) {
            var h = {};
            if (h.algorithm = (C = C || {}).algorithm || "sha1", h.encoding = C.encoding || "hex", h.excludeValues = !!C.excludeValues, h.algorithm = h.algorithm.toLowerCase(), h.encoding = h.encoding.toLowerCase(), h.ignoreUnknown = C.ignoreUnknown === !0, h.respectType = C.respectType !== !1, h.respectFunctionNames = C.respectFunctionNames !== !1, h.respectFunctionProperties = C.respectFunctionProperties !== !1, h.unorderedArrays = C.unorderedArrays === !0, h.unorderedSets = C.unorderedSets !== !1, h.unorderedObjects = C.unorderedObjects !== !1, h.replacer = C.replacer || void 0, h.excludeKeys = C.excludeKeys || void 0, b === void 0) throw new Error("Object argument required.");
            for (var _ = 0; _ < v.length; ++_) v[_].toLowerCase() === h.algorithm.toLowerCase() && (h.algorithm = v[_]);
            if (v.indexOf(h.algorithm) === -1) throw new Error('Algorithm "' + h.algorithm + '"  not supported. supported values: ' + v.join(", "));
            if (x.indexOf(h.encoding) === -1 && h.algorithm !== "passthrough") throw new Error('Encoding "' + h.encoding + '"  not supported. supported values: ' + x.join(", "));
            return h;
          }
          function T(b) {
            if (typeof b == "function") return /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(b)) != null;
          }
          function R(b, C, h) {
            h = h || [];
            function _(p) {
              return C.update ? C.update(p, "utf8") : C.write(p, "utf8");
            }
            return { dispatch: function(p) {
              return this["_" + ((p = b.replacer ? b.replacer(p) : p) === null ? "null" : typeof p)](p);
            }, _object: function(p) {
              var S, I = Object.prototype.toString.call(p), $ = /\[object (.*)\]/i.exec(I);
              if ($ = ($ = $ ? $[1] : "unknown:[" + I + "]").toLowerCase(), 0 <= (I = h.indexOf(p))) return this.dispatch("[CIRCULAR:" + I + "]");
              if (h.push(p), a !== void 0 && a.isBuffer && a.isBuffer(p)) return _("buffer:"), _(p);
              if ($ === "object" || $ === "function" || $ === "asyncfunction") return I = Object.keys(p), b.unorderedObjects && (I = I.sort()), b.respectType === !1 || T(p) || I.splice(0, 0, "prototype", "__proto__", "constructor"), b.excludeKeys && (I = I.filter(function(F) {
                return !b.excludeKeys(F);
              })), _("object:" + I.length + ":"), S = this, I.forEach(function(F) {
                S.dispatch(F), _(":"), b.excludeValues || S.dispatch(p[F]), _(",");
              });
              if (!this["_" + $]) {
                if (b.ignoreUnknown) return _("[" + $ + "]");
                throw new Error('Unknown object type "' + $ + '"');
              }
              this["_" + $](p);
            }, _array: function(p, F) {
              F = F !== void 0 ? F : b.unorderedArrays !== !1;
              var I = this;
              if (_("array:" + p.length + ":"), !F || p.length <= 1) return p.forEach(function(z) {
                return I.dispatch(z);
              });
              var $ = [], F = p.map(function(z) {
                var B = new U(), ot = h.slice();
                return R(b, B, ot).dispatch(z), $ = $.concat(ot.slice(h.length)), B.read().toString();
              });
              return h = h.concat($), F.sort(), this._array(F, !1);
            }, _date: function(p) {
              return _("date:" + p.toJSON());
            }, _symbol: function(p) {
              return _("symbol:" + p.toString());
            }, _error: function(p) {
              return _("error:" + p.toString());
            }, _boolean: function(p) {
              return _("bool:" + p.toString());
            }, _string: function(p) {
              _("string:" + p.length + ":"), _(p.toString());
            }, _function: function(p) {
              _("fn:"), T(p) ? this.dispatch("[native]") : this.dispatch(p.toString()), b.respectFunctionNames !== !1 && this.dispatch("function-name:" + String(p.name)), b.respectFunctionProperties && this._object(p);
            }, _number: function(p) {
              return _("number:" + p.toString());
            }, _xml: function(p) {
              return _("xml:" + p.toString());
            }, _null: function() {
              return _("Null");
            }, _undefined: function() {
              return _("Undefined");
            }, _regexp: function(p) {
              return _("regex:" + p.toString());
            }, _uint8array: function(p) {
              return _("uint8array:"), this.dispatch(Array.prototype.slice.call(p));
            }, _uint8clampedarray: function(p) {
              return _("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(p));
            }, _int8array: function(p) {
              return _("int8array:"), this.dispatch(Array.prototype.slice.call(p));
            }, _uint16array: function(p) {
              return _("uint16array:"), this.dispatch(Array.prototype.slice.call(p));
            }, _int16array: function(p) {
              return _("int16array:"), this.dispatch(Array.prototype.slice.call(p));
            }, _uint32array: function(p) {
              return _("uint32array:"), this.dispatch(Array.prototype.slice.call(p));
            }, _int32array: function(p) {
              return _("int32array:"), this.dispatch(Array.prototype.slice.call(p));
            }, _float32array: function(p) {
              return _("float32array:"), this.dispatch(Array.prototype.slice.call(p));
            }, _float64array: function(p) {
              return _("float64array:"), this.dispatch(Array.prototype.slice.call(p));
            }, _arraybuffer: function(p) {
              return _("arraybuffer:"), this.dispatch(new Uint8Array(p));
            }, _url: function(p) {
              return _("url:" + p.toString());
            }, _map: function(p) {
              return _("map:"), p = Array.from(p), this._array(p, b.unorderedSets !== !1);
            }, _set: function(p) {
              return _("set:"), p = Array.from(p), this._array(p, b.unorderedSets !== !1);
            }, _file: function(p) {
              return _("file:"), this.dispatch([p.name, p.size, p.type, p.lastModfied]);
            }, _blob: function() {
              if (b.ignoreUnknown) return _("[blob]");
              throw Error(`Hashing Blob objects is currently not supported
(see https://github.com/puleos/object-hash/issues/26)
Use "options.replacer" or "options.ignoreUnknown"
`);
            }, _domwindow: function() {
              return _("domwindow");
            }, _bigint: function(p) {
              return _("bigint:" + p.toString());
            }, _process: function() {
              return _("process");
            }, _timer: function() {
              return _("timer");
            }, _pipe: function() {
              return _("pipe");
            }, _tcp: function() {
              return _("tcp");
            }, _udp: function() {
              return _("udp");
            }, _tty: function() {
              return _("tty");
            }, _statwatcher: function() {
              return _("statwatcher");
            }, _securecontext: function() {
              return _("securecontext");
            }, _connection: function() {
              return _("connection");
            }, _zlib: function() {
              return _("zlib");
            }, _context: function() {
              return _("context");
            }, _nodescript: function() {
              return _("nodescript");
            }, _httpparser: function() {
              return _("httpparser");
            }, _dataview: function() {
              return _("dataview");
            }, _signal: function() {
              return _("signal");
            }, _fsevent: function() {
              return _("fsevent");
            }, _tlswrap: function() {
              return _("tlswrap");
            } };
          }
          function U() {
            return { buf: "", write: function(b) {
              this.buf += b;
            }, end: function(b) {
              this.buf += b;
            }, read: function() {
              return this.buf;
            } };
          }
          o.writeToStream = function(b, C, h) {
            return h === void 0 && (h = C, C = {}), R(C = k(b, C), h).dispatch(b);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
      }, { buffer: 3, crypto: 5, lYpoI2: 11 }], 2: [function(n, r, o) {
        (function(i, s, a, c, u, f, l, g, O) {
          (function(E) {
            var A = typeof Uint8Array < "u" ? Uint8Array : Array, v = 43, x = 47, k = 48, T = 97, R = 65, U = 45, b = 95;
            function C(h) {
              return h = h.charCodeAt(0), h === v || h === U ? 62 : h === x || h === b ? 63 : h < k ? -1 : h < k + 10 ? h - k + 26 + 26 : h < R + 26 ? h - R : h < T + 26 ? h - T + 26 : void 0;
            }
            E.toByteArray = function(h) {
              var _, p;
              if (0 < h.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
              var S = h.length, S = h.charAt(S - 2) === "=" ? 2 : h.charAt(S - 1) === "=" ? 1 : 0, I = new A(3 * h.length / 4 - S), $ = 0 < S ? h.length - 4 : h.length, F = 0;
              function z(B) {
                I[F++] = B;
              }
              for (_ = 0; _ < $; _ += 4, 0) z((16711680 & (p = C(h.charAt(_)) << 18 | C(h.charAt(_ + 1)) << 12 | C(h.charAt(_ + 2)) << 6 | C(h.charAt(_ + 3)))) >> 16), z((65280 & p) >> 8), z(255 & p);
              return S == 2 ? z(255 & (p = C(h.charAt(_)) << 2 | C(h.charAt(_ + 1)) >> 4)) : S == 1 && (z((p = C(h.charAt(_)) << 10 | C(h.charAt(_ + 1)) << 4 | C(h.charAt(_ + 2)) >> 2) >> 8 & 255), z(255 & p)), I;
            }, E.fromByteArray = function(h) {
              var _, p, S, I, $ = h.length % 3, F = "";
              function z(B) {
                return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(B);
              }
              for (_ = 0, S = h.length - $; _ < S; _ += 3) p = (h[_] << 16) + (h[_ + 1] << 8) + h[_ + 2], F += z((I = p) >> 18 & 63) + z(I >> 12 & 63) + z(I >> 6 & 63) + z(63 & I);
              switch ($) {
                case 1:
                  F = (F += z((p = h[h.length - 1]) >> 2)) + z(p << 4 & 63) + "==";
                  break;
                case 2:
                  F = (F = (F += z((p = (h[h.length - 2] << 8) + h[h.length - 1]) >> 10)) + z(p >> 4 & 63)) + z(p << 2 & 63) + "=";
              }
              return F;
            };
          })(o === void 0 ? this.base64js = {} : o);
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
      }, { buffer: 3, lYpoI2: 11 }], 3: [function(n, r, o) {
        (function(i, s, v, c, u, f, l, g, O) {
          var E = n("base64-js"), A = n("ieee754");
          function v(d, m, w) {
            if (!(this instanceof v)) return new v(d, m, w);
            var N, L, D, q, pt = typeof d;
            if (m === "base64" && pt == "string") for (d = (q = d).trim ? q.trim() : q.replace(/^\s+|\s+$/g, ""); d.length % 4 != 0; ) d += "=";
            if (pt == "number") N = gt(d);
            else if (pt == "string") N = v.byteLength(d, m);
            else {
              if (pt != "object") throw new Error("First argument needs to be a number, array or string.");
              N = gt(d.length);
            }
            if (v._useTypedArrays ? L = v._augment(new Uint8Array(N)) : ((L = this).length = N, L._isBuffer = !0), v._useTypedArrays && typeof d.byteLength == "number") L._set(d);
            else if (tt(q = d) || v.isBuffer(q) || q && typeof q == "object" && typeof q.length == "number") for (D = 0; D < N; D++) v.isBuffer(d) ? L[D] = d.readUInt8(D) : L[D] = d[D];
            else if (pt == "string") L.write(d, 0, m);
            else if (pt == "number" && !v._useTypedArrays && !w) for (D = 0; D < N; D++) L[D] = 0;
            return L;
          }
          function x(d, m, w, N) {
            return v._charsWritten = Mt(function(L) {
              for (var D = [], q = 0; q < L.length; q++) D.push(255 & L.charCodeAt(q));
              return D;
            }(m), d, w, N);
          }
          function k(d, m, w, N) {
            return v._charsWritten = Mt(function(L) {
              for (var D, q, pt = [], yt = 0; yt < L.length; yt++) q = L.charCodeAt(yt), D = q >> 8, q = q % 256, pt.push(q), pt.push(D);
              return pt;
            }(m), d, w, N);
          }
          function T(d, m, w) {
            var N = "";
            w = Math.min(d.length, w);
            for (var L = m; L < w; L++) N += String.fromCharCode(d[L]);
            return N;
          }
          function R(d, m, w, D) {
            D || (M(typeof w == "boolean", "missing or invalid endian"), M(m != null, "missing offset"), M(m + 1 < d.length, "Trying to read beyond buffer length"));
            var L, D = d.length;
            if (!(D <= m)) return w ? (L = d[m], m + 1 < D && (L |= d[m + 1] << 8)) : (L = d[m] << 8, m + 1 < D && (L |= d[m + 1])), L;
          }
          function U(d, m, w, D) {
            D || (M(typeof w == "boolean", "missing or invalid endian"), M(m != null, "missing offset"), M(m + 3 < d.length, "Trying to read beyond buffer length"));
            var L, D = d.length;
            if (!(D <= m)) return w ? (m + 2 < D && (L = d[m + 2] << 16), m + 1 < D && (L |= d[m + 1] << 8), L |= d[m], m + 3 < D && (L += d[m + 3] << 24 >>> 0)) : (m + 1 < D && (L = d[m + 1] << 16), m + 2 < D && (L |= d[m + 2] << 8), m + 3 < D && (L |= d[m + 3]), L += d[m] << 24 >>> 0), L;
          }
          function b(d, m, w, N) {
            if (N || (M(typeof w == "boolean", "missing or invalid endian"), M(m != null, "missing offset"), M(m + 1 < d.length, "Trying to read beyond buffer length")), !(d.length <= m)) return N = R(d, m, w, !0), 32768 & N ? -1 * (65535 - N + 1) : N;
          }
          function C(d, m, w, N) {
            if (N || (M(typeof w == "boolean", "missing or invalid endian"), M(m != null, "missing offset"), M(m + 3 < d.length, "Trying to read beyond buffer length")), !(d.length <= m)) return N = U(d, m, w, !0), 2147483648 & N ? -1 * (4294967295 - N + 1) : N;
          }
          function h(d, m, w, N) {
            return N || (M(typeof w == "boolean", "missing or invalid endian"), M(m + 3 < d.length, "Trying to read beyond buffer length")), A.read(d, m, w, 23, 4);
          }
          function _(d, m, w, N) {
            return N || (M(typeof w == "boolean", "missing or invalid endian"), M(m + 7 < d.length, "Trying to read beyond buffer length")), A.read(d, m, w, 52, 8);
          }
          function p(d, m, w, N, L) {
            if (L || (M(m != null, "missing value"), M(typeof N == "boolean", "missing or invalid endian"), M(w != null, "missing offset"), M(w + 1 < d.length, "trying to write beyond buffer length"), Qt(m, 65535)), L = d.length, !(L <= w)) for (var D = 0, q = Math.min(L - w, 2); D < q; D++) d[w + D] = (m & 255 << 8 * (N ? D : 1 - D)) >>> 8 * (N ? D : 1 - D);
          }
          function S(d, m, w, N, L) {
            if (L || (M(m != null, "missing value"), M(typeof N == "boolean", "missing or invalid endian"), M(w != null, "missing offset"), M(w + 3 < d.length, "trying to write beyond buffer length"), Qt(m, 4294967295)), L = d.length, !(L <= w)) for (var D = 0, q = Math.min(L - w, 4); D < q; D++) d[w + D] = m >>> 8 * (N ? D : 3 - D) & 255;
          }
          function I(d, m, w, N, L) {
            L || (M(m != null, "missing value"), M(typeof N == "boolean", "missing or invalid endian"), M(w != null, "missing offset"), M(w + 1 < d.length, "Trying to write beyond buffer length"), te(m, 32767, -32768)), d.length <= w || p(d, 0 <= m ? m : 65535 + m + 1, w, N, L);
          }
          function $(d, m, w, N, L) {
            L || (M(m != null, "missing value"), M(typeof N == "boolean", "missing or invalid endian"), M(w != null, "missing offset"), M(w + 3 < d.length, "Trying to write beyond buffer length"), te(m, 2147483647, -2147483648)), d.length <= w || S(d, 0 <= m ? m : 4294967295 + m + 1, w, N, L);
          }
          function F(d, m, w, N, L) {
            L || (M(m != null, "missing value"), M(typeof N == "boolean", "missing or invalid endian"), M(w != null, "missing offset"), M(w + 3 < d.length, "Trying to write beyond buffer length"), St(m, 34028234663852886e22, -34028234663852886e22)), d.length <= w || A.write(d, m, w, N, 23, 4);
          }
          function z(d, m, w, N, L) {
            L || (M(m != null, "missing value"), M(typeof N == "boolean", "missing or invalid endian"), M(w != null, "missing offset"), M(w + 7 < d.length, "Trying to write beyond buffer length"), St(m, 17976931348623157e292, -17976931348623157e292)), d.length <= w || A.write(d, m, w, N, 52, 8);
          }
          o.Buffer = v, o.SlowBuffer = v, o.INSPECT_MAX_BYTES = 50, v.poolSize = 8192, v._useTypedArrays = function() {
            try {
              var d = new ArrayBuffer(0), m = new Uint8Array(d);
              return m.foo = function() {
                return 42;
              }, m.foo() === 42 && typeof m.subarray == "function";
            } catch {
              return !1;
            }
          }(), v.isEncoding = function(d) {
            switch (String(d).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "binary":
              case "base64":
              case "raw":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;
              default:
                return !1;
            }
          }, v.isBuffer = function(d) {
            return !(d == null || !d._isBuffer);
          }, v.byteLength = function(d, m) {
            var w;
            switch (d += "", m || "utf8") {
              case "hex":
                w = d.length / 2;
                break;
              case "utf8":
              case "utf-8":
                w = ft(d).length;
                break;
              case "ascii":
              case "binary":
              case "raw":
                w = d.length;
                break;
              case "base64":
                w = Ut(d).length;
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                w = 2 * d.length;
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return w;
          }, v.concat = function(d, m) {
            if (M(tt(d), `Usage: Buffer.concat(list, [totalLength])
list should be an Array.`), d.length === 0) return new v(0);
            if (d.length === 1) return d[0];
            if (typeof m != "number") for (L = m = 0; L < d.length; L++) m += d[L].length;
            for (var w = new v(m), N = 0, L = 0; L < d.length; L++) {
              var D = d[L];
              D.copy(w, N), N += D.length;
            }
            return w;
          }, v.prototype.write = function(d, m, w, N) {
            isFinite(m) ? isFinite(w) || (N = w, w = void 0) : (yt = N, N = m, m = w, w = yt), m = Number(m) || 0;
            var L, D, q, pt, yt = this.length - m;
            switch ((!w || yt < (w = Number(w))) && (w = yt), N = String(N || "utf8").toLowerCase()) {
              case "hex":
                L = function(kt, Lt, Rt, _t) {
                  Rt = Number(Rt) || 0;
                  var bt = kt.length - Rt;
                  (!_t || bt < (_t = Number(_t))) && (_t = bt), M((bt = Lt.length) % 2 == 0, "Invalid hex string"), bt / 2 < _t && (_t = bt / 2);
                  for (var ee = 0; ee < _t; ee++) {
                    var nn = parseInt(Lt.substr(2 * ee, 2), 16);
                    M(!isNaN(nn), "Invalid hex string"), kt[Rt + ee] = nn;
                  }
                  return v._charsWritten = 2 * ee, ee;
                }(this, d, m, w);
                break;
              case "utf8":
              case "utf-8":
                D = this, q = m, pt = w, L = v._charsWritten = Mt(ft(d), D, q, pt);
                break;
              case "ascii":
              case "binary":
                L = x(this, d, m, w);
                break;
              case "base64":
                D = this, q = m, pt = w, L = v._charsWritten = Mt(Ut(d), D, q, pt);
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                L = k(this, d, m, w);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return L;
          }, v.prototype.toString = function(d, m, w) {
            var N, L, D, q, pt = this;
            if (d = String(d || "utf8").toLowerCase(), m = Number(m) || 0, (w = w !== void 0 ? Number(w) : pt.length) === m) return "";
            switch (d) {
              case "hex":
                N = function(yt, kt, Lt) {
                  var Rt = yt.length;
                  (!kt || kt < 0) && (kt = 0), (!Lt || Lt < 0 || Rt < Lt) && (Lt = Rt);
                  for (var _t = "", bt = kt; bt < Lt; bt++) _t += J(yt[bt]);
                  return _t;
                }(pt, m, w);
                break;
              case "utf8":
              case "utf-8":
                N = function(yt, kt, Lt) {
                  var Rt = "", _t = "";
                  Lt = Math.min(yt.length, Lt);
                  for (var bt = kt; bt < Lt; bt++) yt[bt] <= 127 ? (Rt += Re(_t) + String.fromCharCode(yt[bt]), _t = "") : _t += "%" + yt[bt].toString(16);
                  return Rt + Re(_t);
                }(pt, m, w);
                break;
              case "ascii":
              case "binary":
                N = T(pt, m, w);
                break;
              case "base64":
                L = pt, q = w, N = (D = m) === 0 && q === L.length ? E.fromByteArray(L) : E.fromByteArray(L.slice(D, q));
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                N = function(yt, kt, Lt) {
                  for (var Rt = yt.slice(kt, Lt), _t = "", bt = 0; bt < Rt.length; bt += 2) _t += String.fromCharCode(Rt[bt] + 256 * Rt[bt + 1]);
                  return _t;
                }(pt, m, w);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return N;
          }, v.prototype.toJSON = function() {
            return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
          }, v.prototype.copy = function(d, m, w, N) {
            if (m = m || 0, (N = N || N === 0 ? N : this.length) !== (w = w || 0) && d.length !== 0 && this.length !== 0) {
              M(w <= N, "sourceEnd < sourceStart"), M(0 <= m && m < d.length, "targetStart out of bounds"), M(0 <= w && w < this.length, "sourceStart out of bounds"), M(0 <= N && N <= this.length, "sourceEnd out of bounds"), N > this.length && (N = this.length);
              var L = (N = d.length - m < N - w ? d.length - m + w : N) - w;
              if (L < 100 || !v._useTypedArrays) for (var D = 0; D < L; D++) d[D + m] = this[D + w];
              else d._set(this.subarray(w, w + L), m);
            }
          }, v.prototype.slice = function(d, m) {
            var w = this.length;
            if (d = ot(d, w, 0), m = ot(m, w, w), v._useTypedArrays) return v._augment(this.subarray(d, m));
            for (var N = m - d, L = new v(N, void 0, !0), D = 0; D < N; D++) L[D] = this[D + d];
            return L;
          }, v.prototype.get = function(d) {
            return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(d);
          }, v.prototype.set = function(d, m) {
            return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(d, m);
          }, v.prototype.readUInt8 = function(d, m) {
            if (m || (M(d != null, "missing offset"), M(d < this.length, "Trying to read beyond buffer length")), !(d >= this.length)) return this[d];
          }, v.prototype.readUInt16LE = function(d, m) {
            return R(this, d, !0, m);
          }, v.prototype.readUInt16BE = function(d, m) {
            return R(this, d, !1, m);
          }, v.prototype.readUInt32LE = function(d, m) {
            return U(this, d, !0, m);
          }, v.prototype.readUInt32BE = function(d, m) {
            return U(this, d, !1, m);
          }, v.prototype.readInt8 = function(d, m) {
            if (m || (M(d != null, "missing offset"), M(d < this.length, "Trying to read beyond buffer length")), !(d >= this.length)) return 128 & this[d] ? -1 * (255 - this[d] + 1) : this[d];
          }, v.prototype.readInt16LE = function(d, m) {
            return b(this, d, !0, m);
          }, v.prototype.readInt16BE = function(d, m) {
            return b(this, d, !1, m);
          }, v.prototype.readInt32LE = function(d, m) {
            return C(this, d, !0, m);
          }, v.prototype.readInt32BE = function(d, m) {
            return C(this, d, !1, m);
          }, v.prototype.readFloatLE = function(d, m) {
            return h(this, d, !0, m);
          }, v.prototype.readFloatBE = function(d, m) {
            return h(this, d, !1, m);
          }, v.prototype.readDoubleLE = function(d, m) {
            return _(this, d, !0, m);
          }, v.prototype.readDoubleBE = function(d, m) {
            return _(this, d, !1, m);
          }, v.prototype.writeUInt8 = function(d, m, w) {
            w || (M(d != null, "missing value"), M(m != null, "missing offset"), M(m < this.length, "trying to write beyond buffer length"), Qt(d, 255)), m >= this.length || (this[m] = d);
          }, v.prototype.writeUInt16LE = function(d, m, w) {
            p(this, d, m, !0, w);
          }, v.prototype.writeUInt16BE = function(d, m, w) {
            p(this, d, m, !1, w);
          }, v.prototype.writeUInt32LE = function(d, m, w) {
            S(this, d, m, !0, w);
          }, v.prototype.writeUInt32BE = function(d, m, w) {
            S(this, d, m, !1, w);
          }, v.prototype.writeInt8 = function(d, m, w) {
            w || (M(d != null, "missing value"), M(m != null, "missing offset"), M(m < this.length, "Trying to write beyond buffer length"), te(d, 127, -128)), m >= this.length || (0 <= d ? this.writeUInt8(d, m, w) : this.writeUInt8(255 + d + 1, m, w));
          }, v.prototype.writeInt16LE = function(d, m, w) {
            I(this, d, m, !0, w);
          }, v.prototype.writeInt16BE = function(d, m, w) {
            I(this, d, m, !1, w);
          }, v.prototype.writeInt32LE = function(d, m, w) {
            $(this, d, m, !0, w);
          }, v.prototype.writeInt32BE = function(d, m, w) {
            $(this, d, m, !1, w);
          }, v.prototype.writeFloatLE = function(d, m, w) {
            F(this, d, m, !0, w);
          }, v.prototype.writeFloatBE = function(d, m, w) {
            F(this, d, m, !1, w);
          }, v.prototype.writeDoubleLE = function(d, m, w) {
            z(this, d, m, !0, w);
          }, v.prototype.writeDoubleBE = function(d, m, w) {
            z(this, d, m, !1, w);
          }, v.prototype.fill = function(d, m, w) {
            if (m = m || 0, w = w || this.length, M(typeof (d = typeof (d = d || 0) == "string" ? d.charCodeAt(0) : d) == "number" && !isNaN(d), "value is not a number"), M(m <= w, "end < start"), w !== m && this.length !== 0) {
              M(0 <= m && m < this.length, "start out of bounds"), M(0 <= w && w <= this.length, "end out of bounds");
              for (var N = m; N < w; N++) this[N] = d;
            }
          }, v.prototype.inspect = function() {
            for (var d = [], m = this.length, w = 0; w < m; w++) if (d[w] = J(this[w]), w === o.INSPECT_MAX_BYTES) {
              d[w + 1] = "...";
              break;
            }
            return "<Buffer " + d.join(" ") + ">";
          }, v.prototype.toArrayBuffer = function() {
            if (typeof Uint8Array > "u") throw new Error("Buffer.toArrayBuffer not supported in this browser");
            if (v._useTypedArrays) return new v(this).buffer;
            for (var d = new Uint8Array(this.length), m = 0, w = d.length; m < w; m += 1) d[m] = this[m];
            return d.buffer;
          };
          var B = v.prototype;
          function ot(d, m, w) {
            return typeof d != "number" ? w : m <= (d = ~~d) ? m : 0 <= d || 0 <= (d += m) ? d : 0;
          }
          function gt(d) {
            return (d = ~~Math.ceil(+d)) < 0 ? 0 : d;
          }
          function tt(d) {
            return (Array.isArray || function(m) {
              return Object.prototype.toString.call(m) === "[object Array]";
            })(d);
          }
          function J(d) {
            return d < 16 ? "0" + d.toString(16) : d.toString(16);
          }
          function ft(d) {
            for (var m = [], w = 0; w < d.length; w++) {
              var N = d.charCodeAt(w);
              if (N <= 127) m.push(d.charCodeAt(w));
              else for (var L = w, D = (55296 <= N && N <= 57343 && w++, encodeURIComponent(d.slice(L, w + 1)).substr(1).split("%")), q = 0; q < D.length; q++) m.push(parseInt(D[q], 16));
            }
            return m;
          }
          function Ut(d) {
            return E.toByteArray(d);
          }
          function Mt(d, m, w, N) {
            for (var L = 0; L < N && !(L + w >= m.length || L >= d.length); L++) m[L + w] = d[L];
            return L;
          }
          function Re(d) {
            try {
              return decodeURIComponent(d);
            } catch {
              return "�";
            }
          }
          function Qt(d, m) {
            M(typeof d == "number", "cannot write a non-number as a number"), M(0 <= d, "specified a negative value for writing an unsigned value"), M(d <= m, "value is larger than maximum value for type"), M(Math.floor(d) === d, "value has a fractional component");
          }
          function te(d, m, w) {
            M(typeof d == "number", "cannot write a non-number as a number"), M(d <= m, "value larger than maximum allowed value"), M(w <= d, "value smaller than minimum allowed value"), M(Math.floor(d) === d, "value has a fractional component");
          }
          function St(d, m, w) {
            M(typeof d == "number", "cannot write a non-number as a number"), M(d <= m, "value larger than maximum allowed value"), M(w <= d, "value smaller than minimum allowed value");
          }
          function M(d, m) {
            if (!d) throw new Error(m || "Failed assertion");
          }
          v._augment = function(d) {
            return d._isBuffer = !0, d._get = d.get, d._set = d.set, d.get = B.get, d.set = B.set, d.write = B.write, d.toString = B.toString, d.toLocaleString = B.toString, d.toJSON = B.toJSON, d.copy = B.copy, d.slice = B.slice, d.readUInt8 = B.readUInt8, d.readUInt16LE = B.readUInt16LE, d.readUInt16BE = B.readUInt16BE, d.readUInt32LE = B.readUInt32LE, d.readUInt32BE = B.readUInt32BE, d.readInt8 = B.readInt8, d.readInt16LE = B.readInt16LE, d.readInt16BE = B.readInt16BE, d.readInt32LE = B.readInt32LE, d.readInt32BE = B.readInt32BE, d.readFloatLE = B.readFloatLE, d.readFloatBE = B.readFloatBE, d.readDoubleLE = B.readDoubleLE, d.readDoubleBE = B.readDoubleBE, d.writeUInt8 = B.writeUInt8, d.writeUInt16LE = B.writeUInt16LE, d.writeUInt16BE = B.writeUInt16BE, d.writeUInt32LE = B.writeUInt32LE, d.writeUInt32BE = B.writeUInt32BE, d.writeInt8 = B.writeInt8, d.writeInt16LE = B.writeInt16LE, d.writeInt16BE = B.writeInt16BE, d.writeInt32LE = B.writeInt32LE, d.writeInt32BE = B.writeInt32BE, d.writeFloatLE = B.writeFloatLE, d.writeFloatBE = B.writeFloatBE, d.writeDoubleLE = B.writeDoubleLE, d.writeDoubleBE = B.writeDoubleBE, d.fill = B.fill, d.inspect = B.inspect, d.toArrayBuffer = B.toArrayBuffer, d;
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
      }, { "base64-js": 2, buffer: 3, ieee754: 10, lYpoI2: 11 }], 4: [function(n, r, o) {
        (function(i, s, E, c, u, f, l, g, O) {
          var E = n("buffer").Buffer, A = 4, v = new E(A);
          v.fill(0), r.exports = { hash: function(x, k, T, R) {
            for (var U = k(function(p, S) {
              p.length % A != 0 && (I = p.length + (A - p.length % A), p = E.concat([p, v], I));
              for (var I, $ = [], F = S ? p.readInt32BE : p.readInt32LE, z = 0; z < p.length; z += A) $.push(F.call(p, z));
              return $;
            }(x = E.isBuffer(x) ? x : new E(x), R), 8 * x.length), k = R, b = new E(T), C = k ? b.writeInt32BE : b.writeInt32LE, h = 0; h < U.length; h++) C.call(b, U[h], 4 * h, !0);
            return b;
          } };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 5: [function(n, r, o) {
        (function(i, s, E, c, u, f, l, g, O) {
          var E = n("buffer").Buffer, A = n("./sha"), v = n("./sha256"), x = n("./rng"), k = { sha1: A, sha256: v, md5: n("./md5") }, T = 64, R = new E(T);
          function U(p, S) {
            var I = k[p = p || "sha1"], $ = [];
            return I || b("algorithm:", p, "is not yet supported"), { update: function(F) {
              return E.isBuffer(F) || (F = new E(F)), $.push(F), F.length, this;
            }, digest: function(F) {
              var z = E.concat($), z = S ? function(B, ot, gt) {
                E.isBuffer(ot) || (ot = new E(ot)), E.isBuffer(gt) || (gt = new E(gt)), ot.length > T ? ot = B(ot) : ot.length < T && (ot = E.concat([ot, R], T));
                for (var tt = new E(T), J = new E(T), ft = 0; ft < T; ft++) tt[ft] = 54 ^ ot[ft], J[ft] = 92 ^ ot[ft];
                return gt = B(E.concat([tt, gt])), B(E.concat([J, gt]));
              }(I, S, z) : I(z);
              return $ = null, F ? z.toString(F) : z;
            } };
          }
          function b() {
            var p = [].slice.call(arguments).join(" ");
            throw new Error([p, "we accept pull requests", "http://github.com/dominictarr/crypto-browserify"].join(`
`));
          }
          R.fill(0), o.createHash = function(p) {
            return U(p);
          }, o.createHmac = U, o.randomBytes = function(p, S) {
            if (!S || !S.call) return new E(x(p));
            try {
              S.call(this, void 0, new E(x(p)));
            } catch (I) {
              S(I);
            }
          };
          var C, h = ["createCredentials", "createCipher", "createCipheriv", "createDecipher", "createDecipheriv", "createSign", "createVerify", "createDiffieHellman", "pbkdf2"], _ = function(p) {
            o[p] = function() {
              b("sorry,", p, "is not implemented yet");
            };
          };
          for (C in h) _(h[C]);
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./md5": 6, "./rng": 7, "./sha": 8, "./sha256": 9, buffer: 3, lYpoI2: 11 }], 6: [function(n, r, o) {
        (function(i, s, a, c, u, f, l, g, O) {
          var E = n("./helpers");
          function A(b, C) {
            b[C >> 5] |= 128 << C % 32, b[14 + (C + 64 >>> 9 << 4)] = C;
            for (var h = 1732584193, _ = -271733879, p = -1732584194, S = 271733878, I = 0; I < b.length; I += 16) {
              var $ = h, F = _, z = p, B = S, h = x(h, _, p, S, b[I + 0], 7, -680876936), S = x(S, h, _, p, b[I + 1], 12, -389564586), p = x(p, S, h, _, b[I + 2], 17, 606105819), _ = x(_, p, S, h, b[I + 3], 22, -1044525330);
              h = x(h, _, p, S, b[I + 4], 7, -176418897), S = x(S, h, _, p, b[I + 5], 12, 1200080426), p = x(p, S, h, _, b[I + 6], 17, -1473231341), _ = x(_, p, S, h, b[I + 7], 22, -45705983), h = x(h, _, p, S, b[I + 8], 7, 1770035416), S = x(S, h, _, p, b[I + 9], 12, -1958414417), p = x(p, S, h, _, b[I + 10], 17, -42063), _ = x(_, p, S, h, b[I + 11], 22, -1990404162), h = x(h, _, p, S, b[I + 12], 7, 1804603682), S = x(S, h, _, p, b[I + 13], 12, -40341101), p = x(p, S, h, _, b[I + 14], 17, -1502002290), h = k(h, _ = x(_, p, S, h, b[I + 15], 22, 1236535329), p, S, b[I + 1], 5, -165796510), S = k(S, h, _, p, b[I + 6], 9, -1069501632), p = k(p, S, h, _, b[I + 11], 14, 643717713), _ = k(_, p, S, h, b[I + 0], 20, -373897302), h = k(h, _, p, S, b[I + 5], 5, -701558691), S = k(S, h, _, p, b[I + 10], 9, 38016083), p = k(p, S, h, _, b[I + 15], 14, -660478335), _ = k(_, p, S, h, b[I + 4], 20, -405537848), h = k(h, _, p, S, b[I + 9], 5, 568446438), S = k(S, h, _, p, b[I + 14], 9, -1019803690), p = k(p, S, h, _, b[I + 3], 14, -187363961), _ = k(_, p, S, h, b[I + 8], 20, 1163531501), h = k(h, _, p, S, b[I + 13], 5, -1444681467), S = k(S, h, _, p, b[I + 2], 9, -51403784), p = k(p, S, h, _, b[I + 7], 14, 1735328473), h = T(h, _ = k(_, p, S, h, b[I + 12], 20, -1926607734), p, S, b[I + 5], 4, -378558), S = T(S, h, _, p, b[I + 8], 11, -2022574463), p = T(p, S, h, _, b[I + 11], 16, 1839030562), _ = T(_, p, S, h, b[I + 14], 23, -35309556), h = T(h, _, p, S, b[I + 1], 4, -1530992060), S = T(S, h, _, p, b[I + 4], 11, 1272893353), p = T(p, S, h, _, b[I + 7], 16, -155497632), _ = T(_, p, S, h, b[I + 10], 23, -1094730640), h = T(h, _, p, S, b[I + 13], 4, 681279174), S = T(S, h, _, p, b[I + 0], 11, -358537222), p = T(p, S, h, _, b[I + 3], 16, -722521979), _ = T(_, p, S, h, b[I + 6], 23, 76029189), h = T(h, _, p, S, b[I + 9], 4, -640364487), S = T(S, h, _, p, b[I + 12], 11, -421815835), p = T(p, S, h, _, b[I + 15], 16, 530742520), h = R(h, _ = T(_, p, S, h, b[I + 2], 23, -995338651), p, S, b[I + 0], 6, -198630844), S = R(S, h, _, p, b[I + 7], 10, 1126891415), p = R(p, S, h, _, b[I + 14], 15, -1416354905), _ = R(_, p, S, h, b[I + 5], 21, -57434055), h = R(h, _, p, S, b[I + 12], 6, 1700485571), S = R(S, h, _, p, b[I + 3], 10, -1894986606), p = R(p, S, h, _, b[I + 10], 15, -1051523), _ = R(_, p, S, h, b[I + 1], 21, -2054922799), h = R(h, _, p, S, b[I + 8], 6, 1873313359), S = R(S, h, _, p, b[I + 15], 10, -30611744), p = R(p, S, h, _, b[I + 6], 15, -1560198380), _ = R(_, p, S, h, b[I + 13], 21, 1309151649), h = R(h, _, p, S, b[I + 4], 6, -145523070), S = R(S, h, _, p, b[I + 11], 10, -1120210379), p = R(p, S, h, _, b[I + 2], 15, 718787259), _ = R(_, p, S, h, b[I + 9], 21, -343485551), h = U(h, $), _ = U(_, F), p = U(p, z), S = U(S, B);
            }
            return Array(h, _, p, S);
          }
          function v(b, C, h, _, p, S) {
            return U((C = U(U(C, b), U(_, S))) << p | C >>> 32 - p, h);
          }
          function x(b, C, h, _, p, S, I) {
            return v(C & h | ~C & _, b, C, p, S, I);
          }
          function k(b, C, h, _, p, S, I) {
            return v(C & _ | h & ~_, b, C, p, S, I);
          }
          function T(b, C, h, _, p, S, I) {
            return v(C ^ h ^ _, b, C, p, S, I);
          }
          function R(b, C, h, _, p, S, I) {
            return v(h ^ (C | ~_), b, C, p, S, I);
          }
          function U(b, C) {
            var h = (65535 & b) + (65535 & C);
            return (b >> 16) + (C >> 16) + (h >> 16) << 16 | 65535 & h;
          }
          r.exports = function(b) {
            return E.hash(b, A, 16);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 7: [function(n, r, o) {
        (function(i, s, a, c, u, f, l, g, O) {
          r.exports = function(E) {
            for (var A, v = new Array(E), x = 0; x < E; x++) (3 & x) == 0 && (A = 4294967296 * Math.random()), v[x] = A >>> ((3 & x) << 3) & 255;
            return v;
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 8: [function(n, r, o) {
        (function(i, s, a, c, u, f, l, g, O) {
          var E = n("./helpers");
          function A(k, T) {
            k[T >> 5] |= 128 << 24 - T % 32, k[15 + (T + 64 >> 9 << 4)] = T;
            for (var R, U, b, C = Array(80), h = 1732584193, _ = -271733879, p = -1732584194, S = 271733878, I = -1009589776, $ = 0; $ < k.length; $ += 16) {
              for (var F = h, z = _, B = p, ot = S, gt = I, tt = 0; tt < 80; tt++) {
                C[tt] = tt < 16 ? k[$ + tt] : x(C[tt - 3] ^ C[tt - 8] ^ C[tt - 14] ^ C[tt - 16], 1);
                var J = v(v(x(h, 5), (J = _, U = p, b = S, (R = tt) < 20 ? J & U | ~J & b : !(R < 40) && R < 60 ? J & U | J & b | U & b : J ^ U ^ b)), v(v(I, C[tt]), (R = tt) < 20 ? 1518500249 : R < 40 ? 1859775393 : R < 60 ? -1894007588 : -899497514)), I = S, S = p, p = x(_, 30), _ = h, h = J;
              }
              h = v(h, F), _ = v(_, z), p = v(p, B), S = v(S, ot), I = v(I, gt);
            }
            return Array(h, _, p, S, I);
          }
          function v(k, T) {
            var R = (65535 & k) + (65535 & T);
            return (k >> 16) + (T >> 16) + (R >> 16) << 16 | 65535 & R;
          }
          function x(k, T) {
            return k << T | k >>> 32 - T;
          }
          r.exports = function(k) {
            return E.hash(k, A, 20, !0);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 9: [function(n, r, o) {
        (function(i, s, a, c, u, f, l, g, O) {
          function E(T, R) {
            var U = (65535 & T) + (65535 & R);
            return (T >> 16) + (R >> 16) + (U >> 16) << 16 | 65535 & U;
          }
          function A(T, R) {
            var U, b = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), C = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), h = new Array(64);
            T[R >> 5] |= 128 << 24 - R % 32, T[15 + (R + 64 >> 9 << 4)] = R;
            for (var _, p, S = 0; S < T.length; S += 16) {
              for (var I = C[0], $ = C[1], F = C[2], z = C[3], B = C[4], ot = C[5], gt = C[6], tt = C[7], J = 0; J < 64; J++) h[J] = J < 16 ? T[J + S] : E(E(E((p = h[J - 2], x(p, 17) ^ x(p, 19) ^ k(p, 10)), h[J - 7]), (p = h[J - 15], x(p, 7) ^ x(p, 18) ^ k(p, 3))), h[J - 16]), U = E(E(E(E(tt, x(p = B, 6) ^ x(p, 11) ^ x(p, 25)), B & ot ^ ~B & gt), b[J]), h[J]), _ = E(x(_ = I, 2) ^ x(_, 13) ^ x(_, 22), I & $ ^ I & F ^ $ & F), tt = gt, gt = ot, ot = B, B = E(z, U), z = F, F = $, $ = I, I = E(U, _);
              C[0] = E(I, C[0]), C[1] = E($, C[1]), C[2] = E(F, C[2]), C[3] = E(z, C[3]), C[4] = E(B, C[4]), C[5] = E(ot, C[5]), C[6] = E(gt, C[6]), C[7] = E(tt, C[7]);
            }
            return C;
          }
          var v = n("./helpers"), x = function(T, R) {
            return T >>> R | T << 32 - R;
          }, k = function(T, R) {
            return T >>> R;
          };
          r.exports = function(T) {
            return v.hash(T, A, 32, !0);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 10: [function(n, r, o) {
        (function(i, s, a, c, u, f, l, g, O) {
          o.read = function(E, A, v, x, S) {
            var T, R, U = 8 * S - x - 1, b = (1 << U) - 1, C = b >> 1, h = -7, _ = v ? S - 1 : 0, p = v ? -1 : 1, S = E[A + _];
            for (_ += p, T = S & (1 << -h) - 1, S >>= -h, h += U; 0 < h; T = 256 * T + E[A + _], _ += p, h -= 8) ;
            for (R = T & (1 << -h) - 1, T >>= -h, h += x; 0 < h; R = 256 * R + E[A + _], _ += p, h -= 8) ;
            if (T === 0) T = 1 - C;
            else {
              if (T === b) return R ? NaN : 1 / 0 * (S ? -1 : 1);
              R += Math.pow(2, x), T -= C;
            }
            return (S ? -1 : 1) * R * Math.pow(2, T - x);
          }, o.write = function(E, A, v, x, k, I) {
            var R, U, b = 8 * I - k - 1, C = (1 << b) - 1, h = C >> 1, _ = k === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = x ? 0 : I - 1, S = x ? 1 : -1, I = A < 0 || A === 0 && 1 / A < 0 ? 1 : 0;
            for (A = Math.abs(A), isNaN(A) || A === 1 / 0 ? (U = isNaN(A) ? 1 : 0, R = C) : (R = Math.floor(Math.log(A) / Math.LN2), A * (x = Math.pow(2, -R)) < 1 && (R--, x *= 2), 2 <= (A += 1 <= R + h ? _ / x : _ * Math.pow(2, 1 - h)) * x && (R++, x /= 2), C <= R + h ? (U = 0, R = C) : 1 <= R + h ? (U = (A * x - 1) * Math.pow(2, k), R += h) : (U = A * Math.pow(2, h - 1) * Math.pow(2, k), R = 0)); 8 <= k; E[v + p] = 255 & U, p += S, U /= 256, k -= 8) ;
            for (R = R << k | U, b += k; 0 < b; E[v + p] = 255 & R, p += S, R /= 256, b -= 8) ;
            E[v + p - S] |= 128 * I;
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
      }, { buffer: 3, lYpoI2: 11 }], 11: [function(n, r, o) {
        (function(i, s, a, c, u, f, l, g, O) {
          var E, A, v;
          function x() {
          }
          (i = r.exports = {}).nextTick = (A = typeof window < "u" && window.setImmediate, v = typeof window < "u" && window.postMessage && window.addEventListener, A ? function(k) {
            return window.setImmediate(k);
          } : v ? (E = [], window.addEventListener("message", function(k) {
            var T = k.source;
            T !== window && T !== null || k.data !== "process-tick" || (k.stopPropagation(), 0 < E.length && E.shift()());
          }, !0), function(k) {
            E.push(k), window.postMessage("process-tick", "*");
          }) : function(k) {
            setTimeout(k, 0);
          }), i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.on = x, i.addListener = x, i.once = x, i.off = x, i.removeListener = x, i.removeAllListeners = x, i.emit = x, i.binding = function(k) {
            throw new Error("process.binding is not supported");
          }, i.cwd = function() {
            return "/";
          }, i.chdir = function(k) {
            throw new Error("process.chdir is not supported");
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
      }, { buffer: 3, lYpoI2: 11 }] }, {}, [1])(1);
    });
  }(Lr)), Lr.exports;
}
var Rm = Im();
const xm = /* @__PURE__ */ Oi(Rm), Om = (t) => !(t.type === "error" && t.error.message.includes("localhost:12387")), km = (t) => {
  var e, n;
  return !(t.type === "error" && ((n = (e = t.error) == null ? void 0 : e.message) != null && n.includes("chrome-extension://")));
}, Lm = [
  Om,
  km
];
function wi(t, e = []) {
  const r = [
    ...[
      "password",
      "token",
      "authorization",
      "secret",
      "document",
      "cpf",
      "cnpj"
    ],
    ...e
  ].map((a) => a.toLowerCase());
  function o(a) {
    return `[REDACTED:${typeof a}]`;
  }
  function i(a) {
    return r.some(
      (c) => a.toLowerCase().includes(c)
    );
  }
  function s(a) {
    if (Array.isArray(a))
      return a.map(s);
    if (a !== null && typeof a == "object") {
      const c = {};
      for (const [u, f] of Object.entries(a))
        c[u] = i(u) ? o(f) : s(f);
      return c;
    }
    return a;
  }
  return s(t);
}
const Nm = (t, e, n) => {
  Xm(t, {
    componentStack: e.componentStack ?? "",
    source: "react-error-boundary",
    ...n == null ? void 0 : n()
  });
}, Pm = (t) => JSON.parse(decodeURIComponent(escape(atob(t)))), Um = (t) => {
  for (t = t.replace(/-/g, "+").replace(/_/g, "/"); t.length % 4; )
    t += "=";
  return Pm(t);
}, Mm = (t) => {
  const [, e] = t.split(".");
  return Um(e);
}, Dm = (t) => {
  const e = Dr.get(t);
  if (e) {
    const n = Mm(e);
    return n == null ? void 0 : n["custom:id_naturalperson"];
  }
  return null;
}, Bm = 6e4, Si = /* @__PURE__ */ new Map();
class Fm {
  constructor(e) {
    dt(this, "rumEnabled");
    dt(this, "logsEnabled");
    dt(this, "replayEnabled");
    dt(this, "userId", null);
    this.config = e, this.logsEnabled = e.enableLogs ?? !0, this.rumEnabled = e.enableRum ?? !0, this.replayEnabled = e.enableSessionReplayRecording ?? !0;
  }
  initialize() {
    const { shared: e, logs: n, rum: r } = this.config;
    if (this.logsEnabled && n) {
      const { beforeSend: o, ...i } = n;
      ce.init({
        ...i,
        ...e,
        beforeSend: this.buildBeforeSendLog({
          userBeforeSend: o
        })
      });
    }
    if (this.rumEnabled && r) {
      const {
        filters: o = [],
        enrichers: i,
        transformers: s,
        allowedEventTypes: a,
        errorSampling: c,
        beforeSend: u,
        ...f
      } = r, l = [...Lm, ...o];
      Gt.init({
        ...f,
        ...e,
        applicationId: r.applicationId,
        beforeSend: this.buildBeforeSendRum({
          allowedEventTypes: a,
          filters: l,
          enrichers: i,
          transformers: s,
          userBeforeSend: u,
          errorSampling: c
        })
      }), this.replayEnabled && Gt.startSessionReplayRecording();
    }
    this.config.cookieJwtName && (this.userId = Dm(this.config.cookieJwtName), this.userId && this.setUserContext({
      id: this.userId
    }));
  }
  addRumError(e, n) {
    this.guard("rum", "addRumError", () => {
      Gt.addError(e, n);
    });
  }
  logInfo(e, n, r) {
    this.guard("logs", "logInfo", () => {
      ce.logger.info(e, n, r);
    });
  }
  logError(e, n, r) {
    this.guard("logs", "logError", () => {
      ce.logger.error(e, n, r);
    });
  }
  setUserContext(e) {
    this.rumEnabled && Gt.setUser(e), this.logsEnabled && ce.setUser(e);
  }
  clearUserContext() {
    this.rumEnabled && Gt.clearUser(), this.logsEnabled && ce.clearUser();
  }
  setGlobalContextProperty(e, n) {
    this.rumEnabled && Gt.setGlobalContextProperty(e, n), this.logsEnabled && ce.setGlobalContextProperty(e, n);
  }
  removeGlobalContextProperty(e) {
    this.rumEnabled && Gt.removeGlobalContextProperty(e), this.logsEnabled && ce.removeGlobalContextProperty(e);
  }
  trackRouteChange(e) {
    this.rumEnabled && Gt.startView(e);
  }
  trackUserAction(e, n) {
    this.rumEnabled && Gt.addAction(e, n);
  }
  trackFeatureFlag(e, n) {
    this.rumEnabled && Gt.addFeatureFlagEvaluation(e, n);
  }
  trackMultipleFeatureFlags(e) {
    if (this.rumEnabled)
      for (const [n, r] of Object.entries(e))
        Gt.addFeatureFlagEvaluation(n, r);
  }
  guard(e, n, r) {
    if (!(e === "logs" ? this.logsEnabled : e === "rum" ? this.rumEnabled : !1)) {
      this.config.isDev && console.warn(
        `[Observability] ${n} skipped: ${e} is disabled`
      );
      return;
    }
    r();
  }
  buildErrorContext(e, n, r = {}) {
    const {
      correlationID: o,
      http_status: i,
      type: s,
      exception: a,
      error: c,
      ...u
    } = r;
    return {
      team: this.config.team,
      environment: this.config.shared.env,
      log_level: e,
      correlation_id: o ?? Hr(),
      message: n,
      http_status: i,
      type: s ?? (e === "ERROR" ? "UI_ERROR" : "UI_EVENT"),
      exception: a ?? this.extractException(c),
      error: c,
      ...u
    };
  }
  extractException(e) {
    return e instanceof Error ? {
      kind: e.name,
      message: e.message,
      stack: e.stack
    } : e;
  }
  buildBeforeSendRum(e) {
    const {
      allowedEventTypes: n = [],
      filters: r,
      enrichers: o = [],
      transformers: i = [],
      userBeforeSend: s,
      errorSampling: a
    } = e;
    return (c, u) => {
      c = this.applyTransformers(c, i);
      for (const f of o) {
        const l = f(c);
        Object.assign(u, l);
      }
      if (c.type === "error") {
        if (a && a.enabled) {
          const f = this.shouldSampleError(c, a);
          if (!f.send) return !1;
          f.context && (c.context = {
            ...c.context,
            ...f.context
          });
        }
        c.context = {
          ...c.context,
          correlation_id: Hr()
        };
      }
      if (n.length > 0 && !n.includes(c.type))
        return !1;
      for (const f of r)
        if (!f(c, u)) return !1;
      return s ? s(c, u) : !0;
    };
  }
  buildBeforeSendLog(e) {
    const { userBeforeSend: n } = e;
    return (r, o) => {
      const i = this.buildErrorContext("ERROR", r.message, {
        ...r,
        ...o
      });
      return Object.assign(r, i), n ? n(r, o) : !0;
    };
  }
  applyTransformers(e, n) {
    return n.reduce(
      (r, o) => o(r),
      e
    );
  }
  shouldSampleError(e, n) {
    if (!n.enabled) return { send: !0 };
    if (n.filter && !n.filter(e)) return { send: !0 };
    const r = this.getErrorKey(e), o = Date.now(), i = Si.get(r), s = n.ttlMs ?? Bm;
    if (i && o - i.lastSent < s)
      return i.suppressedCount += 1, { send: !1 };
    const a = (i == null ? void 0 : i.suppressedCount) ?? 0;
    return Si.set(r, { lastSent: o, suppressedCount: 0 }), {
      send: !0,
      context: {
        suppressedSinceLastSend: a,
        samplingStrategy: "TTL",
        ttl: s
      }
    };
  }
  getErrorKey(e) {
    const n = e.error, r = typeof (n == null ? void 0 : n.message) == "string" ? n.message : "", o = typeof (n == null ? void 0 : n.stack) == "string" ? n.stack : "";
    return xm({ message: r, stack: o });
  }
}
var Nn = { exports: {} }, Ue = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Nr, Ti;
function Ma() {
  if (Ti) return Nr;
  Ti = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var c = Object.getOwnPropertyNames(s).map(function(f) {
        return s[f];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        u[f] = f;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Nr = o() ? Object.assign : function(i, s) {
    for (var a, c = r(i), u, f = 1; f < arguments.length; f++) {
      a = Object(arguments[f]);
      for (var l in a)
        e.call(a, l) && (c[l] = a[l]);
      if (t) {
        u = t(a);
        for (var g = 0; g < u.length; g++)
          n.call(a, u[g]) && (c[u[g]] = a[u[g]]);
      }
    }
    return c;
  }, Nr;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ci;
function Vm() {
  if (Ci) return Ue;
  Ci = 1, Ma();
  var t = Ri, e = 60103;
  if (Ue.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var n = Symbol.for;
    e = n("react.element"), Ue.Fragment = n("react.fragment");
  }
  var r = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, c, u) {
    var f, l = {}, g = null, O = null;
    u !== void 0 && (g = "" + u), c.key !== void 0 && (g = "" + c.key), c.ref !== void 0 && (O = c.ref);
    for (f in c) o.call(c, f) && !i.hasOwnProperty(f) && (l[f] = c[f]);
    if (a && a.defaultProps) for (f in c = a.defaultProps, c) l[f] === void 0 && (l[f] = c[f]);
    return { $$typeof: e, type: a, key: g, ref: O, props: l, _owner: r.current };
  }
  return Ue.jsx = s, Ue.jsxs = s, Ue;
}
var Pr = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ai;
function $m() {
  return Ai || (Ai = 1, function(t) {
    process.env.NODE_ENV !== "production" && function() {
      var e = Ri, n = Ma(), r = 60103, o = 60106;
      t.Fragment = 60107;
      var i = 60108, s = 60114, a = 60109, c = 60110, u = 60112, f = 60113, l = 60120, g = 60115, O = 60116, E = 60121, A = 60122, v = 60117, x = 60129, k = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var T = Symbol.for;
        r = T("react.element"), o = T("react.portal"), t.Fragment = T("react.fragment"), i = T("react.strict_mode"), s = T("react.profiler"), a = T("react.provider"), c = T("react.context"), u = T("react.forward_ref"), f = T("react.suspense"), l = T("react.suspense_list"), g = T("react.memo"), O = T("react.lazy"), E = T("react.block"), A = T("react.server.block"), v = T("react.fundamental"), T("react.scope"), T("react.opaque.id"), x = T("react.debug_trace_mode"), T("react.offscreen"), k = T("react.legacy_hidden");
      }
      var R = typeof Symbol == "function" && Symbol.iterator, U = "@@iterator";
      function b(y) {
        if (y === null || typeof y != "object")
          return null;
        var P = R && y[R] || y[U];
        return typeof P == "function" ? P : null;
      }
      var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function h(y) {
        {
          for (var P = arguments.length, V = new Array(P > 1 ? P - 1 : 0), H = 1; H < P; H++)
            V[H - 1] = arguments[H];
          _("error", y, V);
        }
      }
      function _(y, P, V) {
        {
          var H = C.ReactDebugCurrentFrame, lt = H.getStackAddendum();
          lt !== "" && (P += "%s", V = V.concat([lt]));
          var ut = V.map(function(et) {
            return "" + et;
          });
          ut.unshift("Warning: " + P), Function.prototype.apply.call(console[y], console, ut);
        }
      }
      var p = !1;
      function S(y) {
        return !!(typeof y == "string" || typeof y == "function" || y === t.Fragment || y === s || y === x || y === i || y === f || y === l || y === k || p || typeof y == "object" && y !== null && (y.$$typeof === O || y.$$typeof === g || y.$$typeof === a || y.$$typeof === c || y.$$typeof === u || y.$$typeof === v || y.$$typeof === E || y[0] === A));
      }
      function I(y, P, V) {
        var H = P.displayName || P.name || "";
        return y.displayName || (H !== "" ? V + "(" + H + ")" : V);
      }
      function $(y) {
        return y.displayName || "Context";
      }
      function F(y) {
        if (y == null)
          return null;
        if (typeof y.tag == "number" && h("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof y == "function")
          return y.displayName || y.name || null;
        if (typeof y == "string")
          return y;
        switch (y) {
          case t.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case s:
            return "Profiler";
          case i:
            return "StrictMode";
          case f:
            return "Suspense";
          case l:
            return "SuspenseList";
        }
        if (typeof y == "object")
          switch (y.$$typeof) {
            case c:
              var P = y;
              return $(P) + ".Consumer";
            case a:
              var V = y;
              return $(V._context) + ".Provider";
            case u:
              return I(y, y.render, "ForwardRef");
            case g:
              return F(y.type);
            case E:
              return F(y._render);
            case O: {
              var H = y, lt = H._payload, ut = H._init;
              try {
                return F(ut(lt));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var z = 0, B, ot, gt, tt, J, ft, Ut;
      function Mt() {
      }
      Mt.__reactDisabledLog = !0;
      function Re() {
        {
          if (z === 0) {
            B = console.log, ot = console.info, gt = console.warn, tt = console.error, J = console.group, ft = console.groupCollapsed, Ut = console.groupEnd;
            var y = {
              configurable: !0,
              enumerable: !0,
              value: Mt,
              writable: !0
            };
            Object.defineProperties(console, {
              info: y,
              log: y,
              warn: y,
              error: y,
              group: y,
              groupCollapsed: y,
              groupEnd: y
            });
          }
          z++;
        }
      }
      function Qt() {
        {
          if (z--, z === 0) {
            var y = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: n({}, y, {
                value: B
              }),
              info: n({}, y, {
                value: ot
              }),
              warn: n({}, y, {
                value: gt
              }),
              error: n({}, y, {
                value: tt
              }),
              group: n({}, y, {
                value: J
              }),
              groupCollapsed: n({}, y, {
                value: ft
              }),
              groupEnd: n({}, y, {
                value: Ut
              })
            });
          }
          z < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var te = C.ReactCurrentDispatcher, St;
      function M(y, P, V) {
        {
          if (St === void 0)
            try {
              throw Error();
            } catch (lt) {
              var H = lt.stack.trim().match(/\n( *(at )?)/);
              St = H && H[1] || "";
            }
          return `
` + St + y;
        }
      }
      var d = !1, m;
      {
        var w = typeof WeakMap == "function" ? WeakMap : Map;
        m = new w();
      }
      function N(y, P) {
        if (!y || d)
          return "";
        {
          var V = m.get(y);
          if (V !== void 0)
            return V;
        }
        var H;
        d = !0;
        var lt = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var ut;
        ut = te.current, te.current = null, Re();
        try {
          if (P) {
            var et = function() {
              throw Error();
            };
            if (Object.defineProperty(et.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(et, []);
              } catch (re) {
                H = re;
              }
              Reflect.construct(y, [], et);
            } else {
              try {
                et.call();
              } catch (re) {
                H = re;
              }
              y.call(et.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (re) {
              H = re;
            }
            y();
          }
        } catch (re) {
          if (re && H && typeof re.stack == "string") {
            for (var Q = re.stack.split(`
`), Dt = H.stack.split(`
`), vt = Q.length - 1, Tt = Dt.length - 1; vt >= 1 && Tt >= 0 && Q[vt] !== Dt[Tt]; )
              Tt--;
            for (; vt >= 1 && Tt >= 0; vt--, Tt--)
              if (Q[vt] !== Dt[Tt]) {
                if (vt !== 1 || Tt !== 1)
                  do
                    if (vt--, Tt--, Tt < 0 || Q[vt] !== Dt[Tt]) {
                      var ne = `
` + Q[vt].replace(" at new ", " at ");
                      return typeof y == "function" && m.set(y, ne), ne;
                    }
                  while (vt >= 1 && Tt >= 0);
                break;
              }
          }
        } finally {
          d = !1, te.current = ut, Qt(), Error.prepareStackTrace = lt;
        }
        var Oe = y ? y.displayName || y.name : "", Ro = Oe ? M(Oe) : "";
        return typeof y == "function" && m.set(y, Ro), Ro;
      }
      function L(y, P, V) {
        return N(y, !1);
      }
      function D(y) {
        var P = y.prototype;
        return !!(P && P.isReactComponent);
      }
      function q(y, P, V) {
        if (y == null)
          return "";
        if (typeof y == "function")
          return N(y, D(y));
        if (typeof y == "string")
          return M(y);
        switch (y) {
          case f:
            return M("Suspense");
          case l:
            return M("SuspenseList");
        }
        if (typeof y == "object")
          switch (y.$$typeof) {
            case u:
              return L(y.render);
            case g:
              return q(y.type, P, V);
            case E:
              return L(y._render);
            case O: {
              var H = y, lt = H._payload, ut = H._init;
              try {
                return q(ut(lt), P, V);
              } catch {
              }
            }
          }
        return "";
      }
      var pt = {}, yt = C.ReactDebugCurrentFrame;
      function kt(y) {
        if (y) {
          var P = y._owner, V = q(y.type, y._source, P ? P.type : null);
          yt.setExtraStackFrame(V);
        } else
          yt.setExtraStackFrame(null);
      }
      function Lt(y, P, V, H, lt) {
        {
          var ut = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var et in y)
            if (ut(y, et)) {
              var Q = void 0;
              try {
                if (typeof y[et] != "function") {
                  var Dt = Error((H || "React class") + ": " + V + " type `" + et + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof y[et] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Dt.name = "Invariant Violation", Dt;
                }
                Q = y[et](P, et, H, V, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (vt) {
                Q = vt;
              }
              Q && !(Q instanceof Error) && (kt(lt), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", H || "React class", V, et, typeof Q), kt(null)), Q instanceof Error && !(Q.message in pt) && (pt[Q.message] = !0, kt(lt), h("Failed %s type: %s", V, Q.message), kt(null));
            }
        }
      }
      var Rt = C.ReactCurrentOwner, _t = Object.prototype.hasOwnProperty, bt = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, ee, nn;
      function Da(y) {
        if (_t.call(y, "ref")) {
          var P = Object.getOwnPropertyDescriptor(y, "ref").get;
          if (P && P.isReactWarning)
            return !1;
        }
        return y.ref !== void 0;
      }
      function Ba(y) {
        if (_t.call(y, "key")) {
          var P = Object.getOwnPropertyDescriptor(y, "key").get;
          if (P && P.isReactWarning)
            return !1;
        }
        return y.key !== void 0;
      }
      function Fa(y, P) {
        typeof y.ref == "string" && Rt.current;
      }
      function Va(y, P) {
        {
          var V = function() {
            ee || (ee = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
          };
          V.isReactWarning = !0, Object.defineProperty(y, "key", {
            get: V,
            configurable: !0
          });
        }
      }
      function $a(y, P) {
        {
          var V = function() {
            nn || (nn = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
          };
          V.isReactWarning = !0, Object.defineProperty(y, "ref", {
            get: V,
            configurable: !0
          });
        }
      }
      var ja = function(y, P, V, H, lt, ut, et) {
        var Q = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: r,
          // Built-in properties that belong on the element
          type: y,
          key: P,
          ref: V,
          props: et,
          // Record the component responsible for creating this element.
          _owner: ut
        };
        return Q._store = {}, Object.defineProperty(Q._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Q, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: H
        }), Object.defineProperty(Q, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: lt
        }), Object.freeze && (Object.freeze(Q.props), Object.freeze(Q)), Q;
      };
      function za(y, P, V, H, lt) {
        {
          var ut, et = {}, Q = null, Dt = null;
          V !== void 0 && (Q = "" + V), Ba(P) && (Q = "" + P.key), Da(P) && (Dt = P.ref, Fa(P, lt));
          for (ut in P)
            _t.call(P, ut) && !bt.hasOwnProperty(ut) && (et[ut] = P[ut]);
          if (y && y.defaultProps) {
            var vt = y.defaultProps;
            for (ut in vt)
              et[ut] === void 0 && (et[ut] = vt[ut]);
          }
          if (Q || Dt) {
            var Tt = typeof y == "function" ? y.displayName || y.name || "Unknown" : y;
            Q && Va(et, Tt), Dt && $a(et, Tt);
          }
          return ja(y, Q, Dt, lt, H, Rt.current, et);
        }
      }
      var ar = C.ReactCurrentOwner, wo = C.ReactDebugCurrentFrame;
      function xe(y) {
        if (y) {
          var P = y._owner, V = q(y.type, y._source, P ? P.type : null);
          wo.setExtraStackFrame(V);
        } else
          wo.setExtraStackFrame(null);
      }
      var cr;
      cr = !1;
      function ur(y) {
        return typeof y == "object" && y !== null && y.$$typeof === r;
      }
      function So() {
        {
          if (ar.current) {
            var y = F(ar.current.type);
            if (y)
              return `

Check the render method of \`` + y + "`.";
          }
          return "";
        }
      }
      function Ga(y) {
        return "";
      }
      var To = {};
      function Ha(y) {
        {
          var P = So();
          if (!P) {
            var V = typeof y == "string" ? y : y.displayName || y.name;
            V && (P = `

Check the top-level render call using <` + V + ">.");
          }
          return P;
        }
      }
      function Co(y, P) {
        {
          if (!y._store || y._store.validated || y.key != null)
            return;
          y._store.validated = !0;
          var V = Ha(P);
          if (To[V])
            return;
          To[V] = !0;
          var H = "";
          y && y._owner && y._owner !== ar.current && (H = " It was passed a child from " + F(y._owner.type) + "."), xe(y), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', V, H), xe(null);
        }
      }
      function Ao(y, P) {
        {
          if (typeof y != "object")
            return;
          if (Array.isArray(y))
            for (var V = 0; V < y.length; V++) {
              var H = y[V];
              ur(H) && Co(H, P);
            }
          else if (ur(y))
            y._store && (y._store.validated = !0);
          else if (y) {
            var lt = b(y);
            if (typeof lt == "function" && lt !== y.entries)
              for (var ut = lt.call(y), et; !(et = ut.next()).done; )
                ur(et.value) && Co(et.value, P);
          }
        }
      }
      function Ka(y) {
        {
          var P = y.type;
          if (P == null || typeof P == "string")
            return;
          var V;
          if (typeof P == "function")
            V = P.propTypes;
          else if (typeof P == "object" && (P.$$typeof === u || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          P.$$typeof === g))
            V = P.propTypes;
          else
            return;
          if (V) {
            var H = F(P);
            Lt(V, y.props, "prop", H, y);
          } else if (P.PropTypes !== void 0 && !cr) {
            cr = !0;
            var lt = F(P);
            h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", lt || "Unknown");
          }
          typeof P.getDefaultProps == "function" && !P.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Ya(y) {
        {
          for (var P = Object.keys(y.props), V = 0; V < P.length; V++) {
            var H = P[V];
            if (H !== "children" && H !== "key") {
              xe(y), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", H), xe(null);
              break;
            }
          }
          y.ref !== null && (xe(y), h("Invalid attribute `ref` supplied to `React.Fragment`."), xe(null));
        }
      }
      function Io(y, P, V, H, lt, ut) {
        {
          var et = S(y);
          if (!et) {
            var Q = "";
            (y === void 0 || typeof y == "object" && y !== null && Object.keys(y).length === 0) && (Q += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Dt = Ga();
            Dt ? Q += Dt : Q += So();
            var vt;
            y === null ? vt = "null" : Array.isArray(y) ? vt = "array" : y !== void 0 && y.$$typeof === r ? (vt = "<" + (F(y.type) || "Unknown") + " />", Q = " Did you accidentally export a JSX literal instead of a component?") : vt = typeof y, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", vt, Q);
          }
          var Tt = za(y, P, V, lt, ut);
          if (Tt == null)
            return Tt;
          if (et) {
            var ne = P.children;
            if (ne !== void 0)
              if (H)
                if (Array.isArray(ne)) {
                  for (var Oe = 0; Oe < ne.length; Oe++)
                    Ao(ne[Oe], y);
                  Object.freeze && Object.freeze(ne);
                } else
                  h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ao(ne, y);
          }
          return y === t.Fragment ? Ya(Tt) : Ka(Tt), Tt;
        }
      }
      function Wa(y, P, V) {
        return Io(y, P, V, !0);
      }
      function qa(y, P, V) {
        return Io(y, P, V, !1);
      }
      var Xa = qa, Ja = Wa;
      t.jsx = Xa, t.jsxs = Ja;
    }();
  }(Pr)), Pr;
}
var Ii;
function jm() {
  return Ii || (Ii = 1, process.env.NODE_ENV === "production" ? Nn.exports = Vm() : Nn.exports = $m()), Nn.exports;
}
var zm = jm();
const Gm = ec(null), Ur = {
  didCatch: !1,
  error: null
};
class Hm extends tc {
  constructor(e) {
    super(e), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = Ur;
  }
  static getDerivedStateFromError(e) {
    return {
      didCatch: !0,
      error: e
    };
  }
  resetErrorBoundary() {
    const {
      error: e
    } = this.state;
    if (e !== null) {
      for (var n, r, o = arguments.length, i = new Array(o), s = 0; s < o; s++)
        i[s] = arguments[s];
      (n = (r = this.props).onReset) === null || n === void 0 || n.call(r, {
        args: i,
        reason: "imperative-api"
      }), this.setState(Ur);
    }
  }
  componentDidCatch(e, n) {
    var r, o;
    (r = (o = this.props).onError) === null || r === void 0 || r.call(o, e, n);
  }
  componentDidUpdate(e, n) {
    const {
      didCatch: r
    } = this.state, {
      resetKeys: o
    } = this.props;
    if (r && n.error !== null && Km(e.resetKeys, o)) {
      var i, s;
      (i = (s = this.props).onReset) === null || i === void 0 || i.call(s, {
        next: o,
        prev: e.resetKeys,
        reason: "keys"
      }), this.setState(Ur);
    }
  }
  render() {
    const {
      children: e,
      fallbackRender: n,
      FallbackComponent: r,
      fallback: o
    } = this.props, {
      didCatch: i,
      error: s
    } = this.state;
    let a = e;
    if (i) {
      const c = {
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof n == "function")
        a = n(c);
      else if (r)
        a = xo(r, c);
      else if (o !== void 0)
        a = o;
      else
        throw s;
    }
    return xo(Gm.Provider, {
      value: {
        didCatch: i,
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, a);
  }
}
function Km() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return t.length !== e.length || t.some((n, r) => !Object.is(n, e[r]));
}
const h_ = ({
  children: t,
  fallback: e = null,
  contextExtras: n = () => ({})
}) => /* @__PURE__ */ zm.jsx(
  Hm,
  {
    fallbackRender: () => e,
    onError: (r, o) => Nm(r, o, n),
    children: t
  }
);
function g_(t, e = {}) {
  const { additionalSensitiveKeys: n = [], slowThresholdMs: r = 2e3 } = e;
  t.interceptors.request.use((o) => (o.headers["x-correlation-id"] = Hr(), o.metadata = {
    startTime: (/* @__PURE__ */ new Date()).getTime(),
    requestBody: o.data
  }, o)), t.interceptors.response.use(
    (o) => {
      var s;
      const i = (/* @__PURE__ */ new Date()).getTime() - (((s = o.config.metadata) == null ? void 0 : s.startTime) || 0);
      return i > r && Wm("Slow request", {
        type: "SLOW_REQUEST",
        status: o.status,
        duration: i,
        url: o.config.url
      }), o;
    },
    (o) => {
      var s, a, c, u, f, l, g, O;
      const i = (/* @__PURE__ */ new Date()).getTime() - (((a = (s = o.config) == null ? void 0 : s.metadata) == null ? void 0 : a.startTime) || 0);
      return qm("HTTP Error", {
        type: "HTTP_ERROR",
        http_status: (c = o.response) == null ? void 0 : c.status,
        url: (u = o.config) == null ? void 0 : u.url,
        method: (f = o.config) == null ? void 0 : f.method,
        duration: i,
        exception: {
          name: o.name,
          message: o.message,
          stack: o.stack
        },
        requestBody: wi(
          (g = (l = o.config) == null ? void 0 : l.metadata) == null ? void 0 : g.requestBody,
          n
        ),
        responseBody: wi(
          (O = o.response) == null ? void 0 : O.data,
          n
        )
      }), Promise.reject(o);
    }
  );
}
let j = null;
const Ym = {
  datadog: Fm
};
let Kr = "anunciar_correlation_id";
function m_(t) {
  if (t.correlationStorageKey && (Kr = t.correlationStorageKey), !t.config || !t.provider)
    throw new Error("[Observability] initObservability: invalid parameters");
  const e = Ym[t.provider];
  j = new e(t.config), j.initialize();
}
const Wm = (t, e) => {
  var n;
  return (n = j == null ? void 0 : j.logInfo) == null ? void 0 : n.call(j, t, e);
}, qm = (t, e) => {
  var n;
  return (n = j == null ? void 0 : j.logError) == null ? void 0 : n.call(j, t, e);
}, Xm = (t, e) => {
  var n;
  return (n = j == null ? void 0 : j.addRumError) == null ? void 0 : n.call(j, t, e);
}, __ = (t) => {
  var e;
  return (e = j == null ? void 0 : j.setUserContext) == null ? void 0 : e.call(j, t);
}, b_ = () => {
  var t;
  return (t = j == null ? void 0 : j.clearUserContext) == null ? void 0 : t.call(j);
}, y_ = (t, e) => {
  var n;
  return (n = j == null ? void 0 : j.setGlobalContextProperty) == null ? void 0 : n.call(j, t, e);
}, v_ = (t) => {
  var e;
  return (e = j == null ? void 0 : j.removeGlobalContextProperty) == null ? void 0 : e.call(j, t);
}, E_ = (t, e) => {
  var n;
  return (n = j == null ? void 0 : j.trackUserAction) == null ? void 0 : n.call(j, t, e);
}, w_ = (t, e) => {
  var n;
  return (n = j == null ? void 0 : j.trackFeatureFlag) == null ? void 0 : n.call(j, t, e);
}, S_ = (t) => {
  var e;
  return (e = j == null ? void 0 : j.trackMultipleFeatureFlags) == null ? void 0 : e.call(j, t);
}, T_ = (t) => {
  var e;
  return (e = j == null ? void 0 : j.trackRouteChange) == null ? void 0 : e.call(j, t);
};
export {
  pn as $,
  mo as A,
  ad as B,
  Ir as C,
  kf as D,
  G as E,
  vo as F,
  Zr as G,
  f_ as H,
  l_ as I,
  d_ as J,
  p_ as K,
  Zu as L,
  Kt as M,
  ct as N,
  At as O,
  cp as P,
  Pt as Q,
  Y as R,
  Sp as S,
  Qe as T,
  Ku as U,
  ie as V,
  Ic as W,
  Ae as X,
  rt as Y,
  xt as Z,
  qt as _,
  a_ as a,
  X as a0,
  Ct as a1,
  Mi as a2,
  yn as a3,
  h_ as a4,
  g_ as a5,
  t_ as a6,
  e_ as a7,
  Qm as a8,
  Kr as a9,
  m_ as aa,
  Wm as ab,
  qm as ac,
  Xm as ad,
  __ as ae,
  b_ as af,
  y_ as ag,
  v_ as ah,
  E_ as ai,
  w_ as aj,
  S_ as ak,
  T_ as al,
  io as b,
  Hf as c,
  n_ as d,
  c_ as e,
  pp as f,
  rp as g,
  s_ as h,
  np as i,
  o_ as j,
  i_ as k,
  da as l,
  Jn as m,
  pe as n,
  se as o,
  pa as p,
  $h as q,
  fp as r,
  hp as s,
  It as t,
  u_ as u,
  mt as v,
  jh as w,
  it as x,
  Jt as y,
  r_ as z
};
